const H = 4007501668557849e-8;
function Gt(a, t) {
  const e = a * 180 / (H / 2), n = Math.atan(Math.exp(t * Math.PI / (H / 2))) * 360 / Math.PI - 90;
  return { lng: e, lat: n };
}
function V(a, t) {
  const e = a * (H / 2) / 180;
  let n = Math.log(Math.tan((90 + t) * Math.PI / 360)) / (Math.PI / 180);
  return n = n * (H / 2) / 180, { x: e, y: n };
}
function ti(a, t, e = 256) {
  const n = H / e * Math.pow(2, -t);
  return a * n;
}
function ei(a, t, e = 256) {
  const n = H / e * Math.pow(2, -t);
  return a / n;
}
function Xt(a) {
  return a.map((t, e) => {
    const n = a[(e - 1 + a.length) % a.length];
    return (n[0] - t[0]) * (n[1] + t[1]);
  }).reduce((t, e) => t + e, 0) >= 0;
}
function Oe(a, t) {
  return t.map((n, i) => {
    const s = t[(i - 1 + t.length) % t.length];
    return n[1] > a[1] != s[1] > a[1] && a[0] < (s[0] - n[0]) * (a[1] - n[1]) / (s[1] - n[1]) + n[0];
  }).reduce((n, i) => i ? !n : n, !1);
}
function ke(a, t) {
  let e = !1, n = !1;
  for (let i = 0; i < t.length && !n; i++) {
    const s = Xt(t[i]);
    Oe(a, t[i]) && (s ? e = !0 : (e = !1, n = !0));
  }
  return e;
}
function ni(a) {
  const t = [];
  for (let e = 0; e < a.length; e++) {
    let n = !0;
    const i = Xt(a[e]);
    for (let s = 0; s < t.length && n; s++)
      Oe(a[e][0], t[s]) && (n = !1);
    t.push(i === n ? a[e] : a[e].reverse());
  }
  return t;
}
function he(a, t) {
  return (1 - Math.log(Math.tan(a * Math.PI / 180) + 1 / Math.cos(a * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, t);
}
function ce(a, t) {
  return (a + 180) / 360 * Math.pow(2, t);
}
function It(a, t) {
  return Math.floor(he(a, t));
}
function Pt(a, t) {
  return Math.floor(ce(a, t));
}
function Be(a, t) {
  const e = Math.PI - 2 * Math.PI * a / Math.pow(2, t);
  return 180 / Math.PI * Math.atan(0.5 * (Math.exp(e) - Math.exp(-e)));
}
function Ae(a, t) {
  return a / Math.pow(2, t) * 360 - 180;
}
function $e(a, t, e) {
  const n = Gt(a, t), i = ce(n.lng, e), s = he(n.lat, e);
  return { x: i, y: s, z: e };
}
function Ce(a, t, e) {
  return {
    x: (a / (1 << e) - 0.5) * H,
    y: (t / (1 << e) - 0.5) * H * -1
  };
}
const on = (a) => {
  let t = 0, e = 0;
  const n = a.length;
  for (let i = n; i > 0; i--) {
    const s = 1 << i - 1;
    switch (a[n - i]) {
      case "0":
        break;
      case "1":
        t |= s;
        break;
      case "2":
        e |= s;
        break;
      case "3":
        t |= s, e |= s;
        break;
      default:
        throw new Error("Invalid QuadKey digit sequence.");
    }
  }
  return { x: t, y: e, z: n };
};
function je(a, t, e) {
  return Array.from({ length: e }, (n, i) => {
    const r = 1 << e - i - 1;
    let o = 0;
    return o += a & r ? 1 : 0, o += t & r ? 2 : 0, o;
  }).join("");
}
function Z(a, t, e) {
  return ((1 << e) * t + a).toString(36) + e.toString(36) + e.toString(36);
}
function Rt(a) {
  const t = parseInt(a.slice(-1), 36), e = parseInt(a.slice(0, -2), 36), n = 1 << t, i = Math.floor(e / n);
  return { x: e % n, y: i, z: t };
}
function rn(a, t) {
  const [e, n, i, s] = a, r = { x: Pt(e, t), y: It(s, t) }, o = { x: Pt(i, t), y: It(n, t) };
  let l = [];
  for (let h = r.y; h <= o.y; h++)
    for (let u = r.x; u <= o.x; u++)
      l.push({ x: u, y: h, z: t });
  return l;
}
function ue(a, t, e, n, i) {
  const s = /* @__PURE__ */ new Set();
  let r = Pt(a, i), o = It(t, i), l = Pt(e, i), h = It(n, i);
  const u = Math.abs(l - r), c = Math.abs(h - o), f = Math.max(u, c), d = (l - r) / f, g = (h - o) / f;
  let p = r, x = o;
  for (let m = 0; m <= f; m++)
    s.add(Z(Math.round(p), Math.round(x), i)), p += d, x += g;
  return Array.from(s).map((m) => Rt(m));
}
function Ge(a, t) {
  const e = /* @__PURE__ */ new Set();
  for (let n = 0; n < a.length - 1; n++) {
    const [i, s] = a[n], [r, o] = a[n + 1];
    ue(i, s, r, o, t).forEach((l) => e.add(Z(l.x, l.y, l.z)));
  }
  return Array.from(e).map((n) => Rt(n));
}
function Xe(a, t) {
  const e = /* @__PURE__ */ new Set(), [n, i] = a[0], [s, r] = a[a.length - 1];
  let o = 1 / 0, l = -1 / 0, h = 1 / 0, u = -1 / 0;
  ue(n, i, s, r, t).forEach((c) => {
    e.add(Z(c.x, c.y, c.z)), o = Math.min(o, c.x), l = Math.max(l, c.x), h = Math.min(h, c.y), u = Math.max(u, c.y);
  });
  for (let c = h; c <= u; c++)
    for (let f = o; f <= l; f++) {
      const d = { x: f, y: c, z: t };
      let g = Ae(d.x + 0.5, d.z), p = Be(d.y + 0.5, d.z);
      ke([g, p], [a]) && e.add(Z(d.x, d.y, d.z));
    }
  return Array.from(e).map((c) => Rt(c));
}
const ii = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  lat2PartialTile: he,
  lat2tile: It,
  lineSegmentToTiles: ue,
  lineStringToTiles: Ge,
  long2PartialTile: ce,
  long2tile: Pt,
  ringToTiles: Xe,
  tile2lat: Be,
  tile2long: Ae,
  tileCoordFromQuadKey: on,
  tileCoordFromTileKey: Rt,
  tileToQuadKey: je,
  tileToTileKey: Z,
  tileTopLeft: Ce,
  tilesInBbox: rn,
  xyzToTile: $e
}, Symbol.toStringTag, { value: "Module" }));
let me = " ";
class y {
  // note Unicode Degree = U+00B0. Prime = U+2032, Double prime = U+2033
  /**
   * Separator character to be used to separate degrees, minutes, seconds, and cardinal directions.
   *
   * Default separator is U+202F ‘narrow no-break space’.
   *
   * To change this (e.g. to empty string or full space), set Dms.separator prior to invoking
   * formatting.
   *
   * @example
   *   import LatLon, { Dms } from '/js/geodesy/latlon-spherical.js';
   *   const p = new LatLon(51.2, 0.33).toString('dms');  // 51° 12′ 00″ N, 000° 19′ 48″ E
   *   Dms.separator = '';                                // no separator
   *   const pʹ = new LatLon(51.2, 0.33).toString('dms'); // 51°12′00″N, 000°19′48″E
   */
  static get separator() {
    return me;
  }
  static set separator(t) {
    me = t;
  }
  /**
   * Parses string representing degrees/minutes/seconds into numeric degrees.
   *
   * This is very flexible on formats, allowing signed decimal degrees, or deg-min-sec optionally
   * suffixed by compass direction (NSEW); a variety of separators are accepted. Examples -3.62,
   * '3 37 12W', '3°37′12″W'.
   *
   * Thousands/decimal separators must be comma/dot; use Dms.fromLocale to convert locale-specific
   * thousands/decimal separators.
   *
   * @param   {string|number} dms - Degrees or deg/min/sec in variety of formats.
   * @returns {number}        Degrees as decimal number.
   *
   * @example
   *   const lat = Dms.parse('51° 28′ 40.37″ N');
   *   const lon = Dms.parse('000° 00′ 05.29″ W');
   *   const p1 = new LatLon(lat, lon); // 51.4779°N, 000.0015°W
   */
  static parse(t) {
    if (!isNaN(parseFloat(t)) && isFinite(t)) return Number(t);
    const e = String(t).trim().replace(/^-/, "").replace(/[NSEW]$/i, "").split(/[^0-9.,]+/);
    if (e[e.length - 1] == "" && e.splice(e.length - 1), e == "") return NaN;
    let n = null;
    switch (e.length) {
      case 3:
        n = e[0] / 1 + e[1] / 60 + e[2] / 3600;
        break;
      case 2:
        n = e[0] / 1 + e[1] / 60;
        break;
      case 1:
        n = e[0];
        break;
      default:
        return NaN;
    }
    return /^-|[WS]$/i.test(t.trim()) && (n = -n), Number(n);
  }
  /**
   * Converts decimal degrees to deg/min/sec format
   *  - degree, prime, double-prime symbols are added, but sign is discarded, though no compass
   *    direction is added.
   *  - degrees are zero-padded to 3 digits; for degrees latitude, use .slice(1) to remove leading
   *    zero.
   *
   * @private
   * @param   {number} deg - Degrees to be formatted as specified.
   * @param   {string} [format=d] - Return value as 'd', 'dm', 'dms' for deg, deg+min, deg+min+sec.
   * @param   {number} [dp=4|2|0] - Number of decimal places to use – default 4 for d, 2 for dm, 0 for dms.
   * @returns {string} Degrees formatted as deg/min/secs according to specified format.
   */
  static toDms(t, e = "d", n = void 0) {
    if (isNaN(t) || typeof t == "string" && t.trim() == "" || typeof t == "boolean" || t == 1 / 0 || t == null) return null;
    if (n === void 0)
      switch (e) {
        case "d":
        case "deg":
          n = 4;
          break;
        case "dm":
        case "deg+min":
          n = 2;
          break;
        case "dms":
        case "deg+min+sec":
          n = 0;
          break;
        default:
          e = "d", n = 4;
          break;
      }
    t = Math.abs(t);
    let i = null, s = null, r = null, o = null;
    switch (e) {
      default:
      // invalid format spec!
      case "d":
      case "deg":
        s = t.toFixed(n), s < 100 && (s = "0" + s), s < 10 && (s = "0" + s), i = s + "°";
        break;
      case "dm":
      case "deg+min":
        s = Math.floor(t), r = (t * 60 % 60).toFixed(n), r == 60 && (r = 0 .toFixed(n), s++), s = ("000" + s).slice(-3), r < 10 && (r = "0" + r), i = s + "°" + y.separator + r + "′";
        break;
      case "dms":
      case "deg+min+sec":
        s = Math.floor(t), r = Math.floor(t * 3600 / 60) % 60, o = (t * 3600 % 60).toFixed(n), o == 60 && (o = 0 .toFixed(n), r++), r == 60 && (r = 0, s++), s = ("000" + s).slice(-3), r = ("00" + r).slice(-2), o < 10 && (o = "0" + o), i = s + "°" + y.separator + r + "′" + y.separator + o + "″";
        break;
    }
    return i;
  }
  /**
   * Converts numeric degrees to deg/min/sec latitude (2-digit degrees, suffixed with N/S).
   *
   * @param   {number} deg - Degrees to be formatted as specified.
   * @param   {string} [format=d] - Return value as 'd', 'dm', 'dms' for deg, deg+min, deg+min+sec.
   * @param   {number} [dp=4|2|0] - Number of decimal places to use – default 4 for d, 2 for dm, 0 for dms.
   * @returns {string} Degrees formatted as deg/min/secs according to specified format.
   *
   * @example
   *   const lat = Dms.toLat(-3.62, 'dms'); // 3°37′12″S
   */
  static toLat(t, e, n) {
    const i = y.toDms(y.wrap90(t), e, n);
    return i === null ? "–" : i.slice(1) + y.separator + (t < 0 ? "S" : "N");
  }
  /**
   * Convert numeric degrees to deg/min/sec longitude (3-digit degrees, suffixed with E/W).
   *
   * @param   {number} deg - Degrees to be formatted as specified.
   * @param   {string} [format=d] - Return value as 'd', 'dm', 'dms' for deg, deg+min, deg+min+sec.
   * @param   {number} [dp=4|2|0] - Number of decimal places to use – default 4 for d, 2 for dm, 0 for dms.
   * @returns {string} Degrees formatted as deg/min/secs according to specified format.
   *
   * @example
   *   const lon = Dms.toLon(-3.62, 'dms'); // 3°37′12″W
   */
  static toLon(t, e, n) {
    const i = y.toDms(y.wrap180(t), e, n);
    return i === null ? "–" : i + y.separator + (t < 0 ? "W" : "E");
  }
  /**
   * Converts numeric degrees to deg/min/sec as a bearing (0°..360°).
   *
   * @param   {number} deg - Degrees to be formatted as specified.
   * @param   {string} [format=d] - Return value as 'd', 'dm', 'dms' for deg, deg+min, deg+min+sec.
   * @param   {number} [dp=4|2|0] - Number of decimal places to use – default 4 for d, 2 for dm, 0 for dms.
   * @returns {string} Degrees formatted as deg/min/secs according to specified format.
   *
   * @example
   *   const lon = Dms.toBrng(-3.62, 'dms'); // 356°22′48″
   */
  static toBrng(t, e, n) {
    const i = y.toDms(y.wrap360(t), e, n);
    return i === null ? "–" : i.replace("360", "0");
  }
  /**
   * Converts DMS string from locale thousands/decimal separators to JavaScript comma/dot separators
   * for subsequent parsing.
   *
   * Both thousands and decimal separators must be followed by a numeric character, to facilitate
   * parsing of single lat/long string (in which whitespace must be left after the comma separator).
   *
   * @param   {string} str - Degrees/minutes/seconds formatted with locale separators.
   * @returns {string} Degrees/minutes/seconds formatted with standard Javascript separators.
   *
   * @example
   *   const lat = Dms.fromLocale('51°28′40,12″N');                          // '51°28′40.12″N' in France
   *   const p = new LatLon(Dms.fromLocale('51°28′40,37″N, 000°00′05,29″W'); // '51.4779°N, 000.0015°W' in France
   */
  static fromLocale(t) {
    const e = 123456.789.toLocaleString(), n = { thousands: e.slice(3, 4), decimal: e.slice(7, 8) };
    return t.replace(n.thousands, "⁜").replace(n.decimal, ".").replace("⁜", ",");
  }
  /**
   * Converts DMS string from JavaScript comma/dot thousands/decimal separators to locale separators.
   *
   * Can also be used to format standard numbers such as distances.
   *
   * @param   {string} str - Degrees/minutes/seconds formatted with standard Javascript separators.
   * @returns {string} Degrees/minutes/seconds formatted with locale separators.
   *
   * @example
   *   const Dms.toLocale('123,456.789');                   // '123.456,789' in France
   *   const Dms.toLocale('51°28′40.12″N, 000°00′05.31″W'); // '51°28′40,12″N, 000°00′05,31″W' in France
   */
  static toLocale(t) {
    const e = 123456.789.toLocaleString(), n = { thousands: e.slice(3, 4), decimal: e.slice(7, 8) };
    return t.replace(/,([0-9])/, "⁜$1").replace(".", n.decimal).replace("⁜", n.thousands);
  }
  /**
   * Returns compass point (to given precision) for supplied bearing.
   *
   * @param   {number} bearing - Bearing in degrees from north.
   * @param   {number} [precision=3] - Precision (1:cardinal / 2:intercardinal / 3:secondary-intercardinal).
   * @returns {string} Compass point for supplied bearing.
   *
   * @example
   *   const point = Dms.compassPoint(24);    // point = 'NNE'
   *   const point = Dms.compassPoint(24, 1); // point = 'N'
   */
  static compassPoint(t, e = 3) {
    if (![1, 2, 3].includes(Number(e))) throw new RangeError(`invalid precision ‘${e}’`);
    t = y.wrap360(t);
    const n = [
      "N",
      "NNE",
      "NE",
      "ENE",
      "E",
      "ESE",
      "SE",
      "SSE",
      "S",
      "SSW",
      "SW",
      "WSW",
      "W",
      "WNW",
      "NW",
      "NNW"
    ], i = 4 * 2 ** (e - 1);
    return n[Math.round(t * i / 360) % i * 16 / i];
  }
  /**
   * Constrain degrees to range -90..+90 (for latitude); e.g. -91 => -89, 91 => 89.
   *
   * @private
   * @param {number} degrees
   * @returns degrees within range -90..+90.
   */
  static wrap90(t) {
    if (-90 <= t && t <= 90) return t;
    const e = t, n = 90, i = 360;
    return 4 * n / i * Math.abs(((e - i / 4) % i + i) % i - i / 2) - n;
  }
  /**
   * Constrain degrees to range -180..+180 (for longitude); e.g. -181 => 179, 181 => -179.
   *
   * @private
   * @param {number} degrees
   * @returns degrees within range -180..+180.
   */
  static wrap180(t) {
    if (-180 <= t && t <= 180) return t;
    const e = t, n = 180, i = 360;
    return ((2 * n * e / i - i / 2) % i + i) % i - n;
  }
  /**
   * Constrain degrees to range 0..360 (for bearings); e.g. -1 => 359, 361 => 1.
   *
   * @private
   * @param {number} degrees
   * @returns degrees within range 0..360.
   */
  static wrap360(t) {
    if (0 <= t && t < 360) return t;
    const e = t, n = 180, i = 360;
    return (2 * n * e / i % i + i) % i;
  }
}
Number.prototype.toRadians = function() {
  return this * Math.PI / 180;
};
Number.prototype.toDegrees = function() {
  return this * 180 / Math.PI;
};
class j {
  /**
   * Creates a 3-d vector.
   *
   * @param {number} x - X component of vector.
   * @param {number} y - Y component of vector.
   * @param {number} z - Z component of vector.
   *
   * @example
   *   import Vector3d from '/js/geodesy/vector3d.js';
   *   const v = new Vector3d(0.267, 0.535, 0.802);
   */
  constructor(t, e, n) {
    if (isNaN(t) || isNaN(e) || isNaN(n)) throw new TypeError(`invalid vector [${t},${e},${n}]`);
    this.x = Number(t), this.y = Number(e), this.z = Number(n);
  }
  /**
   * Length (magnitude or norm) of ‘this’ vector.
   *
   * @returns {number} Magnitude of this vector.
   */
  get length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  /**
   * Adds supplied vector to ‘this’ vector.
   *
   * @param   {Vector3d} v - Vector to be added to this vector.
   * @returns {Vector3d} Vector representing sum of this and v.
   */
  plus(t) {
    if (!(t instanceof j)) throw new TypeError("v is not Vector3d object");
    return new j(this.x + t.x, this.y + t.y, this.z + t.z);
  }
  /**
   * Subtracts supplied vector from ‘this’ vector.
   *
   * @param   {Vector3d} v - Vector to be subtracted from this vector.
   * @returns {Vector3d} Vector representing difference between this and v.
   */
  minus(t) {
    if (!(t instanceof j)) throw new TypeError("v is not Vector3d object");
    return new j(this.x - t.x, this.y - t.y, this.z - t.z);
  }
  /**
   * Multiplies ‘this’ vector by a scalar value.
   *
   * @param   {number}   x - Factor to multiply this vector by.
   * @returns {Vector3d} Vector scaled by x.
   */
  times(t) {
    if (isNaN(t)) throw new TypeError(`invalid scalar value ‘${t}’`);
    return new j(this.x * t, this.y * t, this.z * t);
  }
  /**
   * Divides ‘this’ vector by a scalar value.
   *
   * @param   {number}   x - Factor to divide this vector by.
   * @returns {Vector3d} Vector divided by x.
   */
  dividedBy(t) {
    if (isNaN(t)) throw new TypeError(`invalid scalar value ‘${t}’`);
    return new j(this.x / t, this.y / t, this.z / t);
  }
  /**
   * Multiplies ‘this’ vector by the supplied vector using dot (scalar) product.
   *
   * @param   {Vector3d} v - Vector to be dotted with this vector.
   * @returns {number}   Dot product of ‘this’ and v.
   */
  dot(t) {
    if (!(t instanceof j)) throw new TypeError("v is not Vector3d object");
    return this.x * t.x + this.y * t.y + this.z * t.z;
  }
  /**
   * Multiplies ‘this’ vector by the supplied vector using cross (vector) product.
   *
   * @param   {Vector3d} v - Vector to be crossed with this vector.
   * @returns {Vector3d} Cross product of ‘this’ and v.
   */
  cross(t) {
    if (!(t instanceof j)) throw new TypeError("v is not Vector3d object");
    const e = this.y * t.z - this.z * t.y, n = this.z * t.x - this.x * t.z, i = this.x * t.y - this.y * t.x;
    return new j(e, n, i);
  }
  /**
   * Negates a vector to point in the opposite direction.
   *
   * @returns {Vector3d} Negated vector.
   */
  negate() {
    return new j(-this.x, -this.y, -this.z);
  }
  /**
   * Normalizes a vector to its unit vector
   * – if the vector is already unit or is zero magnitude, this is a no-op.
   *
   * @returns {Vector3d} Normalised version of this vector.
   */
  unit() {
    const t = this.length;
    if (t == 1) return this;
    if (t == 0) return this;
    const e = this.x / t, n = this.y / t, i = this.z / t;
    return new j(e, n, i);
  }
  /**
   * Calculates the angle between ‘this’ vector and supplied vector atan2(|p₁×p₂|, p₁·p₂) (or if
   * (extra-planar) ‘n’ supplied then atan2(n·p₁×p₂, p₁·p₂).
   *
   * @param   {Vector3d} v - Vector whose angle is to be determined from ‘this’ vector.
   * @param   {Vector3d} [n] - Plane normal: if supplied, angle is signed +ve if this->v is
   *                     clockwise looking along n, -ve in opposite direction.
   * @returns {number}   Angle (in radians) between this vector and supplied vector (in range 0..π
   *                     if n not supplied, range -π..+π if n supplied).
   */
  angleTo(t, e = void 0) {
    if (!(t instanceof j)) throw new TypeError("v is not Vector3d object");
    if (!(e instanceof j || e == null)) throw new TypeError("n is not Vector3d object");
    const n = e == null || this.cross(t).dot(e) >= 0 ? 1 : -1, i = this.cross(t).length * n, s = this.dot(t);
    return Math.atan2(i, s);
  }
  /**
   * Rotates ‘this’ point around an axis by a specified angle.
   *
   * @param   {Vector3d} axis - The axis being rotated around.
   * @param   {number}   angle - The angle of rotation (in degrees).
   * @returns {Vector3d} The rotated point.
   */
  rotateAround(t, e) {
    if (!(t instanceof j)) throw new TypeError("axis is not Vector3d object");
    const n = e.toRadians(), i = this.unit(), s = t.unit(), r = Math.sin(n), o = Math.cos(n), l = 1 - o, h = s.x, u = s.y, c = s.z, f = [
      // rotation matrix for rotation about supplied axis
      [l * h * h + o, l * h * u - r * c, l * h * c + r * u],
      [l * h * u + r * c, l * u * u + o, l * u * c - r * h],
      [l * h * c - r * u, l * u * c + r * h, l * c * c + o]
    ], d = [
      f[0][0] * i.x + f[0][1] * i.y + f[0][2] * i.z,
      f[1][0] * i.x + f[1][1] * i.y + f[1][2] * i.z,
      f[2][0] * i.x + f[2][1] * i.y + f[2][2] * i.z
    ];
    return new j(d[0], d[1], d[2]);
  }
  /**
   * String representation of vector.
   *
   * @param   {number} [dp=3] - Number of decimal places to be used.
   * @returns {string} Vector represented as [x,y,z].
   */
  toString(t = 3) {
    return `[${this.x.toFixed(t)},${this.y.toFixed(t)},${this.z.toFixed(t)}]`;
  }
}
Number.prototype.toRadians = function() {
  return this * Math.PI / 180;
};
Number.prototype.toDegrees = function() {
  return this * 180 / Math.PI;
};
const _t = {
  WGS84: { a: 6378137, b: 6356752314245e-6, f: 1 / 298.257223563 }
}, ze = {
  WGS84: { ellipsoid: _t.WGS84 }
};
Object.freeze(_t.WGS84);
Object.freeze(ze.WGS84);
class nt {
  /**
   * Creates a geodetic latitude/longitude point on a (WGS84) ellipsoidal model earth.
   *
   * @param  {number} lat - Latitude (in degrees).
   * @param  {number} lon - Longitude (in degrees).
   * @param  {number} [height=0] - Height above ellipsoid in metres.
   * @throws {TypeError} Invalid lat/lon/height.
   *
   * @example
   *   import LatLon from '/js/geodesy/latlon-ellipsoidal.js';
   *   const p = new LatLon(51.47788, -0.00147, 17);
   */
  constructor(t, e, n = 0) {
    if (isNaN(t) || t == null) throw new TypeError(`invalid lat ‘${t}’`);
    if (isNaN(e) || e == null) throw new TypeError(`invalid lon ‘${e}’`);
    if (isNaN(n) || n == null) throw new TypeError(`invalid height ‘${n}’`);
    this._lat = y.wrap90(Number(t)), this._lon = y.wrap180(Number(e)), this._height = Number(n);
  }
  /**
   * Latitude in degrees north from equator (including aliases lat, latitude): can be set as
   * numeric or hexagesimal (deg-min-sec); returned as numeric.
   */
  get lat() {
    return this._lat;
  }
  get latitude() {
    return this._lat;
  }
  set lat(t) {
    if (this._lat = isNaN(t) ? y.wrap90(y.parse(t)) : y.wrap90(Number(t)), isNaN(this._lat)) throw new TypeError(`invalid lat ‘${t}’`);
  }
  set latitude(t) {
    if (this._lat = isNaN(t) ? y.wrap90(y.parse(t)) : y.wrap90(Number(t)), isNaN(this._lat)) throw new TypeError(`invalid latitude ‘${t}’`);
  }
  /**
   * Longitude in degrees east from international reference meridian (including aliases lon, lng,
   * longitude): can be set as numeric or hexagesimal (deg-min-sec); returned as numeric.
   */
  get lon() {
    return this._lon;
  }
  get lng() {
    return this._lon;
  }
  get longitude() {
    return this._lon;
  }
  set lon(t) {
    if (this._lon = isNaN(t) ? y.wrap180(y.parse(t)) : y.wrap180(Number(t)), isNaN(this._lon)) throw new TypeError(`invalid lon ‘${t}’`);
  }
  set lng(t) {
    if (this._lon = isNaN(t) ? y.wrap180(y.parse(t)) : y.wrap180(Number(t)), isNaN(this._lon)) throw new TypeError(`invalid lng ‘${t}’`);
  }
  set longitude(t) {
    if (this._lon = isNaN(t) ? y.wrap180(y.parse(t)) : y.wrap180(Number(t)), isNaN(this._lon)) throw new TypeError(`invalid longitude ‘${t}’`);
  }
  /**
   * Height in metres above ellipsoid.
   */
  get height() {
    return this._height;
  }
  set height(t) {
    if (this._height = Number(t), isNaN(this._height)) throw new TypeError(`invalid height ‘${t}’`);
  }
  /**
   * Datum.
   *
   * Note this is replicated within LatLonEllipsoidal in order that a LatLonEllipsoidal object can
   * be monkey-patched to look like a LatLonEllipsoidal_Datum, for Vincenty calculations on
   * different ellipsoids.
   *
   * @private
   */
  get datum() {
    return this._datum;
  }
  set datum(t) {
    this._datum = t;
  }
  /**
   * Ellipsoids with their parameters; this module only defines WGS84 parameters a = 6378137, b =
   * 6356752.314245, f = 1/298.257223563.
   *
   * @example
   *   const a = LatLon.ellipsoids.WGS84.a; // 6378137
   */
  static get ellipsoids() {
    return _t;
  }
  /**
   * Datums; this module only defines WGS84 datum, hence no datum transformations.
   *
   * @example
   *   const a = LatLon.datums.WGS84.ellipsoid.a; // 6377563.396
   */
  static get datums() {
    return ze;
  }
  /**
   * Parses a latitude/longitude point from a variety of formats.
   *
   * Latitude & longitude (in degrees) can be supplied as two separate parameters, as a single
   * comma-separated lat/lon string, or as a single object with { lat, lon } or GeoJSON properties.
   *
   * The latitude/longitude values may be numeric or strings; they may be signed decimal or
   * deg-min-sec (hexagesimal) suffixed by compass direction (NSEW); a variety of separators are
   * accepted. Examples -3.62, '3 37 12W', '3°37′12″W'.
   *
   * Thousands/decimal separators must be comma/dot; use Dms.fromLocale to convert locale-specific
   * thousands/decimal separators.
   *
   * @param   {number|string|Object} lat|latlon - Latitude (in degrees), or comma-separated lat/lon, or lat/lon object.
   * @param   {number}               [lon]      - Longitude (in degrees).
   * @param   {number}               [height=0] - Height above ellipsoid in metres.
   * @returns {LatLon} Latitude/longitude point on WGS84 ellipsoidal model earth.
   * @throws  {TypeError} Invalid coordinate.
   *
   * @example
   *   const p1 = LatLon.parse(51.47788, -0.00147);              // numeric pair
   *   const p2 = LatLon.parse('51°28′40″N, 000°00′05″W', 17);   // dms string + height
   *   const p3 = LatLon.parse({ lat: 52.205, lon: 0.119 }, 17); // { lat, lon } object numeric + height
   */
  static parse(...t) {
    if (t.length == 0) throw new TypeError("invalid (empty) point");
    let e, n, i;
    if (typeof t[0] == "object" && (t.length == 1 || !isNaN(parseFloat(t[1])))) {
      const s = t[0];
      if (s.type == "Point" && Array.isArray(s.coordinates) ? ([n, e, i] = s.coordinates, i = i || 0) : (s.latitude != null && (e = s.latitude), s.lat != null && (e = s.lat), s.longitude != null && (n = s.longitude), s.lng != null && (n = s.lng), s.lon != null && (n = s.lon), s.height != null && (i = s.height), e = y.wrap90(y.parse(e)), n = y.wrap180(y.parse(n))), t[1] != null && (i = t[1]), isNaN(e) || isNaN(n)) throw new TypeError(`invalid point ‘${JSON.stringify(t[0])}’`);
    }
    if (typeof t[0] == "string" && t[0].split(",").length == 2 && ([e, n] = t[0].split(","), e = y.wrap90(y.parse(e)), n = y.wrap180(y.parse(n)), i = t[1] || 0, isNaN(e) || isNaN(n)))
      throw new TypeError(`invalid point ‘${t[0]}’`);
    if (e == null && n == null && ([e, n] = t, e = y.wrap90(y.parse(e)), n = y.wrap180(y.parse(n)), i = t[2] || 0, isNaN(e) || isNaN(n)))
      throw new TypeError(`invalid point ‘${t.toString()}’`);
    return new this(e, n, i);
  }
  /**
   * Converts ‘this’ point from (geodetic) latitude/longitude coordinates to (geocentric)
   * cartesian (x/y/z) coordinates.
   *
   * @returns {Cartesian} Cartesian point equivalent to lat/lon point, with x, y, z in metres from
   *   earth centre.
   */
  toCartesian() {
    const t = this.datum ? this.datum.ellipsoid : this.referenceFrame ? this.referenceFrame.ellipsoid : _t.WGS84, e = this.lat.toRadians(), n = this.lon.toRadians(), i = this.height, { a: s, f: r } = t, o = Math.sin(e), l = Math.cos(e), h = Math.sin(n), u = Math.cos(n), c = 2 * r - r * r, f = s / Math.sqrt(1 - c * o * o), d = (f + i) * l * u, g = (f + i) * l * h, p = (f * (1 - c) + i) * o;
    return new Ye(d, g, p);
  }
  /**
   * Checks if another point is equal to ‘this’ point.
   *
   * @param   {LatLon} point - Point to be compared against this point.
   * @returns {bool} True if points have identical latitude, longitude, height, and datum/referenceFrame.
   * @throws  {TypeError} Invalid point.
   *
   * @example
   *   const p1 = new LatLon(52.205, 0.119);
   *   const p2 = new LatLon(52.205, 0.119);
   *   const equal = p1.equals(p2); // true
   */
  equals(t) {
    if (!(t instanceof nt)) throw new TypeError(`invalid point ‘${t}’`);
    return !(Math.abs(this.lat - t.lat) > Number.EPSILON || Math.abs(this.lon - t.lon) > Number.EPSILON || Math.abs(this.height - t.height) > Number.EPSILON || this.datum != t.datum || this.referenceFrame != t.referenceFrame || this.epoch != t.epoch);
  }
  /**
   * Returns a string representation of ‘this’ point, formatted as degrees, degrees+minutes, or
   * degrees+minutes+seconds.
   *
   * @param   {string} [format=d] - Format point as 'd', 'dm', 'dms', or 'n' for signed numeric.
   * @param   {number} [dp=4|2|0] - Number of decimal places to use: default 4 for d, 2 for dm, 0 for dms.
   * @param   {number} [dpHeight=null] - Number of decimal places to use for height; default is no height display.
   * @returns {string} Comma-separated formatted latitude/longitude.
   * @throws  {RangeError} Invalid format.
   *
   * @example
   *   const greenwich = new LatLon(51.47788, -0.00147, 46);
   *   const d = greenwich.toString();                        // 51.4779°N, 000.0015°W
   *   const dms = greenwich.toString('dms', 2);              // 51°28′40″N, 000°00′05″W
   *   const [lat, lon] = greenwich.toString('n').split(','); // 51.4779, -0.0015
   *   const dmsh = greenwich.toString('dms', 0, 0);          // 51°28′40″N, 000°00′06″W +46m
   */
  toString(t = "d", e = void 0, n = null) {
    if (!["d", "dm", "dms", "n"].includes(t)) throw new RangeError(`invalid format ‘${t}’`);
    const i = (this.height >= 0 ? " +" : " ") + this.height.toFixed(n) + "m";
    if (t == "n") {
      e == null && (e = 4);
      const o = this.lat.toFixed(e), l = this.lon.toFixed(e);
      return `${o}, ${l}${n == null ? "" : i}`;
    }
    const s = y.toLat(this.lat, t, e), r = y.toLon(this.lon, t, e);
    return `${s}, ${r}${n == null ? "" : i}`;
  }
}
class Ye extends j {
  /**
   * Creates cartesian coordinate representing ECEF (earth-centric earth-fixed) point.
   *
   * @param {number} x - X coordinate in metres (=> 0°N,0°E).
   * @param {number} y - Y coordinate in metres (=> 0°N,90°E).
   * @param {number} z - Z coordinate in metres (=> 90°N).
   *
   * @example
   *   import { Cartesian } from '/js/geodesy/latlon-ellipsoidal.js';
   *   const coord = new Cartesian(3980581.210, -111.159, 4966824.522);
   */
  constructor(t, e, n) {
    super(t, e, n);
  }
  /**
   * Converts ‘this’ (geocentric) cartesian (x/y/z) coordinate to (geodetic) latitude/longitude
   * point on specified ellipsoid.
   *
   * Uses Bowring’s (1985) formulation for μm precision in concise form; ‘The accuracy of geodetic
   * latitude and height equations’, B R Bowring, Survey Review vol 28, 218, Oct 1985.
   *
   * @param   {LatLon.ellipsoids} [ellipsoid=WGS84] - Ellipsoid to use when converting point.
   * @returns {LatLon} Latitude/longitude point defined by cartesian coordinates, on given ellipsoid.
   * @throws  {TypeError} Invalid ellipsoid.
   *
   * @example
   *   const c = new Cartesian(4027893.924, 307041.993, 4919474.294);
   *   const p = c.toLatLon(); // 50.7978°N, 004.3592°E
   */
  toLatLon(t = _t.WGS84) {
    if (!t || !t.a) throw new TypeError(`invalid ellipsoid ‘${t}’`);
    const { x: e, y: n, z: i } = this, { a: s, b: r, f: o } = t, l = 2 * o - o * o, h = l / (1 - l), u = Math.sqrt(e * e + n * n), c = Math.sqrt(u * u + i * i), f = r * i / (s * u) * (1 + h * r / c), d = f / Math.sqrt(1 + f * f), g = d / f, p = isNaN(g) ? 0 : Math.atan2(i + h * r * d * d * d, u - l * s * g * g * g), x = Math.atan2(n, e), m = Math.sin(p), M = Math.cos(p), w = s / Math.sqrt(1 - l * m * m), N = u * M + i * m - s * s / w;
    return new nt(p.toDegrees(), x.toDegrees(), N);
  }
  /**
   * Returns a string representation of ‘this’ cartesian point.
   *
   * @param   {number} [dp=0] - Number of decimal places to use.
   * @returns {string} Comma-separated latitude/longitude.
   */
  toString(t = 0) {
    const e = this.x.toFixed(t), n = this.y.toFixed(t), i = this.z.toFixed(t);
    return `[${e},${n},${i}]`;
  }
}
const z = {
  WGS84: { a: 6378137, b: 6356752314245e-6, f: 1 / 298.257223563 },
  Airy1830: { a: 6377563396e-3, b: 6356256909e-3, f: 1 / 299.3249646 },
  AiryModified: { a: 6377340189e-3, b: 6356034448e-3, f: 1 / 299.3249646 },
  Bessel1841: { a: 6377397155e-3, b: 6356078962818e-6, f: 1 / 299.1528128 },
  Clarke1866: { a: 63782064e-1, b: 63565838e-1, f: 1 / 294.978698214 },
  Clarke1880IGN: { a: 63782492e-1, b: 6356515, f: 1 / 293.466021294 },
  GRS80: { a: 6378137, b: 635675231414e-5, f: 1 / 298.257222101 },
  Intl1924: { a: 6378388, b: 6356911946e-3, f: 1 / 297 },
  // aka Hayford
  WGS72: { a: 6378135, b: 63567505e-1, f: 1 / 298.26 }
}, W = {
  // transforms: t in metres, s in ppm, r in arcseconds              tx       ty        tz       s        rx        ry        rz
  ED50: { ellipsoid: z.Intl1924, transform: [89.5, 93.8, 123.1, -1.2, 0, 0, 0.156] },
  // epsg.io/1311
  ETRS89: { ellipsoid: z.GRS80, transform: [0, 0, 0, 0, 0, 0, 0] },
  // epsg.io/1149; @ 1-metre level
  Irl1975: { ellipsoid: z.AiryModified, transform: [-482.53, 130.596, -564.557, -8.15, 1.042, 0.214, 0.631] },
  // epsg.io/1954
  NAD27: { ellipsoid: z.Clarke1866, transform: [8, -160, -176, 0, 0, 0, 0] },
  NAD83: { ellipsoid: z.GRS80, transform: [0.9956, -1.9103, -0.5215, -62e-5, 0.025915, 9426e-6, 0.011599] },
  NTF: { ellipsoid: z.Clarke1880IGN, transform: [168, 60, -320, 0, 0, 0, 0] },
  OSGB36: { ellipsoid: z.Airy1830, transform: [-446.448, 125.157, -542.06, 20.4894, -0.1502, -0.247, -0.8421] },
  // epsg.io/1314
  Potsdam: { ellipsoid: z.Bessel1841, transform: [-582, -105, -414, -8.3, 1.04, 0.35, -3.08] },
  TokyoJapan: { ellipsoid: z.Bessel1841, transform: [148, -507, -685, 0, 0, 0, 0] },
  WGS72: { ellipsoid: z.WGS72, transform: [0, 0, -4.5, -0.22, 0, 0, 0.554] },
  WGS84: { ellipsoid: z.WGS84, transform: [0, 0, 0, 0, 0, 0, 0] }
};
Object.keys(z).forEach((a) => Object.freeze(z[a]));
Object.keys(W).forEach((a) => {
  Object.freeze(W[a]), Object.freeze(W[a].transform);
});
class pt extends nt {
  /**
   * Creates a geodetic latitude/longitude point on an ellipsoidal model earth using given datum.
   *
   * @param {number} lat - Latitude (in degrees).
   * @param {number} lon - Longitude (in degrees).
   * @param {number} [height=0] - Height above ellipsoid in metres.
   * @param {LatLon.datums} datum - Datum this point is defined within.
   *
   * @example
   *   import LatLon from '/js/geodesy/latlon-ellipsoidal-datum.js';
   *   const p = new LatLon(53.3444, -6.2577, 17, LatLon.datums.Irl1975);
   */
  constructor(t, e, n = 0, i = W.WGS84) {
    if (!i || i.ellipsoid == null) throw new TypeError(`unrecognised datum ‘${i}’`);
    super(t, e, n), this._datum = i;
  }
  /**
   * Datum this point is defined within.
   */
  get datum() {
    return this._datum;
  }
  /**
   * Ellipsoids with their parameters; semi-major axis (a), semi-minor axis (b), and flattening (f).
   *
   * Flattening f = (a−b)/a; at least one of these parameters is derived from defining constants.
   *
   * @example
   *   const a = LatLon.ellipsoids.Airy1830.a; // 6377563.396
   */
  static get ellipsoids() {
    return z;
  }
  /**
   * Datums; with associated ellipsoid, and Helmert transform parameters to convert from WGS-84
   * into given datum.
   *
   * Note that precision of various datums will vary, and WGS-84 (original) is not defined to be
   * accurate to better than ±1 metre. No transformation should be assumed to be accurate to
   * better than a metre, for many datums somewhat less.
   *
   * This is a small sample of commoner datums from a large set of historical datums. I will add
   * new datums on request.
   *
   * @example
   *   const a = LatLon.datums.OSGB36.ellipsoid.a;                    // 6377563.396
   *   const tx = LatLon.datums.OSGB36.transform;                     // [ tx, ty, tz, s, rx, ry, rz ]
   *   const availableDatums = Object.keys(LatLon.datums).join(', '); // ED50, Irl1975, NAD27, ...
   */
  static get datums() {
    return W;
  }
  // note instance datum getter/setters are in LatLonEllipsoidal
  /**
   * Parses a latitude/longitude point from a variety of formats.
   *
   * Latitude & longitude (in degrees) can be supplied as two separate parameters, as a single
   * comma-separated lat/lon string, or as a single object with { lat, lon } or GeoJSON properties.
   *
   * The latitude/longitude values may be numeric or strings; they may be signed decimal or
   * deg-min-sec (hexagesimal) suffixed by compass direction (NSEW); a variety of separators are
   * accepted. Examples -3.62, '3 37 12W', '3°37′12″W'.
   *
   * Thousands/decimal separators must be comma/dot; use Dms.fromLocale to convert locale-specific
   * thousands/decimal separators.
   *
   * @param   {number|string|Object} lat|latlon - Geodetic Latitude (in degrees) or comma-separated lat/lon or lat/lon object.
   * @param   {number}               [lon] - Longitude in degrees.
   * @param   {number}               [height=0] - Height above ellipsoid in metres.
   * @param   {LatLon.datums}        [datum=WGS84] - Datum this point is defined within.
   * @returns {LatLon} Latitude/longitude point on ellipsoidal model earth using given datum.
   * @throws  {TypeError} Unrecognised datum.
   *
   * @example
   *   const p = LatLon.parse('51.47736, 0.0000', 0, LatLon.datums.OSGB36);
   */
  static parse(...t) {
    let e = W.WGS84;
    if ((t.length == 4 || t.length == 3 && typeof t[2] == "object") && (e = t.pop()), !e || e.ellipsoid == null) throw new TypeError(`unrecognised datum ‘${e}’`);
    const n = super.parse(...t);
    return n._datum = e, n;
  }
  /**
   * Converts ‘this’ lat/lon coordinate to new coordinate system.
   *
   * @param   {LatLon.datums} toDatum - Datum this coordinate is to be converted to.
   * @returns {LatLon} This point converted to new datum.
   * @throws  {TypeError} Unrecognised datum.
   *
   * @example
   *   const pWGS84 = new LatLon(51.47788, -0.00147, 0, LatLon.datums.WGS84);
   *   const pOSGB = pWGS84.convertDatum(LatLon.datums.OSGB36); // 51.4773°N, 000.0001°E
   */
  convertDatum(t) {
    if (!t || t.ellipsoid == null) throw new TypeError(`unrecognised datum ‘${t}’`);
    return this.toCartesian().convertDatum(t).toLatLon();
  }
  /**
   * Converts ‘this’ point from (geodetic) latitude/longitude coordinates to (geocentric) cartesian
   * (x/y/z) coordinates, based on the same datum.
   *
   * Shadow of LatLonEllipsoidal.toCartesian(), returning Cartesian augmented with
   * LatLonEllipsoidal_Datum methods/properties.
   *
   * @returns {Cartesian} Cartesian point equivalent to lat/lon point, with x, y, z in metres from
   *   earth centre, augmented with reference frame conversion methods and properties.
   */
  toCartesian() {
    const t = super.toCartesian();
    return new fe(t.x, t.y, t.z, this.datum);
  }
}
class fe extends Ye {
  /**
   * Creates cartesian coordinate representing ECEF (earth-centric earth-fixed) point, on a given
   * datum. The datum will identify the primary meridian (for the x-coordinate), and is also
   * useful in transforming to/from geodetic (lat/lon) coordinates.
   *
   * @param  {number} x - X coordinate in metres (=> 0°N,0°E).
   * @param  {number} y - Y coordinate in metres (=> 0°N,90°E).
   * @param  {number} z - Z coordinate in metres (=> 90°N).
   * @param  {LatLon.datums} [datum] - Datum this coordinate is defined within.
   * @throws {TypeError} Unrecognised datum.
   *
   * @example
   *   import { Cartesian } from '/js/geodesy/latlon-ellipsoidal-datum.js';
   *   const coord = new Cartesian(3980581.210, -111.159, 4966824.522);
   */
  constructor(t, e, n, i = void 0) {
    if (i && i.ellipsoid == null) throw new TypeError(`unrecognised datum ‘${i}’`);
    super(t, e, n), i && (this._datum = i);
  }
  /**
   * Datum this point is defined within.
   */
  get datum() {
    return this._datum;
  }
  set datum(t) {
    if (!t || t.ellipsoid == null) throw new TypeError(`unrecognised datum ‘${t}’`);
    this._datum = t;
  }
  /**
   * Converts ‘this’ (geocentric) cartesian (x/y/z) coordinate to (geodetic) latitude/longitude
   * point (based on the same datum, or WGS84 if unset).
   *
   * Shadow of Cartesian.toLatLon(), returning LatLon augmented with LatLonEllipsoidal_Datum
   * methods convertDatum, toCartesian, etc.
   *
   * @returns {LatLon} Latitude/longitude point defined by cartesian coordinates.
   * @throws  {TypeError} Unrecognised datum
   *
   * @example
   *   const c = new Cartesian(4027893.924, 307041.993, 4919474.294);
   *   const p = c.toLatLon(); // 50.7978°N, 004.3592°E
   */
  toLatLon(t = void 0) {
    t && (console.info("datum parameter to Cartesian_Datum.toLatLon is deprecated: set datum before calling toLatLon()"), this.datum = t);
    const e = this.datum || W.WGS84;
    if (!e || e.ellipsoid == null) throw new TypeError(`unrecognised datum ‘${e}’`);
    const n = super.toLatLon(e.ellipsoid);
    return new pt(n.lat, n.lon, n.height, this.datum);
  }
  /**
   * Converts ‘this’ cartesian coordinate to new datum using Helmert 7-parameter transformation.
   *
   * @param   {LatLon.datums} toDatum - Datum this coordinate is to be converted to.
   * @returns {Cartesian} This point converted to new datum.
   * @throws  {Error} Undefined datum.
   *
   * @example
   *   const c = new Cartesian(3980574.247, -102.127, 4966830.065, LatLon.datums.OSGB36);
   *   c.convertDatum(LatLon.datums.Irl1975); // [??,??,??]
   */
  convertDatum(t) {
    if (!t || t.ellipsoid == null) throw new TypeError(`unrecognised datum ‘${t}’`);
    if (!this.datum) throw new TypeError("cartesian coordinate has no datum");
    let e = null, n = null;
    (this.datum == null || this.datum == W.WGS84) && (e = this, n = t.transform), t == W.WGS84 && (e = this, n = this.datum.transform.map((s) => -s)), n == null && (e = this.convertDatum(W.WGS84), n = t.transform);
    const i = e.applyTransform(n);
    return i.datum = t, i;
  }
  /**
   * Applies Helmert 7-parameter transformation to ‘this’ coordinate using transform parameters t.
   *
   * This is used in converting datums (geodetic->cartesian, apply transform, cartesian->geodetic).
   *
   * @private
   * @param   {number[]} t - Transformation to apply to this coordinate.
   * @returns {Cartesian} Transformed point.
   */
  applyTransform(t) {
    const { x: e, y: n, z: i } = this, s = t[0], r = t[1], o = t[2], l = t[3] / 1e6 + 1, h = (t[4] / 3600).toRadians(), u = (t[5] / 3600).toRadians(), c = (t[6] / 3600).toRadians(), f = s + e * l - n * c + i * u, d = r + e * c + n * l - i * h, g = o - e * u + n * h + i * l;
    return new fe(f, d, g);
  }
}
class We {
  /**
   * Creates a Utm coordinate object comprising zone, hemisphere, easting, northing on a given
   * datum (normally WGS84).
   *
   * @param  {number}        zone - UTM 6° longitudinal zone (1..60 covering 180°W..180°E).
   * @param  {string}        hemisphere - N for northern hemisphere, S for southern hemisphere.
   * @param  {number}        easting - Easting in metres from false easting (-500km from central meridian).
   * @param  {number}        northing - Northing in metres from equator (N) or from false northing -10,000km (S).
   * @param  {LatLon.datums} [datum=WGS84] - Datum UTM coordinate is based on.
   * @param  {number}        [convergence=null] - Meridian convergence (bearing of grid north
   *                         clockwise from true north), in degrees.
   * @param  {number}        [scale=null] - Grid scale factor.
   * @params {boolean=true}  verifyEN - Check easting/northing is within 'normal' values (may be
   *                         suppressed for extended coherent coordinates or alternative datums
   *                         e.g. ED50 (epsg.io/23029).
   * @throws {TypeError} Invalid UTM coordinate.
   *
   * @example
   *   import Utm from '/js/geodesy/utm.js';
   *   const utmCoord = new Utm(31, 'N', 448251, 5411932);
   */
  constructor(t, e, n, i, s = pt.datums.WGS84, r = null, o = null, l = !0) {
    if (!(1 <= t && t <= 60)) throw new RangeError(`invalid UTM zone ‘${t}’`);
    if (t != parseInt(t)) throw new RangeError(`invalid UTM zone ‘${t}’`);
    if (typeof e != "string" || !e.match(/[NS]/i)) throw new RangeError(`invalid UTM hemisphere ‘${e}’`);
    if (l) {
      if (!(0 <= n && n <= 1e6)) throw new RangeError(`invalid UTM easting ‘${n}’`);
      if (e.toUpperCase() == "N" && !(0 <= i && i < 9328094)) throw new RangeError(`invalid UTM northing ‘${i}’`);
      if (e.toUpperCase() == "S" && !(1118414 < i && i <= 1e7)) throw new RangeError(`invalid UTM northing ‘${i}’`);
    }
    if (!s || s.ellipsoid == null) throw new TypeError(`unrecognised datum ‘${s}’`);
    this.zone = Number(t), this.hemisphere = e.toUpperCase(), this.easting = Number(n), this.northing = Number(i), this.datum = s, this.convergence = r === null ? null : Number(r), this.scale = o === null ? null : Number(o);
  }
  /**
   * Converts UTM zone/easting/northing coordinate to latitude/longitude.
   *
   * Implements Karney’s method, using Krüger series to order n⁶, giving results accurate to 5nm
   * for distances up to 3900km from the central meridian.
   *
   * @param   {Utm} utmCoord - UTM coordinate to be converted to latitude/longitude.
   * @returns {LatLon} Latitude/longitude of supplied grid reference.
   *
   * @example
   *   const grid = new Utm(31, 'N', 448251.795, 5411932.678);
   *   const latlong = grid.toLatLon(); // 48°51′29.52″N, 002°17′40.20″E
   */
  toLatLon() {
    const { zone: t, hemisphere: e } = this, n = 5e5, i = 1e7, { a: s, f: r } = this.datum.ellipsoid, o = 0.9996, l = this.easting - n, h = e == "S" ? this.northing - i : this.northing, u = Math.sqrt(r * (2 - r)), c = r / (2 - r), f = c * c, d = c * f, g = c * d, p = c * g, x = c * p, m = s / (1 + c) * (1 + 1 / 4 * f + 1 / 64 * g + 1 / 256 * x), M = l / (o * m), w = h / (o * m), N = [
      null,
      // note β is one-based array (6th order Krüger expressions)
      1 / 2 * c - 2 / 3 * f + 37 / 96 * d - 1 / 360 * g - 81 / 512 * p + 96199 / 604800 * x,
      1 / 48 * f + 1 / 15 * d - 437 / 1440 * g + 46 / 105 * p - 1118711 / 3870720 * x,
      17 / 480 * d - 37 / 840 * g - 209 / 4480 * p + 5569 / 90720 * x,
      4397 / 161280 * g - 11 / 504 * p - 830251 / 7257600 * x,
      4583 / 161280 * p - 108847 / 3991680 * x,
      20648693 / 638668800 * x
    ];
    let E = w;
    for (let b = 1; b <= 6; b++) E -= N[b] * Math.sin(2 * b * w) * Math.cosh(2 * b * M);
    let P = M;
    for (let b = 1; b <= 6; b++) P -= N[b] * Math.cos(2 * b * w) * Math.sinh(2 * b * M);
    const T = Math.sinh(P), v = Math.sin(E), _ = Math.cos(E), L = v / Math.sqrt(T * T + _ * _);
    let R = null, S = L;
    do {
      const b = Math.sinh(u * Math.atanh(u * S / Math.sqrt(1 + S * S))), Jt = S * Math.sqrt(1 + b * b) - b * Math.sqrt(1 + S * S);
      R = (L - Jt) / Math.sqrt(1 + Jt * Jt) * (1 + (1 - u * u) * S * S) / ((1 - u * u) * Math.sqrt(1 + S * S)), S += R;
    } while (Math.abs(R) > 1e-12);
    const O = S, A = Math.atan(O);
    let k = Math.atan2(T, _), Y = 1;
    for (let b = 1; b <= 6; b++) Y -= 2 * b * N[b] * Math.cos(2 * b * w) * Math.cosh(2 * b * M);
    let $ = 0;
    for (let b = 1; b <= 6; b++) $ += 2 * b * N[b] * Math.sin(2 * b * w) * Math.sinh(2 * b * M);
    const q = Math.atan(Math.tan(E) * Math.tanh(P)), D = Math.atan2($, Y), Q = q + D, lt = Math.sin(A), rt = Math.sqrt(1 - u * u * lt * lt) * Math.sqrt(1 + O * O) * Math.sqrt(T * T + _ * _), at = m / s / Math.sqrt(Y * Y + $ * $), xt = o * rt * at, Yt = ((t - 1) * 6 - 180 + 3).toRadians();
    k += Yt;
    const Wt = Number(A.toDegrees().toFixed(14)), qt = Number(k.toDegrees().toFixed(14)), Ut = Number(Q.toDegrees().toFixed(9)), Dt = Number(xt.toFixed(12)), Mt = new qe(Wt, qt, 0, this.datum);
    return Mt.convergence = Ut, Mt.scale = Dt, Mt;
  }
  /**
   * Parses string representation of UTM coordinate.
   *
   * A UTM coordinate comprises (space-separated)
   *  - zone
   *  - hemisphere
   *  - easting
   *  - northing.
   *
   * @param   {string} utmCoord - UTM coordinate (WGS 84).
   * @param   {Datum}  [datum=WGS84] - Datum coordinate is defined in (default WGS 84).
   * @returns {Utm} Parsed UTM coordinate.
   * @throws  {TypeError} Invalid UTM coordinate.
   *
   * @example
   *   const utmCoord = Utm.parse('31 N 448251 5411932');
   *   // utmCoord: {zone: 31, hemisphere: 'N', easting: 448251, northing: 5411932 }
   */
  static parse(t, e = pt.datums.WGS84) {
    if (t = t.trim().match(/\S+/g), t == null || t.length != 4) throw new Error(`invalid UTM coordinate ‘${t}’`);
    const n = t[0], i = t[1], s = t[2], r = t[3];
    return new this(n, i, s, r, e);
  }
  /**
   * Returns a string representation of a UTM coordinate.
   *
   * To distinguish from MGRS grid zone designators, a space is left between the zone and the
   * hemisphere.
   *
   * Note that UTM coordinates get rounded, not truncated (unlike MGRS grid references).
   *
   * @param   {number} [digits=0] - Number of digits to appear after the decimal point (3 ≡ mm).
   * @returns {string} A string representation of the coordinate.
   *
   * @example
   *   const utm = new Utm('31', 'N', 448251, 5411932).toString(4);  // 31 N 448251.0000 5411932.0000
   */
  toString(t = 0) {
    const e = this.zone.toString().padStart(2, "0"), n = this.hemisphere, i = this.easting.toFixed(t), s = this.northing.toFixed(t);
    return `${e} ${n} ${i} ${s}`;
  }
}
class qe extends pt {
  /**
   * Converts latitude/longitude to UTM coordinate.
   *
   * Implements Karney’s method, using Krüger series to order n⁶, giving results accurate to 5nm
   * for distances up to 3900km from the central meridian.
   *
   * @param   {number} [zoneOverride] - Use specified zone rather than zone within which point lies;
   *          note overriding the UTM zone has the potential to result in negative eastings, and
   *          perverse results within Norway/Svalbard exceptions.
   * @returns {Utm} UTM coordinate.
   * @throws  {TypeError} Latitude outside UTM limits.
   *
   * @example
   *   const latlong = new LatLon(48.8582, 2.2945);
   *   const utmCoord = latlong.toUtm(); // 31 N 448252 5411933
   */
  toUtm(t = void 0) {
    if (!(-80 <= this.lat && this.lat <= 84)) throw new RangeError(`latitude ‘${this.lat}’ outside UTM limits`);
    const e = 5e5, n = 1e7;
    let i = t || Math.floor((this.lon + 180) / 6) + 1, s = ((i - 1) * 6 - 180 + 3).toRadians();
    const o = "CDEFGHJKLMNPQRSTUVWXX".charAt(Math.floor(this.lat / 8 + 10));
    i == 31 && o == "V" && this.lon >= 3 && (i++, s += 6 .toRadians()), i == 32 && o == "X" && this.lon < 9 && (i--, s -= 6 .toRadians()), i == 32 && o == "X" && this.lon >= 9 && (i++, s += 6 .toRadians()), i == 34 && o == "X" && this.lon < 21 && (i--, s -= 6 .toRadians()), i == 34 && o == "X" && this.lon >= 21 && (i++, s += 6 .toRadians()), i == 36 && o == "X" && this.lon < 33 && (i--, s -= 6 .toRadians()), i == 36 && o == "X" && this.lon >= 33 && (i++, s += 6 .toRadians());
    const l = this.lat.toRadians(), h = this.lon.toRadians() - s, u = this.datum ? this.datum.ellipsoid : pt.ellipsoids.WGS84, { a: c, f } = u, d = 0.9996, g = Math.sqrt(f * (2 - f)), p = f / (2 - f), x = p * p, m = p * x, M = p * m, w = p * M, N = p * w, E = Math.cos(h), P = Math.sin(h), T = Math.tan(h), v = Math.tan(l), _ = Math.sinh(g * Math.atanh(g * v / Math.sqrt(1 + v * v))), L = v * Math.sqrt(1 + _ * _) - _ * Math.sqrt(1 + v * v), R = Math.atan2(L, E), S = Math.asinh(P / Math.sqrt(L * L + E * E)), O = c / (1 + p) * (1 + 1 / 4 * x + 1 / 64 * M + 1 / 256 * N), A = [
      null,
      // note α is one-based array (6th order Krüger expressions)
      1 / 2 * p - 2 / 3 * x + 5 / 16 * m + 41 / 180 * M - 127 / 288 * w + 7891 / 37800 * N,
      13 / 48 * x - 3 / 5 * m + 557 / 1440 * M + 281 / 630 * w - 1983433 / 1935360 * N,
      61 / 240 * m - 103 / 140 * M + 15061 / 26880 * w + 167603 / 181440 * N,
      49561 / 161280 * M - 179 / 168 * w + 6601661 / 7257600 * N,
      34729 / 80640 * w - 3418889 / 1995840 * N,
      212378941 / 319334400 * N
    ];
    let k = R;
    for (let b = 1; b <= 6; b++) k += A[b] * Math.sin(2 * b * R) * Math.cosh(2 * b * S);
    let Y = S;
    for (let b = 1; b <= 6; b++) Y += A[b] * Math.cos(2 * b * R) * Math.sinh(2 * b * S);
    let $ = d * O * Y, q = d * O * k, D = 1;
    for (let b = 1; b <= 6; b++) D += 2 * b * A[b] * Math.cos(2 * b * R) * Math.cosh(2 * b * S);
    let Q = 0;
    for (let b = 1; b <= 6; b++) Q += 2 * b * A[b] * Math.sin(2 * b * R) * Math.sinh(2 * b * S);
    const lt = Math.atan(L / Math.sqrt(1 + L * L) * T), rt = Math.atan2(Q, D), at = lt + rt, xt = Math.sin(l), Yt = Math.sqrt(1 - g * g * xt * xt) * Math.sqrt(1 + v * v) / Math.sqrt(L * L + E * E), Wt = O / c * Math.sqrt(D * D + Q * Q), qt = d * Yt * Wt;
    $ = $ + e, q < 0 && (q = q + n), $ = Number($.toFixed(9)), q = Number(q.toFixed(9));
    const Ut = Number(at.toDegrees().toFixed(9)), Dt = Number(qt.toFixed(12)), Mt = this.lat >= 0 ? "N" : "S";
    return new We(i, Mt, $, q, this.datum, Ut, Dt, !!t);
  }
}
class C {
  /**
   * Creates an instance of XYCoord.
   * @param {number} x - The x coordinate or longitude.
   * @param {number} y - The y coordinate or latitude.
   * @param {EPSG} [epsg='3857'] - The EPSG code, either '3857' or '4326'.
   *  Use toDatum for NAD27 convertions (some USGS data is in NAD27)
   */
  constructor(t, e, n = "3857") {
    if (n === "3857") {
      this.x = t, this.y = e;
      const i = Gt(t, e);
      this.lng = i.lng, this.lat = i.lat;
    } else if (n === "4326") {
      this.lng = t, this.lat = e;
      const i = V(t, e);
      this.x = i.x, this.y = i.y;
    } else
      throw new Error("Only 3857 and 4326 are supported");
  }
  /**
   * Gets the pixel coordinates at a specific zoom level.
   * @param {number} z - The zoom level.
   * @param {number} [tileSize=256] - The size of the tile.
   * @returns {{ x: number, y: number }} - The pixel coordinates.
   */
  pixelAtZoom(t, e = 256) {
    const n = $e(this.x, this.y, t);
    return {
      x: n.x * e,
      y: n.y * e
    };
  }
  /**
   * Gets the XY coordinates as an array.
   * @returns {number[]} - The XY coordinates.
   */
  get xyArray() {
    return [this.x, this.y];
  }
  /**
   * Gets the XY coordinates as an object.
   * @returns {{ x: number, y: number }} - The XY coordinates.
   */
  get xyObject() {
    return { x: this.x, y: this.y };
  }
  /**
   * Gets the longitude and latitude as an array.
   * @returns {[number, number]} - The longitude and latitude.
   */
  get lngLatArray() {
    return [this.lng, this.lat];
  }
  /**
   * Gets the longitude and latitude as a Position.
   * @returns {Position} - The longitude and latitude.
   */
  get lngLatPosition() {
    return this.lngLatArray;
  }
  /**
   * Gets the longitude and latitude as an object.
   * @returns {{ lng: number, lat: number }} - The longitude and latitude.
   */
  get lngLatObject() {
    return { lng: this.lng, lat: this.lat };
  }
  /**
   * Converts the current XYCoord instance to a string representation in DMS format.
   * @returns {string} The coordinates in DMS format.
   */
  toDMS() {
    return new pt(this.lat, this.lng).convertDatum(W.WGS84).toString("dms").replace(/\u2032/g, "'").replace(/\u2033/g, '"').replace(/\s/g, " ");
  }
  /**
   * Parses a UTM string to create a new XYCoord instance.
   * @param {string} UTMString - The UTM string to parse.
   * @returns {XYCoord} A new XYCoord instance created from the parsed UTM string.
   */
  static fromUTM(t) {
    const n = We.parse(t, W.WGS84).toLatLon();
    return new C(n.lon, n.lat, "4326");
  }
  /**
   * Converts an XYCoord instance to a UTM string.
   * @param {XYCoord} coord - The XYCoord instance to convert.
   * @returns {string} The UTM string representation of the coordinates.
   */
  static toUTM(t) {
    return new qe(t.lat, t.lng, 0, W.WGS84).toUtm().toString();
  }
  /**
   * Instance method to convert the current XYCoord to a UTM string representation.
   * @returns The UTM string representation of this coordinate.
   */
  toUTM() {
    return C.toUTM(this);
  }
}
function an(a, t) {
  const [e, n] = a, [i, s] = t, r = ((e + 180) % 360 + 360) % 360 - 180;
  let l = ((i + 180) % 360 + 360) % 360 - 180 - r;
  return l > 180 ? l -= 360 : l < -180 && (l += 360), [i - l, n];
}
const ln = (a, t) => {
  const e = [];
  t && a.unshift(t);
  for (let n = 0; n < a.length; n++) {
    const i = a[n];
    if (n === 0)
      e.push(i);
    else {
      const s = e[e.length - 1], r = an(i, s);
      e.push(r);
    }
  }
  return t && (a.shift(), e.shift()), e;
};
class K {
  /**
   * Creates a bounding box from an array of coordinates.
   *
   * @param {Array<{x: number, y: number}>} geometry - The coordinates to create the bounding box from.
   * @param {EPSG} [epsg='3857'] - The EPSG code of the coordinate system.
   */
  constructor(t, e = "3857") {
    let n = 1 / 0, i = 1 / 0, s = -1 / 0, r = -1 / 0;
    t.forEach((o) => {
      const l = new C(o.x, o.y, e);
      n = Math.min(n, l.x), i = Math.min(i, l.y), s = Math.max(s, l.x), r = Math.max(r, l.y);
    }), this.northWest = new C(n, r), this.southEast = new C(s, i);
  }
  /**
   * Returns the bounding box as an object with minX, minY, maxX, maxY properties.
   *
   * @param {EPSG} [epsg='3857'] - The EPSG code of the coordinate system.
   * @return {minX: number, minY: number, maxX: number, maxY: number}  The bounding box as an object.
   */
  bboxObject(t = "3857") {
    const e = t === "4326" ? "lng" : "x", n = t === "4326" ? "lat" : "y";
    return {
      minX: this.northWest[e],
      //West
      minY: this.southEast[n],
      //South
      maxX: this.southEast[e],
      //East
      maxY: this.northWest[n]
      //North
    };
  }
  /**
   * Returns the bounding box as a GeoJSON bounding box array.
   *
   * @param {EPSG} [epsg='4326'] - The EPSG code of the coordinate system.
   * @return {BBox} The bounding box as a GeoJSON bounding box array.
   */
  toGeoJSONBBox(t = "4326") {
    const e = this.bboxObject(t);
    return [
      e.minX,
      e.minY,
      e.maxX,
      e.maxY
    ];
  }
  /**
   * Returns the bounding box as a GeoJSON geometry object.
   *
   * @param {EPSG} [epsg='4326'] - The EPSG code of the coordinate system.
   * @return {Polygon} The bounding box as a GeoJSON Polygon geometry object.
   */
  toGeoJSONGeometry(t = "4326") {
    const e = this.toGeoJSONBBox(t);
    return {
      type: "Polygon",
      coordinates: [[
        [e[0], e[1]],
        [e[0], e[3]],
        [e[2], e[3]],
        [e[2], e[1]],
        [e[0], e[1]]
      ]]
    };
  }
  /**
   * Returns the bounding box as a GeoJSON feature object.
   *
   * @param {EPSG} [epsg='4326'] - The EPSG code of the coordinate system.
   * @return {Feature} The bounding box as a GeoJSON feature object.
   */
  toGeoJSONFeature(t = "4326") {
    return {
      type: "Feature",
      properties: {},
      bbox: this.toGeoJSONBBox(t),
      geometry: this.toGeoJSONGeometry(t)
    };
  }
  /**
   * Returns the bounding box as a GeoJSON feature collection object.
   *
   * @param {EPSG} [epsg='4326'] - The EPSG code of the coordinate system.
   * @return {FeatureCollection} The bounding box as a GeoJSON feature collection object.
   */
  toGeoJSON(t = "4326") {
    return {
      type: "FeatureCollection",
      features: [
        this.toGeoJSONFeature(t)
      ]
    };
  }
  /**
   * Checks if the bounding box overlaps with another bounding box.
   *
   * @param {BoundingBox} otherBbox - The other bounding box to check for overlap.
   * @return {boolean} True if the bounding boxes overlap, false otherwise.
   */
  overlaps(t) {
    return t.southEast.x >= this.northWest.x && t.northWest.x <= this.southEast.x && t.southEast.y <= this.northWest.y && t.northWest.y >= this.southEast.y;
  }
  /**
   * Checks if the bounding box is a point.
   *
   * @return {boolean} True if the bounding box is a point, false otherwise.
   */
  get isPoint() {
    return this.northWest.x === this.southEast.x && this.northWest.y === this.southEast.y;
  }
  /**
   * Returns the width of the bounding box.
   *
   * @param {EPSG} [epsg='3857'] - The EPSG code of the coordinate system.
   * @return {number} The width of the bounding box.
   */
  width(t = "3857") {
    const e = this.bboxObject(t);
    return e.maxX - e.minX;
  }
  /**
   * Returns the height of the bounding box.
   *
   * @param {EPSG} [epsg='3857'] - The EPSG code of the coordinate system.
   * @return {number} The height of the bounding box.
   */
  height(t = "3857") {
    const e = this.bboxObject(t);
    return e.maxY - e.minY;
  }
  /**
   * Returns the area of the bounding box.
   *
   * @param {EPSG} [epsg='3857'] - The EPSG code of the coordinate system.
   * @return {number} The area of the bounding box.
   */
  area(t = "3857") {
    return this.width(t) * this.height(t);
  }
  /**
   * Checks if the bounding box contains a point.
   *
   * @param {Object} point - The point to check.
   * @param {number} point.x - The x coordinate of the point.
   * @param {number} point.y - The y coordinate of the point.
   * @param {EPSG} [epsg='3857'] - The EPSG code of the coordinate system.
   * @return {boolean} True if the bounding box contains the point, false otherwise.
   */
  containsPoint(t, e = "3857") {
    const n = new K([t], e);
    return this.overlaps(n);
  }
  /**
   * Checks if the bounding box intersects with a line.
   *
   * @param {Position[]} line - The line to check.
   * @param {EPSG} [epsg='4326'] - The EPSG code of the coordinate system.
   * @return {boolean} True if the bounding box intersects the line, false otherwise.
   */
  intersectsLine(t, e = "4326") {
    let n = !1;
    const i = this.toGeoJSONGeometry(e).coordinates[0], s = Xt;
    let r, o, l, h;
    for (let u = 0; u < t.length && !n; u++) {
      r = t[u], o = t[(u + 1) % t.length];
      for (let c = 0; c < i.length && !n; c++)
        l = i[c], h = i[(c + 1) % i.length], n = s([r, l, h]) != s([o, l, h]) && s([r, o, l]) != s([r, o, h]);
    }
    return n;
  }
  /**
   * Checks if a feature is contained within a bounding box.
   *
   * @param feature - The feature to check.
   * @param epsg - The EPSG code of the coordinate system. Defaults to '4326' because it takes GeoJSON.
   * @throws Will throw an error if the feature is a MultiPolygon.
   * @returns True if the bounding box contains the feature, false otherwise.
   */
  containsFeature(t, e = "4326") {
    let n = !1;
    const i = (s) => ({
      x: s[0],
      y: s[1]
    });
    if (t.geometry.type === "MultiPolygon")
      throw new Error("MultiPolyon not supported");
    if (t.geometry.type === "Point")
      n = this.overlaps(new K([i(t.geometry.coordinates)], e));
    else {
      let s = [[]];
      t.geometry.type === "LineString" ? s = [t.geometry.coordinates] : s = t.geometry.coordinates;
      let r = t.geometry.coordinates.reduce((h, u) => [...h, ...u], []).map((h) => i(h));
      const o = new K(r, e);
      let l = [];
      for (let h = 0; h < s.length && !n; h++) {
        l = s[h];
        for (let u = 0; u < l.length && !n; u++)
          (this.containsPoint({ x: l[u][0], y: l[u][1] }, e) || this.intersectsLine([l[u], l[(u + 1) % l.length]])) && (n = !0);
      }
      if (!n && t.geometry.type === "Polygon" && o.width() > this.width() && o.height() > this.height()) {
        let h = this.toGeoJSONGeometry().coordinates[0];
        for (let u = 0; u < h.length - 1 && !n; u++)
          n = ke(h[u], t.geometry.coordinates);
      }
    }
    return n;
  }
  extend(t) {
    const e = Math.min(this.northWest.x, t.northWest.x), n = Math.min(this.southEast.y, t.southEast.y), i = Math.max(this.southEast.x, t.southEast.x), s = Math.max(this.northWest.y, t.northWest.y);
    return new K([{ x: e, y: s }, { x: i, y: n }]);
  }
  wrapMeridian() {
    const t = this.toGeoJSONGeometry("4326").coordinates[0], e = ln(t);
    return new K(e.map(([i, s]) => ({ x: i, y: s })), "4326");
  }
  toString() {
    return JSON.stringify(this.bboxObject("3857"));
  }
  static fromBoundingBoxes(t) {
    let e = 1 / 0, n = 1 / 0, i = -1 / 0, s = -1 / 0;
    return t.forEach((r) => {
      e = Math.min(e, r.northWest.x), n = Math.min(n, r.southEast.y), i = Math.max(i, r.southEast.x), s = Math.max(s, r.northWest.y);
    }), new K([{ x: e, y: s }, { x: i, y: n }]);
  }
}
class ft {
  /**
   * Creates a new tile coordinate.
   * 
   * @param {number} x - The x coordinate.
   * @param {number} y - The y coordinate.
   * @param {number} z - The zoom level.
   * @param {tileCoordOptions} [options] - Optional parameters for the tile coordinate.
   */
  constructor(t, e, n, i) {
    if (t < 0 || t > 1 << n)
      throw new Error("x is out of bounds");
    if (e < 0 || e > 1 << n)
      throw new Error("y is out of bounds");
    this.x = t, this.y = e, this.z = n, this.tileSize = (i == null ? void 0 : i.tileSize) || 256, this.northWest = ft.tileXY(this.x, this.y, this.z), this.southEast = ft.tileXY(this.x + 1, this.y + 1, this.z), this.center = ft.tileXY(this.x + 0.5, this.y + 0.5, this.z);
  }
  /**
   * Converts tile coordinates to an XY coordinate.
   * 
   * @param {number} x - The x coordinate.
   * @param {number} y - The y coordinate.
   * @param {number} z - The zoom level.
   * @returns {XYCoord} - The XY coordinate.
   */
  static tileXY(t, e, n) {
    const i = Ce(t, e, n);
    return new C(
      i.x,
      i.y,
      "3857"
    );
  }
  /**
   * Gets the size of each pixel in meters at the current zoom level.
   * 
   * @returns {number} - The size of each pixel in meters.
   */
  get metersPerPixel() {
    return H / (this.tileSize * Math.pow(2, this.z));
  }
  /**
   * Gets the children of the current tile at a specified number of zoom levels deeper.
   * 
   * @param {number} [levels=1] - The number of zoom levels deeper to get the children for.
   * @returns {TileCoord[]} - An array of tile coordinates.
   */
  children(t = 1) {
    if (t < 0) throw new Error("Tile Parent out of range.");
    const e = 1 << t;
    return new Array(e * e).fill(void 0).map((n, i) => {
      const s = i % e, r = Math.floor(i / e);
      return new ft(
        this.x * e + s,
        this.y * e + r,
        this.z + t,
        {
          tileSize: this.tileSize
        }
      );
    });
  }
  /**
   * Gets the parent of the current tile at a specified number of zoom levels higher.
   * 
   * @param {number} [levels=1] - The number of zoom levels higher to get the parent for.
   * @returns {TileCoord} - The parent tile coordinate.
   */
  parent(t = 1) {
    if (t < 0 || t > this.z) throw new Error("Tile Parent out of range.");
    const e = Math.pow(2, t * -1);
    return new ft(
      Math.floor(this.x * e),
      Math.floor(this.y * e),
      this.z - t,
      {
        tileSize: this.tileSize
      }
    );
  }
  /**
   * Checks if a given XY coordinate is contained within the current tile.
   * 
   * @param {XYCoord} coord - The XY coordinate.
   * @returns {boolean} - True if the coordinate is contained within the tile, false otherwise.
   */
  contains(t) {
    const e = t.pixelAtZoom(this.z, 1);
    return Math.floor(e.x) === this.x && Math.floor(e.y) === this.y;
  }
  /**
   * Converts the current tile coordinate to a quadkey.
   * 
   * @returns {string} - The quadkey.
   */
  get quadKey() {
    return je(this.x, this.y, this.z);
  }
  /**
   * Converts the current tile coordinate to a tileKey.
   * 
   * @returns {string} - The toTileKey.
   */
  get tileKey() {
    return Z(this.x, this.y, this.z);
  }
}
const ht = Math.PI, Ft = Number.EPSILON;
class At extends nt {
  /**
   * Returns the distance between ‘this’ point and destination point along a geodesic on the
   * surface of the ellipsoid, using Vincenty inverse solution.
   *
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @returns {number} Distance in metres between points or NaN if failed to converge.
   *
   * @example
   *   const p1 = new LatLon(50.06632, -5.71475);
   *   const p2 = new LatLon(58.64402, -3.07009);
   *   const d = p1.distanceTo(p2); // 969,954.166 m
   */
  distanceTo(t) {
    try {
      const e = this.inverse(t).distance;
      return Number(e.toFixed(3));
    } catch (e) {
      if (e instanceof EvalError) return NaN;
      throw e;
    }
  }
  /**
   * Returns the initial bearing to travel along a geodesic from ‘this’ point to the given point,
   * using Vincenty inverse solution.
   *
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @returns {number} Initial bearing in degrees from north (0°..360°) or NaN if failed to converge.
   *
   * @example
   *   const p1 = new LatLon(50.06632, -5.71475);
   *   const p2 = new LatLon(58.64402, -3.07009);
   *   const b1 = p1.initialBearingTo(p2); // 9.1419°
   */
  initialBearingTo(t) {
    try {
      const e = this.inverse(t).initialBearing;
      return Number(e.toFixed(7));
    } catch (e) {
      if (e instanceof EvalError) return NaN;
      throw e;
    }
  }
  /**
   * Returns the final bearing having travelled along a geodesic from ‘this’ point to the given
   * point, using Vincenty inverse solution.
   *
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @returns {number} Final bearing in degrees from north (0°..360°) or NaN if failed to converge.
   *
   * @example
   *   const p1 = new LatLon(50.06632, -5.71475);
   *   const p2 = new LatLon(58.64402, -3.07009);
   *   const b2 = p1.finalBearingTo(p2); // 11.2972°
   */
  finalBearingTo(t) {
    try {
      const e = this.inverse(t).finalBearing;
      return Number(e.toFixed(7));
    } catch (e) {
      if (e instanceof EvalError) return NaN;
      throw e;
    }
  }
  /**
   * Returns the destination point having travelled the given distance along a geodesic given by
   * initial bearing from ‘this’ point, using Vincenty direct solution.
   *
   * @param   {number} distance - Distance travelled along the geodesic in metres.
   * @param   {number} initialBearing - Initial bearing in degrees from north.
   * @returns {LatLon} Destination point.
   *
   * @example
   *   const p1 = new LatLon(-37.95103, 144.42487);
   *   const p2 = p1.destinationPoint(54972.271, 306.86816); // 37.6528°S, 143.9265°E
   */
  destinationPoint(t, e) {
    return this.direct(Number(t), Number(e)).point;
  }
  /**
   * Returns the final bearing having travelled along a geodesic given by initial bearing for a
   * given distance from ‘this’ point, using Vincenty direct solution.
   * TODO: arg order? (this is consistent with destinationPoint, but perhaps less intuitive)
   *
   * @param   {number} distance - Distance travelled along the geodesic in metres.
   * @param   {LatLon} initialBearing - Initial bearing in degrees from north.
   * @returns {number} Final bearing in degrees from north (0°..360°).
   *
   * @example
   *   const p1 = new LatLon(-37.95103, 144.42487);
   *   const b2 = p1.finalBearingOn(54972.271, 306.86816); // 307.1736°
   */
  finalBearingOn(t, e) {
    const n = this.direct(Number(t), Number(e)).finalBearing;
    return Number(n.toFixed(7));
  }
  /**
   * Returns the point at given fraction between ‘this’ point and given point.
   *
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @param   {number} fraction - Fraction between the two points (0 = this point, 1 = specified point).
   * @returns {LatLon} Intermediate point between this point and destination point.
   *
   * @example
   *   const p1 = new LatLon(50.06632, -5.71475);
   *   const p2 = new LatLon(58.64402, -3.07009);
   *   const pInt = p1.intermediatePointTo(p2, 0.5); // 54.3639°N, 004.5304°W
   */
  intermediatePointTo(t, e) {
    if (e == 0) return this;
    if (e == 1) return t;
    const n = this.inverse(t), i = n.distance, s = n.initialBearing;
    return isNaN(s) ? this : this.destinationPoint(i * e, s);
  }
  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
  /**
   * Vincenty direct calculation.
   *
   * Ellipsoid parameters are taken from datum of 'this' point. Height is ignored.
   *
   * @private
   * @param   {number} distance - Distance along bearing in metres.
   * @param   {number} initialBearing - Initial bearing in degrees from north.
   * @returns (Object} Object including point (destination point), finalBearing.
   * @throws  {RangeError} Point must be on surface of ellipsoid.
   * @throws  {EvalError}  Formula failed to converge.
   */
  direct(t, e) {
    if (isNaN(t)) throw new TypeError(`invalid distance ${t}`);
    if (t == 0) return { point: this, finalBearing: NaN, iterations: 0 };
    if (isNaN(e)) throw new TypeError(`invalid bearing ${e}`);
    if (this.height != 0) throw new RangeError("point must be on the surface of the ellipsoid");
    const n = this.lat.toRadians(), i = this.lon.toRadians(), s = Number(e).toRadians(), r = Number(t), o = this.datum ? this.datum.ellipsoid : nt.ellipsoids.WGS84, { a: l, b: h, f: u } = o, c = Math.sin(s), f = Math.cos(s), d = (1 - u) * Math.tan(n), g = 1 / Math.sqrt(1 + d * d), p = d * g, x = Math.atan2(d, f), m = g * c, M = 1 - m * m, w = M * (l * l - h * h) / (h * h), N = 1 + w / 16384 * (4096 + w * (-768 + w * (320 - 175 * w))), E = w / 1024 * (256 + w * (-128 + w * (74 - 47 * w)));
    let P = r / (h * N), T = null, v = null, _ = null, L = null, R = 0;
    do {
      _ = Math.cos(2 * x + P), T = Math.sin(P), v = Math.cos(P);
      const Q = E * T * (_ + E / 4 * (v * (-1 + 2 * _ * _) - E / 6 * _ * (-3 + 4 * T * T) * (-3 + 4 * _ * _)));
      L = P, P = r / (h * N) + Q;
    } while (Math.abs(P - L) > 1e-12 && ++R < 100);
    if (R >= 100) throw new EvalError("Vincenty formula failed to converge");
    const S = p * T - g * v * f, O = Math.atan2(p * v + g * T * f, (1 - u) * Math.sqrt(m * m + S * S)), A = Math.atan2(T * c, g * v - p * T * f), k = u / 16 * M * (4 + u * (4 - 3 * M)), Y = A - (1 - k) * u * m * (P + k * T * (_ + k * v * (-1 + 2 * _ * _))), $ = i + Y, q = Math.atan2(m, -S);
    return {
      point: new At(O.toDegrees(), $.toDegrees(), 0, this.datum),
      finalBearing: y.wrap360(q.toDegrees()),
      iterations: R
    };
  }
  /**
   * Vincenty inverse calculation.
   *
   * Ellipsoid parameters are taken from datum of 'this' point. Height is ignored.
   *
   * @private
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @returns {Object} Object including distance, initialBearing, finalBearing.
   * @throws  {TypeError}  Invalid point.
   * @throws  {RangeError} Points must be on surface of ellipsoid.
   * @throws  {EvalError}  Formula failed to converge.
   */
  inverse(t) {
    if (!(t instanceof nt)) throw new TypeError(`invalid point ‘${t}’`);
    if (this.height != 0 || t.height != 0) throw new RangeError("point must be on the surface of the ellipsoid");
    const e = this, n = t, i = e.lat.toRadians(), s = e.lon.toRadians(), r = n.lat.toRadians(), o = n.lon.toRadians(), l = this.datum ? this.datum.ellipsoid : nt.ellipsoids.WGS84, { a: h, b: u, f: c } = l, f = o - s, d = (1 - c) * Math.tan(i), g = 1 / Math.sqrt(1 + d * d), p = d * g, x = (1 - c) * Math.tan(r), m = 1 / Math.sqrt(1 + x * x), M = x * m, w = Math.abs(f) > ht / 2 || Math.abs(r - i) > ht / 2;
    let N = f, E = null, P = null, T = w ? ht : 0, v = 0, _ = w ? -1 : 1, L = null, R = 1, S = 1, O = null, A = 0;
    do {
      if (E = Math.sin(N), P = Math.cos(N), L = (m * E) ** 2 + (g * M - p * m * P) ** 2, Math.abs(L) < 1e-24) break;
      v = Math.sqrt(L), _ = p * M + g * m * P, T = Math.atan2(v, _);
      const rt = g * m * E / v;
      S = 1 - rt * rt, R = S != 0 ? _ - 2 * p * M / S : 0;
      const at = c / 16 * S * (4 + c * (4 - 3 * S));
      if (O = N, N = f + (1 - at) * c * rt * (T + at * v * (R + at * _ * (-1 + 2 * R * R))), (w ? Math.abs(N) - ht : Math.abs(N)) > ht) throw new EvalError("λ > π");
    } while (Math.abs(N - O) > 1e-12 && ++A < 1e3);
    if (A >= 1e3) throw new EvalError("Vincenty formula failed to converge");
    const k = S * (h * h - u * u) / (u * u), Y = 1 + k / 16384 * (4096 + k * (-768 + k * (320 - 175 * k))), $ = k / 1024 * (256 + k * (-128 + k * (74 - 47 * k))), q = $ * v * (R + $ / 4 * (_ * (-1 + 2 * R * R) - $ / 6 * R * (-3 + 4 * v * v) * (-3 + 4 * R * R))), D = u * Y * (T - q), Q = Math.abs(L) < Ft ? 0 : Math.atan2(m * E, g * M - p * m * P), lt = Math.abs(L) < Ft ? ht : Math.atan2(g * E, -p * m + g * M * P);
    return {
      distance: D,
      initialBearing: Math.abs(D) < Ft ? NaN : y.wrap360(Q.toDegrees()),
      finalBearing: Math.abs(D) < Ft ? NaN : y.wrap360(lt.toDegrees()),
      iterations: A
    };
  }
}
function mt(a, t) {
  return Math.sqrt(
    Math.pow(a[1] - t[1], 2) + Math.pow(a[0] - t[0], 2)
  );
}
function hn([a, t], [e, n]) {
  const i = (d) => Math.PI / 180 * d, s = H / (2 * Math.PI * 1e3), r = i(n - t), o = i(e - a), l = i(t), h = i(n), u = Math.pow(Math.sin(r / 2), 2) + Math.pow(Math.sin(o / 2), 2) * Math.cos(l) * Math.cos(h), c = 2 * Math.asin(Math.sqrt(u));
  return s * c;
}
function bt([a, t], [e, n]) {
  const i = new At(t, a), s = new At(n, e);
  return i.distanceTo(s) / 1e3;
}
const cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  euclidean: mt,
  haversine: hn,
  vincenty: bt
}, Symbol.toStringTag, { value: "Module" })), yt = (a) => cn[a];
function de(a, t) {
  return Math.atan2(t[1] - a[1], t[0] - a[0]);
}
function Ue(a, t, e) {
  return [
    Math.cos(t) * e + a[0],
    // x coordinate
    Math.sin(t) * e + a[1]
    // y coordinate
  ];
}
function ge(a, [t, e], n = "euclidean") {
  const [i, s] = a, [r, o] = t, [l, h] = e;
  if (r === l && o === h)
    return t;
  if (r === l) {
    const M = Math.min(o, h), w = Math.max(o, h);
    return s <= M ? [r, M] : s >= w ? [r, w] : [r, s];
  }
  if (o === h) {
    const M = Math.min(r, l), w = Math.max(r, l);
    return i <= M ? [M, o] : i >= w ? [w, o] : [i, o];
  }
  const u = (h - o) / (l - r), c = o - u * r, f = -1 / u, d = s - f * i, g = (c - d) / (f - u), p = u * g + c, x = [g, p].map((M) => Object.is(M, -0) ? 0 : M);
  if (g >= Math.min(r, l) && g <= Math.max(r, l) && p >= Math.min(o, h) && p <= Math.max(o, h))
    return x;
  {
    const M = yt(n)(a, t), w = yt(n)(a, e);
    return M < w ? t : e;
  }
}
function gt(a) {
  return Array.isArray(a[0]) ? Array.isArray(a[0][0]) ? Array.isArray(a[0][0][0]) ? a : a.map((t) => [t]) : [[a]] : [[[a]]];
}
function De(a, t) {
  let e;
  return t === "Point" || t === "LineString" || t === "MultiPoint" ? e = a[0][0] : t === "MultiLineString" || t === "Polygon" ? e = a[0] : e = a, e;
}
const Qt = (a, t, e) => {
  const n = t.filter((i) => i !== void 0);
  if (!(n === void 0 || t.length === 0)) {
    if (n.length === 1)
      return {
        closestPoint: n[0],
        segment: [n[0], n[0]],
        segmentIdx: 0
      };
    {
      let i = 1 / 0, s = n[0], r = [s, s], o = 0;
      for (let l = 1; l < n.length; l++) {
        const h = n[l - 1], u = n[l], c = ge(a, [h, u || h], e), f = yt(e)(a, c);
        i < f && (i = f, s = c, r = [h, u], o = l);
      }
      return {
        closestPoint: s,
        segment: r,
        segmentIdx: o
      };
    }
  }
};
function Je(a, t, e = "euclidean") {
  var i;
  const n = gt(t);
  return (i = Qt(a, n.map(
    (s) => {
      var r;
      return (r = Qt(a, s.map(
        (o) => {
          var l;
          return (l = Qt(a, o, e)) == null ? void 0 : l.closestPoint;
        }
      ), e)) == null ? void 0 : r.closestPoint;
    }
  ), e)) == null ? void 0 : i.closestPoint;
}
function un(a, t = "euclidean") {
  return gt(a).map(
    (n) => n.map((i) => {
      let s = 0;
      for (let r = 1; r < i.length; r++) {
        const o = i[r - 1], l = i[r];
        s += yt(t)(o, l || o);
      }
      return s;
    }).reduce((i, s) => i + s, 0)
  ).reduce((n, i) => n + i, 0);
}
function fn(a) {
  const t = a.filter((i) => i.geometry.type === "LineString"), n = a.filter((i) => i.geometry.type === "MultiLineString").flatMap((i) => i.geometry.coordinates.map((r) => ({
    type: "Feature",
    properties: i.properties,
    geometry: {
      type: "LineString",
      coordinates: r
    }
  })));
  return [...t, ...n];
}
function dn(a, t, e = "euclidean") {
  const n = t.map((i, s) => {
    let r = 1 / 0;
    const o = Je(a, i.geometry.coordinates, e);
    return o && (r = yt(e)(a, o), console.log(e, a, o, yt(e)(a, o))), {
      distance: r,
      nearestPoint: o,
      featureIdx: s,
      testPoint: a
    };
  }).reduce((i, s) => i.distance < s.distance ? i : s, {
    distance: 1 / 0
  });
  console.log(n);
}
const si = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  angleBetweenPoints: de,
  convertMultiLineStringToLineString: fn,
  lineLength: un,
  multiToType: De,
  nearestPointOnFeature: Je,
  nearestPointOnLineSegment: ge,
  normalizeToMulti: gt,
  polarToCartesian: Ue,
  splitFeaturesAtPoint: dn
}, Symbol.toStringTag, { value: "Module" })), F = Math.PI;
class I {
  /**
   * Creates a latitude/longitude point on the earth’s surface, using a spherical model earth.
   *
   * @param  {number} lat - Latitude (in degrees).
   * @param  {number} lon - Longitude (in degrees).
   * @throws {TypeError} Invalid lat/lon.
   *
   * @example
   *   import LatLon from '/js/geodesy/latlon-spherical.js';
   *   const p = new LatLon(52.205, 0.119);
   */
  constructor(t, e) {
    if (isNaN(t)) throw new TypeError(`invalid lat ‘${t}’`);
    if (isNaN(e)) throw new TypeError(`invalid lon ‘${e}’`);
    this._lat = y.wrap90(Number(t)), this._lon = y.wrap180(Number(e));
  }
  /**
   * Latitude in degrees north from equator (including aliases lat, latitude): can be set as
   * numeric or hexagesimal (deg-min-sec); returned as numeric.
   */
  get lat() {
    return this._lat;
  }
  get latitude() {
    return this._lat;
  }
  set lat(t) {
    if (this._lat = isNaN(t) ? y.wrap90(y.parse(t)) : y.wrap90(Number(t)), isNaN(this._lat)) throw new TypeError(`invalid lat ‘${t}’`);
  }
  set latitude(t) {
    if (this._lat = isNaN(t) ? y.wrap90(y.parse(t)) : y.wrap90(Number(t)), isNaN(this._lat)) throw new TypeError(`invalid latitude ‘${t}’`);
  }
  /**
   * Longitude in degrees east from international reference meridian (including aliases lon, lng,
   * longitude): can be set as numeric or hexagesimal (deg-min-sec); returned as numeric.
   */
  get lon() {
    return this._lon;
  }
  get lng() {
    return this._lon;
  }
  get longitude() {
    return this._lon;
  }
  set lon(t) {
    if (this._lon = isNaN(t) ? y.wrap180(y.parse(t)) : y.wrap180(Number(t)), isNaN(this._lon)) throw new TypeError(`invalid lon ‘${t}’`);
  }
  set lng(t) {
    if (this._lon = isNaN(t) ? y.wrap180(y.parse(t)) : y.wrap180(Number(t)), isNaN(this._lon)) throw new TypeError(`invalid lng ‘${t}’`);
  }
  set longitude(t) {
    if (this._lon = isNaN(t) ? y.wrap180(y.parse(t)) : y.wrap180(Number(t)), isNaN(this._lon)) throw new TypeError(`invalid longitude ‘${t}’`);
  }
  /** Conversion factors; 1000 * LatLon.metresToKm gives 1. */
  static get metresToKm() {
    return 1 / 1e3;
  }
  /** Conversion factors; 1000 * LatLon.metresToMiles gives 0.621371192237334. */
  static get metresToMiles() {
    return 1 / 1609.344;
  }
  /** Conversion factors; 1000 * LatLon.metresToMiles gives 0.5399568034557236. */
  static get metresToNauticalMiles() {
    return 1 / 1852;
  }
  /**
   * Parses a latitude/longitude point from a variety of formats.
   *
   * Latitude & longitude (in degrees) can be supplied as two separate parameters, as a single
   * comma-separated lat/lon string, or as a single object with { lat, lon } or GeoJSON properties.
   *
   * The latitude/longitude values may be numeric or strings; they may be signed decimal or
   * deg-min-sec (hexagesimal) suffixed by compass direction (NSEW); a variety of separators are
   * accepted. Examples -3.62, '3 37 12W', '3°37′12″W'.
   *
   * Thousands/decimal separators must be comma/dot; use Dms.fromLocale to convert locale-specific
   * thousands/decimal separators.
   *
   * @param   {number|string|Object} lat|latlon - Latitude (in degrees) or comma-separated lat/lon or lat/lon object.
   * @param   {number|string}        [lon]      - Longitude (in degrees).
   * @returns {LatLon} Latitude/longitude point.
   * @throws  {TypeError} Invalid point.
   *
   * @example
   *   const p1 = LatLon.parse(52.205, 0.119);                                    // numeric pair (≡ new LatLon)
   *   const p2 = LatLon.parse('52.205', '0.119');                                // numeric string pair (≡ new LatLon)
   *   const p3 = LatLon.parse('52.205, 0.119');                                  // single string numerics
   *   const p4 = LatLon.parse('52°12′18.0″N', '000°07′08.4″E');                  // DMS pair
   *   const p5 = LatLon.parse('52°12′18.0″N, 000°07′08.4″E');                    // single string DMS
   *   const p6 = LatLon.parse({ lat: 52.205, lon: 0.119 });                      // { lat, lon } object numeric
   *   const p7 = LatLon.parse({ lat: '52°12′18.0″N', lng: '000°07′08.4″E' });    // { lat, lng } object DMS
   *   const p8 = LatLon.parse({ type: 'Point', coordinates: [ 0.119, 52.205] }); // GeoJSON
   */
  static parse(...t) {
    if (t.length == 0) throw new TypeError("invalid (empty) point");
    if (t[0] === null || t[1] === null) throw new TypeError("invalid (null) point");
    let e, n;
    if (t.length == 2 && ([e, n] = t, e = y.wrap90(y.parse(e)), n = y.wrap180(y.parse(n)), isNaN(e) || isNaN(n)))
      throw new TypeError(`invalid point ‘${t.toString()}’`);
    if (t.length == 1 && typeof t[0] == "string" && ([e, n] = t[0].split(","), e = y.wrap90(y.parse(e)), n = y.wrap180(y.parse(n)), isNaN(e) || isNaN(n)))
      throw new TypeError(`invalid point ‘${t[0]}’`);
    if (t.length == 1 && typeof t[0] == "object") {
      const i = t[0];
      if (i.type == "Point" && Array.isArray(i.coordinates) ? [n, e] = i.coordinates : (i.latitude != null && (e = i.latitude), i.lat != null && (e = i.lat), i.longitude != null && (n = i.longitude), i.lng != null && (n = i.lng), i.lon != null && (n = i.lon), e = y.wrap90(y.parse(e)), n = y.wrap180(y.parse(n))), isNaN(e) || isNaN(n)) throw new TypeError(`invalid point ‘${JSON.stringify(t[0])}’`);
    }
    if (isNaN(e) || isNaN(n)) throw new TypeError(`invalid point ‘${t.toString()}’`);
    return new I(e, n);
  }
  /**
   * Returns the distance along the surface of the earth from ‘this’ point to destination point.
   *
   * Uses haversine formula: a = sin²(Δφ/2) + cosφ1·cosφ2 · sin²(Δλ/2); d = 2 · atan2(√a, √(a-1)).
   *
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @param   {number} [radius=6371e3] - Radius of earth (defaults to mean radius in metres).
   * @returns {number} Distance between this point and destination point, in same units as radius.
   * @throws  {TypeError} Invalid radius.
   *
   * @example
   *   const p1 = new LatLon(52.205, 0.119);
   *   const p2 = new LatLon(48.857, 2.351);
   *   const d = p1.distanceTo(p2);       // 404.3×10³ m
   *   const m = p1.distanceTo(p2, 3959); // 251.2 miles
   */
  distanceTo(t, e = 6371e3) {
    if (t instanceof I || (t = I.parse(t)), isNaN(e)) throw new TypeError(`invalid radius ‘${e}’`);
    const n = e, i = this.lat.toRadians(), s = this.lon.toRadians(), r = t.lat.toRadians(), o = t.lon.toRadians(), l = r - i, h = o - s, u = Math.sin(l / 2) * Math.sin(l / 2) + Math.cos(i) * Math.cos(r) * Math.sin(h / 2) * Math.sin(h / 2), c = 2 * Math.atan2(Math.sqrt(u), Math.sqrt(1 - u));
    return n * c;
  }
  /**
   * Returns the initial bearing from ‘this’ point to destination point.
   *
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @returns {number} Initial bearing in degrees from north (0°..360°).
   *
   * @example
   *   const p1 = new LatLon(52.205, 0.119);
   *   const p2 = new LatLon(48.857, 2.351);
   *   const b1 = p1.initialBearingTo(p2); // 156.2°
   */
  initialBearingTo(t) {
    if (t instanceof I || (t = I.parse(t)), this.equals(t)) return NaN;
    const e = this.lat.toRadians(), n = t.lat.toRadians(), i = (t.lon - this.lon).toRadians(), s = Math.cos(e) * Math.sin(n) - Math.sin(e) * Math.cos(n) * Math.cos(i), r = Math.sin(i) * Math.cos(n), l = Math.atan2(r, s).toDegrees();
    return y.wrap360(l);
  }
  /**
   * Returns final bearing arriving at destination point from ‘this’ point; the final bearing will
   * differ from the initial bearing by varying degrees according to distance and latitude.
   *
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @returns {number} Final bearing in degrees from north (0°..360°).
   *
   * @example
   *   const p1 = new LatLon(52.205, 0.119);
   *   const p2 = new LatLon(48.857, 2.351);
   *   const b2 = p1.finalBearingTo(p2); // 157.9°
   */
  finalBearingTo(t) {
    t instanceof I || (t = I.parse(t));
    const e = t.initialBearingTo(this) + 180;
    return y.wrap360(e);
  }
  /**
   * Returns the midpoint between ‘this’ point and destination point.
   *
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @returns {LatLon} Midpoint between this point and destination point.
   *
   * @example
   *   const p1 = new LatLon(52.205, 0.119);
   *   const p2 = new LatLon(48.857, 2.351);
   *   const pMid = p1.midpointTo(p2); // 50.5363°N, 001.2746°E
   */
  midpointTo(t) {
    t instanceof I || (t = I.parse(t));
    const e = this.lat.toRadians(), n = this.lon.toRadians(), i = t.lat.toRadians(), s = (t.lon - this.lon).toRadians(), r = { x: Math.cos(e), y: 0, z: Math.sin(e) }, o = { x: Math.cos(i) * Math.cos(s), y: Math.cos(i) * Math.sin(s), z: Math.sin(i) }, l = { x: r.x + o.x, y: r.y + o.y, z: r.z + o.z }, h = Math.atan2(l.z, Math.sqrt(l.x * l.x + l.y * l.y)), u = n + Math.atan2(l.y, l.x), c = h.toDegrees(), f = u.toDegrees();
    return new I(c, f);
  }
  /**
   * Returns the point at given fraction between ‘this’ point and given point.
   *
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @param   {number} fraction - Fraction between the two points (0 = this point, 1 = specified point).
   * @returns {LatLon} Intermediate point between this point and destination point.
   *
   * @example
   *   const p1 = new LatLon(52.205, 0.119);
   *   const p2 = new LatLon(48.857, 2.351);
   *   const pInt = p1.intermediatePointTo(p2, 0.25); // 51.3721°N, 000.7073°E
   */
  intermediatePointTo(t, e) {
    if (t instanceof I || (t = I.parse(t)), this.equals(t)) return new I(this.lat, this.lon);
    const n = this.lat.toRadians(), i = this.lon.toRadians(), s = t.lat.toRadians(), r = t.lon.toRadians(), o = s - n, l = r - i, h = Math.sin(o / 2) * Math.sin(o / 2) + Math.cos(n) * Math.cos(s) * Math.sin(l / 2) * Math.sin(l / 2), u = 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h)), c = Math.sin((1 - e) * u) / Math.sin(u), f = Math.sin(e * u) / Math.sin(u), d = c * Math.cos(n) * Math.cos(i) + f * Math.cos(s) * Math.cos(r), g = c * Math.cos(n) * Math.sin(i) + f * Math.cos(s) * Math.sin(r), p = c * Math.sin(n) + f * Math.sin(s), x = Math.atan2(p, Math.sqrt(d * d + g * g)), m = Math.atan2(g, d), M = x.toDegrees(), w = m.toDegrees();
    return new I(M, w);
  }
  /**
   * Returns the destination point from ‘this’ point having travelled the given distance on the
   * given initial bearing (bearing normally varies around path followed).
   *
   * @param   {number} distance - Distance travelled, in same units as earth radius (default: metres).
   * @param   {number} bearing - Initial bearing in degrees from north.
   * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
   * @returns {LatLon} Destination point.
   *
   * @example
   *   const p1 = new LatLon(51.47788, -0.00147);
   *   const p2 = p1.destinationPoint(7794, 300.7); // 51.5136°N, 000.0983°W
   */
  destinationPoint(t, e, n = 6371e3) {
    const i = t / n, s = Number(e).toRadians(), r = this.lat.toRadians(), o = this.lon.toRadians(), l = Math.sin(r) * Math.cos(i) + Math.cos(r) * Math.sin(i) * Math.cos(s), h = Math.asin(l), u = Math.sin(s) * Math.sin(i) * Math.cos(r), c = Math.cos(i) - Math.sin(r) * l, f = o + Math.atan2(u, c), d = h.toDegrees(), g = f.toDegrees();
    return new I(d, g);
  }
  /**
   * Returns the point of intersection of two paths defined by point and bearing.
   *
   * @param   {LatLon}      p1 - First point.
   * @param   {number}      brng1 - Initial bearing from first point.
   * @param   {LatLon}      p2 - Second point.
   * @param   {number}      brng2 - Initial bearing from second point.
   * @returns {LatLon|null} Destination point (null if no unique intersection defined).
   *
   * @example
   *   const p1 = new LatLon(51.8853, 0.2545), brng1 = 108.547;
   *   const p2 = new LatLon(49.0034, 2.5735), brng2 =  32.435;
   *   const pInt = LatLon.intersection(p1, brng1, p2, brng2); // 50.9078°N, 004.5084°E
   */
  static intersection(t, e, n, i) {
    if (t instanceof I || (t = I.parse(t)), n instanceof I || (n = I.parse(n)), isNaN(e)) throw new TypeError(`invalid brng1 ‘${e}’`);
    if (isNaN(i)) throw new TypeError(`invalid brng2 ‘${i}’`);
    const s = t.lat.toRadians(), r = t.lon.toRadians(), o = n.lat.toRadians(), l = n.lon.toRadians(), h = Number(e).toRadians(), u = Number(i).toRadians(), c = o - s, f = l - r, d = 2 * Math.asin(Math.sqrt(Math.sin(c / 2) * Math.sin(c / 2) + Math.cos(s) * Math.cos(o) * Math.sin(f / 2) * Math.sin(f / 2)));
    if (Math.abs(d) < Number.EPSILON) return new I(t.lat, t.lon);
    const g = (Math.sin(o) - Math.sin(s) * Math.cos(d)) / (Math.sin(d) * Math.cos(s)), p = (Math.sin(s) - Math.sin(o) * Math.cos(d)) / (Math.sin(d) * Math.cos(o)), x = Math.acos(Math.min(Math.max(g, -1), 1)), m = Math.acos(Math.min(Math.max(p, -1), 1)), M = Math.sin(l - r) > 0 ? x : 2 * F - x, w = Math.sin(l - r) > 0 ? 2 * F - m : m, N = h - M, E = w - u;
    if (Math.sin(N) == 0 && Math.sin(E) == 0 || Math.sin(N) * Math.sin(E) < 0) return null;
    const P = -Math.cos(N) * Math.cos(E) + Math.sin(N) * Math.sin(E) * Math.cos(d), T = Math.atan2(Math.sin(d) * Math.sin(N) * Math.sin(E), Math.cos(E) + Math.cos(N) * P), v = Math.asin(Math.min(Math.max(Math.sin(s) * Math.cos(T) + Math.cos(s) * Math.sin(T) * Math.cos(h), -1), 1)), _ = Math.atan2(Math.sin(h) * Math.sin(T) * Math.cos(s), Math.cos(T) - Math.sin(s) * Math.sin(v)), L = r + _, R = v.toDegrees(), S = L.toDegrees();
    return new I(R, S);
  }
  /**
   * Returns (signed) distance from ‘this’ point to great circle defined by start-point and
   * end-point.
   *
   * @param   {LatLon} pathStart - Start point of great circle path.
   * @param   {LatLon} pathEnd - End point of great circle path.
   * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
   * @returns {number} Distance to great circle (-ve if to left, +ve if to right of path).
   *
   * @example
   *   const pCurrent = new LatLon(53.2611, -0.7972);
   *   const p1 = new LatLon(53.3206, -1.7297);
   *   const p2 = new LatLon(53.1887, 0.1334);
   *   const d = pCurrent.crossTrackDistanceTo(p1, p2);  // -307.5 m
   */
  crossTrackDistanceTo(t, e, n = 6371e3) {
    t instanceof I || (t = I.parse(t)), e instanceof I || (e = I.parse(e));
    const i = n;
    if (this.equals(t)) return 0;
    const s = t.distanceTo(this, i) / i, r = t.initialBearingTo(this).toRadians(), o = t.initialBearingTo(e).toRadians();
    return Math.asin(Math.sin(s) * Math.sin(r - o)) * i;
  }
  /**
   * Returns how far ‘this’ point is along a path from from start-point, heading towards end-point.
   * That is, if a perpendicular is drawn from ‘this’ point to the (great circle) path, the
   * along-track distance is the distance from the start point to where the perpendicular crosses
   * the path.
   *
   * @param   {LatLon} pathStart - Start point of great circle path.
   * @param   {LatLon} pathEnd - End point of great circle path.
   * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
   * @returns {number} Distance along great circle to point nearest ‘this’ point.
   *
   * @example
   *   const pCurrent = new LatLon(53.2611, -0.7972);
   *   const p1 = new LatLon(53.3206, -1.7297);
   *   const p2 = new LatLon(53.1887,  0.1334);
   *   const d = pCurrent.alongTrackDistanceTo(p1, p2);  // 62.331 km
   */
  alongTrackDistanceTo(t, e, n = 6371e3) {
    t instanceof I || (t = I.parse(t)), e instanceof I || (e = I.parse(e));
    const i = n;
    if (this.equals(t)) return 0;
    const s = t.distanceTo(this, i) / i, r = t.initialBearingTo(this).toRadians(), o = t.initialBearingTo(e).toRadians(), l = Math.asin(Math.sin(s) * Math.sin(r - o));
    return Math.acos(Math.cos(s) / Math.abs(Math.cos(l))) * Math.sign(Math.cos(o - r)) * i;
  }
  /**
   * Returns maximum latitude reached when travelling on a great circle on given bearing from
   * ‘this’ point (‘Clairaut’s formula’). Negate the result for the minimum latitude (in the
   * southern hemisphere).
   *
   * The maximum latitude is independent of longitude; it will be the same for all points on a
   * given latitude.
   *
   * @param   {number} bearing - Initial bearing.
   * @returns {number} Maximum latitude reached.
   */
  maxLatitude(t) {
    const e = Number(t).toRadians(), n = this.lat.toRadians();
    return Math.acos(Math.abs(Math.sin(e) * Math.cos(n))).toDegrees();
  }
  /**
   * Returns the pair of meridians at which a great circle defined by two points crosses the given
   * latitude. If the great circle doesn't reach the given latitude, null is returned.
   *
   * @param   {LatLon}      point1 - First point defining great circle.
   * @param   {LatLon}      point2 - Second point defining great circle.
   * @param   {number}      latitude - Latitude crossings are to be determined for.
   * @returns {Object|null} Object containing { lon1, lon2 } or null if given latitude not reached.
   */
  static crossingParallels(t, e, n) {
    if (t.equals(e)) return null;
    const i = Number(n).toRadians(), s = t.lat.toRadians(), r = t.lon.toRadians(), o = e.lat.toRadians(), h = e.lon.toRadians() - r, u = Math.sin(s) * Math.cos(o) * Math.cos(i) * Math.sin(h), c = Math.sin(s) * Math.cos(o) * Math.cos(i) * Math.cos(h) - Math.cos(s) * Math.sin(o) * Math.cos(i), f = Math.cos(s) * Math.cos(o) * Math.sin(i) * Math.sin(h);
    if (f * f > u * u + c * c) return null;
    const d = Math.atan2(-c, u), g = Math.acos(f / Math.sqrt(u * u + c * c)), p = r + d - g, x = r + d + g, m = p.toDegrees(), M = x.toDegrees();
    return {
      lon1: y.wrap180(m),
      lon2: y.wrap180(M)
    };
  }
  /* Rhumb - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
  /**
   * Returns the distance travelling from ‘this’ point to destination point along a rhumb line.
   *
   * @param   {LatLon} point - Latitude/longitude of destination point.
   * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
   * @returns {number} Distance in km between this point and destination point (same units as radius).
   *
   * @example
   *   const p1 = new LatLon(51.127, 1.338);
   *   const p2 = new LatLon(50.964, 1.853);
   *   const d = p1.distanceTo(p2); //  40.31 km
   */
  rhumbDistanceTo(t, e = 6371e3) {
    t instanceof I || (t = I.parse(t));
    const n = e, i = this.lat.toRadians(), s = t.lat.toRadians(), r = s - i;
    let o = Math.abs(t.lon - this.lon).toRadians();
    Math.abs(o) > F && (o = o > 0 ? -(2 * F - o) : 2 * F + o);
    const l = Math.log(Math.tan(s / 2 + F / 4) / Math.tan(i / 2 + F / 4)), h = Math.abs(l) > 1e-11 ? r / l : Math.cos(i);
    return Math.sqrt(r * r + h * h * o * o) * n;
  }
  /**
   * Returns the bearing from ‘this’ point to destination point along a rhumb line.
   *
   * @param   {LatLon}    point - Latitude/longitude of destination point.
   * @returns {number}    Bearing in degrees from north.
   *
   * @example
   *   const p1 = new LatLon(51.127, 1.338);
   *   const p2 = new LatLon(50.964, 1.853);
   *   const d = p1.rhumbBearingTo(p2); // 116.7°
   */
  rhumbBearingTo(t) {
    if (t instanceof I || (t = I.parse(t)), this.equals(t)) return NaN;
    const e = this.lat.toRadians(), n = t.lat.toRadians();
    let i = (t.lon - this.lon).toRadians();
    Math.abs(i) > F && (i = i > 0 ? -(2 * F - i) : 2 * F + i);
    const s = Math.log(Math.tan(n / 2 + F / 4) / Math.tan(e / 2 + F / 4)), o = Math.atan2(i, s).toDegrees();
    return y.wrap360(o);
  }
  /**
   * Returns the destination point having travelled along a rhumb line from ‘this’ point the given
   * distance on the given bearing.
   *
   * @param   {number} distance - Distance travelled, in same units as earth radius (default: metres).
   * @param   {number} bearing - Bearing in degrees from north.
   * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
   * @returns {LatLon} Destination point.
   *
   * @example
   *   const p1 = new LatLon(51.127, 1.338);
   *   const p2 = p1.rhumbDestinationPoint(40300, 116.7); // 50.9642°N, 001.8530°E
   */
  rhumbDestinationPoint(t, e, n = 6371e3) {
    const i = this.lat.toRadians(), s = this.lon.toRadians(), r = Number(e).toRadians(), o = t / n, l = o * Math.cos(r);
    let h = i + l;
    Math.abs(h) > F / 2 && (h = h > 0 ? F - h : -F - h);
    const u = Math.log(Math.tan(h / 2 + F / 4) / Math.tan(i / 2 + F / 4)), c = Math.abs(u) > 1e-11 ? l / u : Math.cos(i), f = o * Math.sin(r) / c, d = s + f, g = h.toDegrees(), p = d.toDegrees();
    return new I(g, p);
  }
  /**
   * Returns the loxodromic midpoint (along a rhumb line) between ‘this’ point and second point.
   *
   * @param   {LatLon} point - Latitude/longitude of second point.
   * @returns {LatLon} Midpoint between this point and second point.
   *
   * @example
   *   const p1 = new LatLon(51.127, 1.338);
   *   const p2 = new LatLon(50.964, 1.853);
   *   const pMid = p1.rhumbMidpointTo(p2); // 51.0455°N, 001.5957°E
   */
  rhumbMidpointTo(t) {
    t instanceof I || (t = I.parse(t));
    const e = this.lat.toRadians();
    let n = this.lon.toRadians();
    const i = t.lat.toRadians(), s = t.lon.toRadians();
    Math.abs(s - n) > F && (n += 2 * F);
    const r = (e + i) / 2, o = Math.tan(F / 4 + e / 2), l = Math.tan(F / 4 + i / 2), h = Math.tan(F / 4 + r / 2);
    let u = ((s - n) * Math.log(h) + n * Math.log(l) - s * Math.log(o)) / Math.log(l / o);
    isFinite(u) || (u = (n + s) / 2);
    const c = r.toDegrees(), f = u.toDegrees();
    return new I(c, f);
  }
  /* Area - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /**
   * Calculates the area of a spherical polygon where the sides of the polygon are great circle
   * arcs joining the vertices.
   *
   * @param   {LatLon[]} polygon - Array of points defining vertices of the polygon.
   * @param   {number}   [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
   * @returns {number}   The area of the polygon in the same units as radius.
   *
   * @example
   *   const polygon = [new LatLon(0,0), new LatLon(1,0), new LatLon(0,1)];
   *   const area = LatLon.areaOf(polygon); // 6.18e9 m²
   */
  static areaOf(t, e = 6371e3) {
    const n = e, i = t[0].equals(t[t.length - 1]);
    i || t.push(t[0]);
    const s = t.length - 1;
    let r = 0;
    for (let h = 0; h < s; h++) {
      const u = t[h].lat.toRadians(), c = t[h + 1].lat.toRadians(), f = (t[h + 1].lon - t[h].lon).toRadians(), d = 2 * Math.atan2(Math.tan(f / 2) * (Math.tan(u / 2) + Math.tan(c / 2)), 1 + Math.tan(u / 2) * Math.tan(c / 2));
      r += d;
    }
    l(t) && (r = Math.abs(r) - 2 * F);
    const o = Math.abs(r * n * n);
    return i || t.pop(), o;
    function l(h) {
      let u = 0, c = h[0].initialBearingTo(h[1]);
      for (let g = 0; g < h.length - 1; g++) {
        const p = h[g].initialBearingTo(h[g + 1]), x = h[g].finalBearingTo(h[g + 1]);
        u += (p - c + 540) % 360 - 180, u += (x - p + 540) % 360 - 180, c = x;
      }
      const f = h[0].initialBearingTo(h[1]);
      return u += (f - c + 540) % 360 - 180, Math.abs(u) < 90;
    }
  }
  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
  /**
   * Checks if another point is equal to ‘this’ point.
   *
   * @param   {LatLon} point - Point to be compared against this point.
   * @returns {bool}   True if points have identical latitude and longitude values.
   *
   * @example
   *   const p1 = new LatLon(52.205, 0.119);
   *   const p2 = new LatLon(52.205, 0.119);
   *   const equal = p1.equals(p2); // true
   */
  equals(t) {
    return t instanceof I || (t = I.parse(t)), !(Math.abs(this.lat - t.lat) > Number.EPSILON || Math.abs(this.lon - t.lon) > Number.EPSILON);
  }
  /**
   * Converts ‘this’ point to a GeoJSON object.
   *
   * @returns {Object} this point as a GeoJSON ‘Point’ object.
   */
  toGeoJSON() {
    return { type: "Point", coordinates: [this.lon, this.lat] };
  }
  /**
   * Returns a string representation of ‘this’ point, formatted as degrees, degrees+minutes, or
   * degrees+minutes+seconds.
   *
   * @param   {string} [format=d] - Format point as 'd', 'dm', 'dms', or 'n' for signed numeric.
   * @param   {number} [dp=4|2|0] - Number of decimal places to use: default 4 for d, 2 for dm, 0 for dms.
   * @returns {string} Comma-separated formatted latitude/longitude.
   * @throws  {RangeError} Invalid format.
   *
   * @example
   *   const greenwich = new LatLon(51.47788, -0.00147);
   *   const d = greenwich.toString();                        // 51.4779°N, 000.0015°W
   *   const dms = greenwich.toString('dms', 2);              // 51°28′40.37″N, 000°00′05.29″W
   *   const [lat, lon] = greenwich.toString('n').split(','); // 51.4779, -0.0015
   */
  toString(t = "d", e = void 0) {
    if (!["d", "dm", "dms", "n"].includes(t)) throw new RangeError(`invalid format ‘${t}’`);
    if (t == "n")
      return e == null && (e = 4), `${this.lat.toFixed(e)},${this.lon.toFixed(e)}`;
    const n = y.toLat(this.lat, t, e), i = y.toLon(this.lon, t, e);
    return `${n}, ${i}`;
  }
}
const gn = (a, t, e) => {
  const n = new I(a[1], a[0]), i = new I(t[1], t[0]), s = n.distanceTo(i), r = [n];
  if (s > Math.abs(e) && e > 0) {
    const o = Math.ceil(s / e);
    for (let l = 1; l < o; l++) {
      const h = l / o, u = n.intermediatePointTo(i, h);
      r.push(u);
    }
  }
  return r.push(i), r.map((o) => [o.lon, o.lat]);
}, pn = (a, t, e) => {
  const n = [a], i = mt(a, t);
  if (i > Math.abs(e) && e > 0) {
    const s = Math.ceil(i / e);
    for (let r = 1; r < s; r++) {
      const o = r / s, l = [
        a[0] + o * (t[0] - a[0]),
        a[1] + o * (t[1] - a[1])
      ];
      n.push(l);
    }
  }
  return n.push(t), n;
}, mn = (a, t, e) => {
  const n = [], i = e === "euclidean" ? pn : gn;
  for (let s = 0; s < a.length; s++) {
    const r = a[s];
    if (s === 0)
      n.push(r);
    else {
      const o = n[n.length - 1], l = i(o, r, t);
      n.push(...l.slice(1));
    }
  }
  return n;
};
class B {
  /**
   * Creates a new FeatureList instance with the specified features.
   *
   * @param features - An array of GeoJSON features to initialize the list.
   */
  constructor(t) {
    this._features = /* @__PURE__ */ new Map(), this._featureIdxCounter = -1, t.map((e) => this.add(e));
  }
  /**
   * Add a feature to the feature list.
   *
   * @param feature - The feature to add.
   * @returns The index of the added feature.
   */
  add(t) {
    const e = ++this._featureIdxCounter;
    return this._features.set(e, t), e;
  }
  /**
   * Remove a feature from the feature list.
   *
   * @param featureIdx - The index of the feature to remove.
   */
  remove(t) {
    this._features.delete(t);
  }
  /**
   * Returns a feature from the feature list.
   *
   * @param featureIdx - The index of the feature to return.
   */
  getFeature(t) {
    return this._features.get(t);
  }
  /**
   * Returns an array of tiles that contain their feature.
   *
   * @param zoom - The zoom level of tiles to generate.
   */
  getTiles(t) {
    const e = /* @__PURE__ */ new Set();
    return this._features.forEach((n) => {
      const i = n.geometry.type;
      if (i !== "GeometryCollection") {
        const s = gt(n.geometry.coordinates);
        for (let r = 0; r < s.length; r++)
          for (let o = 0; o < s[r].length; o++) {
            const l = s[r][o];
            i === "MultiPolygon" || i === "Polygon" ? Xe(l, t).forEach((h) => e.add(Z(h.x, h.y, h.z))) : Ge(l, t).forEach((h) => e.add(Z(h.x, h.y, h.z)));
          }
      } else {
        const s = n.geometry.geometries.map((o) => B.feature(o, n.properties));
        new B(s).getTiles(t).forEach((o) => e.add(Z(o.x, o.y, o.z)));
      }
    }), Array.from(e).map((n) => Rt(n));
  }
  getBoundingBox() {
    const t = Array.from(this._features.values()).map((e) => B.featureBoundingBox(e));
    return K.fromBoundingBoxes(t);
  }
  static featureBoundingBox(t, e = "4326") {
    if (t.geometry.type === "GeometryCollection") {
      const i = t.geometry.geometries.map((s) => B.featureBoundingBox({ type: "Feature", geometry: s, properties: {} }, e));
      return K.fromBoundingBoxes(i);
    } else {
      const n = t.geometry, i = gt(n.coordinates).flat(2);
      return new K(i.map(([s, r]) => ({ x: s, y: r })), e);
    }
  }
  static segmentizeFeature(t, e, n = "4326") {
    const i = t.geometry;
    if (i.type === "Point" || i.type === "MultiPoint")
      return t;
    let s = gt(i.coordinates);
    for (let r = 0; r < s.length; r++)
      for (let o = 0; o < s[r].length; o++) {
        const l = s[r][o], h = mn(l, e, n === "4326" ? "vincenty" : "euclidean");
        s[r][o] = h;
      }
    return {
      ...t,
      geometry: {
        ...i,
        coordinates: De(s, i.type)
      }
    };
  }
  /**
   * Converts a set of coordinates into either a Polygon or MultiPolygon geometry.
   *
   * @param coords - The coordinates to be converted.
   * @returns Either a Polygon or MultiPolygon geometry.
   * @throws {Error} If the input coordinates are invalid.
   */
  static polygonize(t) {
    let e;
    if (!Array.isArray(t[0]))
      throw new Error("Invalid coordinates");
    if (!Array.isArray(t[0][0]))
      e = {
        coordinates: t,
        type: "Polygon"
      };
    else if (!Array.isArray(t[0][0][0]))
      e = {
        coordinates: t,
        type: "MultiPolygon"
      };
    else
      throw new Error("Invalid Coords");
    return e;
  }
  /**
   * Creates a GeoJSON feature.
   * 
   * @param geometry - The geometry of the feature.
   * @param properties - The properties of the feature.
   * @param layerName - The name of the layer.
   * 
   * @returns The created feature.
   */
  static feature(t, e, n) {
    const i = {
      type: "Feature",
      properties: e,
      geometry: t
    };
    return n !== void 0 && (i.layerName = n), i;
  }
  /**
   * Creates a GeoJSON feature collection.
   *
   * @param features - An array of features.
   *
   * @returns The created feature collection.
   */
  static collection(t) {
    return {
      type: "FeatureCollection",
      features: t
    };
  }
  /**
   * Creates a GeoJSON Point Feature
   * @param {Position} coordinates - An array of two numbers representing the x and y coordinates.
   * @param {any} properties - An object representing the properties of the Point.
   * @param {string} [layerName] - Optional layer name.
   * @returns {Feature<Point>} - A GeoJSON Point Feature.
   */
  static pointFeature([t, e], n, i) {
    const s = {
      type: "Feature",
      properties: n,
      geometry: {
        type: "Point",
        coordinates: [t, e]
      }
    };
    return i && (s.layerName = i), s;
  }
  /**
   * Modifies positions within a feature's coordinates using the provided function.
   * This is used for reprojection, or moving a feature
   *
   * @param coords - The coordinates to be modified.
   * @param fn - The function to apply to each position.
   * @param geometryType - The type of geometry (e.g., 'MultiPolygon').
   * @returns The modified coordinates in the specified geometry type.
   */
  static modifyPositions(t, e, n = "MultiPolygon") {
    const i = JSON.parse(JSON.stringify(B.normalizeToMulti(t)));
    for (let s = 0; s < i.length; s++)
      for (let r = 0; r < i[s].length; r++)
        for (let o = 0; i[s][r].length; o++)
          i[s][r][o] = e(i[s][r][o]);
    return B.multiToType(i, n);
  }
  /**
   * Projects coordinates from WGS84 to Web Mercator.
   *
   * @param coords - The coordinates to be projected.
   * @param geometryType - The type of geometry (e.g., 'MultiPolygon').
   * @returns The projected coordinates in the specified geometry type.
   */
  static projectWGS84toWebMercator(t, e = "MultiPolygon") {
    const n = ([i, s]) => {
      const { x: r, y: o } = V(i, s);
      return [r, o];
    };
    return B.modifyPositions(t, n, e);
  }
  /**
   * Projects coordinates from Web Mercator to WGS84.
   *
   * @param coords - The coordinates to be projected.
   * @param geometryType - The type of geometry (e.g., 'MultiPolygon').
   * @returns The projected coordinates in the specified geometry type.
   */
  static projectWebMercatorToWGS84(t, e = "MultiPolygon") {
    const n = ([i, s]) => {
      const { lng: r, lat: o } = Gt(i, s);
      return [r, o];
    };
    return B.modifyPositions(t, n, e);
  }
  /**
   * Normalize coordinates to a MultiPolygon format.
   *
   * @param coords - The coordinates to normalize.
   * @returns The normalized coordinates in MultiPolygon format.
   */
  static normalizeToMulti(t) {
    const e = (s) => Array.isArray(s) && s.length === 2 && typeof s[0] == "number" && typeof s[1] == "number", n = (s) => Array.isArray(s) && s.every(e), i = (s) => Array.isArray(s) && s.every(n);
    return e(t) ? [[[t]]] : n(t) ? [[t]] : i(t) ? [t] : t;
  }
  static multiToType(t, e) {
    switch (e) {
      case "Point":
        return t[0][0][0];
      case "MultiPoint":
      case "LineString":
        return t[0][0];
      case "MultiLineString":
      case "Polygon":
        return t[0];
      case "MultiPolygon":
        return t;
      default:
        throw new Error("nope");
    }
  }
  /**
   * Converts the FeatureList to a GeoJSON FeatureCollection.
   *
   * @returns A GeoJSON FeatureCollection representing the features in the list.
   */
  toJSON() {
    const t = Array.from(this._features.values());
    return B.collection(t);
  }
}
const jt = class jt {
  /**
   * Creates a new instance of the NodeGraph class.
   *
   * @param {Partial<graphOptions>} [options={}] - Optional graph options.
   */
  constructor(t = {}) {
    this._graph = {}, this._edgeLookup = {}, this._featureLookup = /* @__PURE__ */ new Map(), this.options = { ...jt.defaultOptions, ...t };
  }
  featureNodeToNodeName(t, e) {
    return `${t.toString()}:${e.toString()}`;
  }
  nodeNameToFeatureNode(t) {
    const [e, n] = t.split(":");
    return {
      featureIdx: parseInt(e),
      nodeIdx: parseInt(n)
    };
  }
  /**
   * Checks if a node with the given name exists in the graph.
   *
   * @param {nodeInfoType} nodeInfo - The name of the node to check.
   * @returns {boolean} True if the node exists, false otherwise.
   */
  hasNode(t) {
    const e = this.featureNodeToNodeName(t.featureIdx, t.nodeIdx);
    return this._graph[e] !== void 0;
  }
  /**
   * Sets a node in the graph by its unique name and coordinates.
   *
   * @param {nodeInfoType} nodeInfo - The unique name of the node.
   * @returns {{ [to: string]: number; }} The data where the node was set.
   */
  addNode(t) {
    const e = this.featureNodeToNodeName(t.featureIdx, t.nodeIdx), n = this._featureLookup.get(t.featureIdx) || {};
    return n[e] = !0, this._featureLookup.set(t.featureIdx, n), this._graph[e] = this._graph[e] || {}, this._graph[e];
  }
  /**
   * Removes a node from the graph by its unique name.
   *
   * @param {nodeInfoType} nodeInfo - The unique name of the node to remove.
   * @returns {NodeGraph} The NodeGraph instance.
   */
  removeNode(t) {
    const e = this.featureNodeToNodeName(t.featureIdx, t.nodeIdx);
    delete this._graph[e], this._edgeLookup[e] === void 0 && (this._edgeLookup[e] = []), this._edgeLookup[e].forEach((i) => {
      this.removeEdge(this.nodeNameToFeatureNode(i), t);
    }), delete this._edgeLookup[e], Object.keys(this._edgeLookup).forEach((i) => {
      this._edgeLookup[i] = this._edgeLookup[i].filter((s) => s !== e);
    });
    const n = this._featureLookup.get(t.featureIdx) || {};
    return n[e] && delete n[e], this._featureLookup.set(t.featureIdx, n), this;
  }
  /**
   * Removes a node from the graph by its unique name.
   *
   * @param {number} featureIdx - The unique name of the node to remove.
   * @returns {NodeGraph} The NodeGraph instance.
   */
  removeFeature(t) {
    const e = this._featureLookup.get(t) || {};
    return Object.keys(e).forEach((n) => {
      const i = this.nodeNameToFeatureNode(n);
      this.removeNode(i);
    }), this;
  }
  /**
   * Sets an edge between two nodes in the graph by their addresss.
   *
   * @param {nodeInfoType} from - The address of the source node.
   * @param {nodeInfoType} to - The address of the target node.
   * @param {number} [cost] - The cost of the edge (optional, uses default if not provided).
   * @returns {NodeGraph} The NodeGraph instance.
   */
  addEdge(t, e, n) {
    const i = this.featureNodeToNodeName(t.featureIdx, t.nodeIdx), s = this.featureNodeToNodeName(e.featureIdx, e.nodeIdx);
    if (!this.hasNode(t)) throw new Error(`Node "${t}" does not exist`);
    if (!this.hasNode(e)) throw new Error(`Node "${e}" does not exist`);
    return n = n === void 0 ? this.options.defaultEdgeValue : n, this._graph[i][s] = n, this._edgeLookup[s] === void 0 && (this._edgeLookup[s] = []), this._edgeLookup[s].push(i), this;
  }
  splitEdge(t, e, n, i, s) {
    const r = this.featureNodeToNodeName(t.featureIdx, t.nodeIdx), o = this.featureNodeToNodeName(e.featureIdx, e.nodeIdx), l = this.featureNodeToNodeName(n.featureIdx, n.nodeIdx);
    return this.getEdge(t, e) !== void 0 && this.removeEdge(t, e), i = i === void 0 ? this.options.defaultEdgeValue : i, s = s === void 0 ? this.options.defaultEdgeValue : s, this._graph[r][l] = i, this._graph[l][o] = s, this._edgeLookup[o] === void 0 && (this._edgeLookup[o] = []), this._edgeLookup[o].push(l), this._edgeLookup[l] === void 0 && (this._edgeLookup[l] = []), this._edgeLookup[l].push(r), this;
  }
  /**
   * Removes an edge between two nodes in the graph by their addresss.
   *
   * @param {nodeInfoType} from - The address of the source node.
   * @param {nodeInfoType} to - The address of the target node.
   */
  removeEdge(t, e) {
    const n = this.featureNodeToNodeName(t.featureIdx, t.nodeIdx), i = this.featureNodeToNodeName(e.featureIdx, e.nodeIdx);
    this._graph[n] && delete this._graph[n][i], this._edgeLookup[i] === void 0 && (this._edgeLookup[i] = []), this._edgeLookup[i] = this._edgeLookup[i].filter((s) => s !== n);
  }
  /**
   * Gets the cost of an edge between two nodes in the graph by their addresss.
   *
   * @param {nodeInfoType} from - The address of the source node.
   * @param {nodeInfoType} to - The address of the target node.
   * @returns {number} The cost of the edge.
   */
  getEdge(t, e) {
    const n = this.featureNodeToNodeName(t.featureIdx, t.nodeIdx), i = this.featureNodeToNodeName(e.featureIdx, e.nodeIdx);
    try {
      return this._graph[n] && this._graph[n][i];
    } catch {
      return;
    }
  }
  /**
   * Retrieves all edges associated with a given node.
   *
   * @param {nodeInfoType} nodeInfo - Information about the target node.
   * @returns {Array<{ from: nodeInfoType, to: nodeInfoType }>} - An array of objects representing edges, with 'from' and 'to' properties.
   */
  getAllEdges(t) {
    const e = this.featureNodeToNodeName(t.featureIdx, t.nodeIdx), n = Object.keys(this._graph[e] || {}).map((s) => ({
      from: t,
      to: this.nodeNameToFeatureNode(s)
    })), i = (this._edgeLookup[e] || []).map((s) => ({
      from: this.nodeNameToFeatureNode(s),
      to: t
    }));
    return [...n, ...i];
  }
  /**
   * Retrieves all nodes associated with a given feature.
   *
   * @param {number} featureIdx - The index of the feature to retrieve nodes for.
   * @returns {nodeInfoType[]} - An array of nodes associated with the specified feature.
   */
  getNodesOnFeature(t) {
    return Object.keys(this._featureLookup.get(t) || {}).map(
      (e) => this.nodeNameToFeatureNode(e)
    );
  }
};
jt.defaultOptions = {
  defaultEdgeValue: 1 / 0
};
let te = jt;
function Qe(a, t, e = 0, n = a.length - 1, i = yn) {
  for (; n > e; ) {
    if (n - e > 600) {
      const l = n - e + 1, h = t - e + 1, u = Math.log(l), c = 0.5 * Math.exp(2 * u / 3), f = 0.5 * Math.sqrt(u * c * (l - c) / l) * (h - l / 2 < 0 ? -1 : 1), d = Math.max(e, Math.floor(t - h * c / l + f)), g = Math.min(n, Math.floor(t + (l - h) * c / l + f));
      Qe(a, t, d, g, i);
    }
    const s = a[t];
    let r = e, o = n;
    for (wt(a, e, t), i(a[n], s) > 0 && wt(a, e, n); r < o; ) {
      for (wt(a, r, o), r++, o--; i(a[r], s) < 0; ) r++;
      for (; i(a[o], s) > 0; ) o--;
    }
    i(a[e], s) === 0 ? wt(a, e, o) : (o++, wt(a, o, n)), o <= t && (e = o + 1), t <= o && (n = o - 1);
  }
}
function wt(a, t, e) {
  const n = a[t];
  a[t] = a[e], a[e] = n;
}
function yn(a, t) {
  return a < t ? -1 : a > t ? 1 : 0;
}
class xn {
  constructor(t = 9) {
    this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4)), this.clear();
  }
  all() {
    return this._all(this.data, []);
  }
  search(t) {
    let e = this.data;
    const n = [];
    if (!kt(t, e)) return n;
    const i = this.toBBox, s = [];
    for (; e; ) {
      for (let r = 0; r < e.children.length; r++) {
        const o = e.children[r], l = e.leaf ? i(o) : o;
        kt(t, l) && (e.leaf ? n.push(o) : Kt(t, l) ? this._all(o, n) : s.push(o));
      }
      e = s.pop();
    }
    return n;
  }
  collides(t) {
    let e = this.data;
    if (!kt(t, e)) return !1;
    const n = [];
    for (; e; ) {
      for (let i = 0; i < e.children.length; i++) {
        const s = e.children[i], r = e.leaf ? this.toBBox(s) : s;
        if (kt(t, r)) {
          if (e.leaf || Kt(t, r)) return !0;
          n.push(s);
        }
      }
      e = n.pop();
    }
    return !1;
  }
  load(t) {
    if (!(t && t.length)) return this;
    if (t.length < this._minEntries) {
      for (let n = 0; n < t.length; n++)
        this.insert(t[n]);
      return this;
    }
    let e = this._build(t.slice(), 0, t.length - 1, 0);
    if (!this.data.children.length)
      this.data = e;
    else if (this.data.height === e.height)
      this._splitRoot(this.data, e);
    else {
      if (this.data.height < e.height) {
        const n = this.data;
        this.data = e, e = n;
      }
      this._insert(e, this.data.height - e.height - 1, !0);
    }
    return this;
  }
  insert(t) {
    return t && this._insert(t, this.data.height - 1), this;
  }
  clear() {
    return this.data = dt([]), this;
  }
  remove(t, e) {
    if (!t) return this;
    let n = this.data;
    const i = this.toBBox(t), s = [], r = [];
    let o, l, h;
    for (; n || s.length; ) {
      if (n || (n = s.pop(), l = s[s.length - 1], o = r.pop(), h = !0), n.leaf) {
        const u = Mn(t, n.children, e);
        if (u !== -1)
          return n.children.splice(u, 1), s.push(n), this._condense(s), this;
      }
      !h && !n.leaf && Kt(n, i) ? (s.push(n), r.push(o), o = 0, l = n, n = n.children[0]) : l ? (o++, n = l.children[o], h = !1) : n = null;
    }
    return this;
  }
  toBBox(t) {
    return t;
  }
  compareMinX(t, e) {
    return t.minX - e.minX;
  }
  compareMinY(t, e) {
    return t.minY - e.minY;
  }
  toJSON() {
    return this.data;
  }
  fromJSON(t) {
    return this.data = t, this;
  }
  _all(t, e) {
    const n = [];
    for (; t; )
      t.leaf ? e.push(...t.children) : n.push(...t.children), t = n.pop();
    return e;
  }
  _build(t, e, n, i) {
    const s = n - e + 1;
    let r = this._maxEntries, o;
    if (s <= r)
      return o = dt(t.slice(e, n + 1)), ct(o, this.toBBox), o;
    i || (i = Math.ceil(Math.log(s) / Math.log(r)), r = Math.ceil(s / Math.pow(r, i - 1))), o = dt([]), o.leaf = !1, o.height = i;
    const l = Math.ceil(s / r), h = l * Math.ceil(Math.sqrt(r));
    ye(t, e, n, h, this.compareMinX);
    for (let u = e; u <= n; u += h) {
      const c = Math.min(u + h - 1, n);
      ye(t, u, c, l, this.compareMinY);
      for (let f = u; f <= c; f += l) {
        const d = Math.min(f + l - 1, c);
        o.children.push(this._build(t, f, d, i - 1));
      }
    }
    return ct(o, this.toBBox), o;
  }
  _chooseSubtree(t, e, n, i) {
    for (; i.push(e), !(e.leaf || i.length - 1 === n); ) {
      let s = 1 / 0, r = 1 / 0, o;
      for (let l = 0; l < e.children.length; l++) {
        const h = e.children[l], u = Vt(h), c = bn(t, h) - u;
        c < r ? (r = c, s = u < s ? u : s, o = h) : c === r && u < s && (s = u, o = h);
      }
      e = o || e.children[0];
    }
    return e;
  }
  _insert(t, e, n) {
    const i = n ? t : this.toBBox(t), s = [], r = this._chooseSubtree(i, this.data, e, s);
    for (r.children.push(t), vt(r, i); e >= 0 && s[e].children.length > this._maxEntries; )
      this._split(s, e), e--;
    this._adjustParentBBoxes(i, s, e);
  }
  // split overflowed node into two
  _split(t, e) {
    const n = t[e], i = n.children.length, s = this._minEntries;
    this._chooseSplitAxis(n, s, i);
    const r = this._chooseSplitIndex(n, s, i), o = dt(n.children.splice(r, n.children.length - r));
    o.height = n.height, o.leaf = n.leaf, ct(n, this.toBBox), ct(o, this.toBBox), e ? t[e - 1].children.push(o) : this._splitRoot(n, o);
  }
  _splitRoot(t, e) {
    this.data = dt([t, e]), this.data.height = t.height + 1, this.data.leaf = !1, ct(this.data, this.toBBox);
  }
  _chooseSplitIndex(t, e, n) {
    let i, s = 1 / 0, r = 1 / 0;
    for (let o = e; o <= n - e; o++) {
      const l = Et(t, 0, o, this.toBBox), h = Et(t, o, n, this.toBBox), u = En(l, h), c = Vt(l) + Vt(h);
      u < s ? (s = u, i = o, r = c < r ? c : r) : u === s && c < r && (r = c, i = o);
    }
    return i || n - e;
  }
  // sorts node children by the best axis for split
  _chooseSplitAxis(t, e, n) {
    const i = t.leaf ? this.compareMinX : wn, s = t.leaf ? this.compareMinY : Nn, r = this._allDistMargin(t, e, n, i), o = this._allDistMargin(t, e, n, s);
    r < o && t.children.sort(i);
  }
  // total margin of all possible split distributions where each node is at least m full
  _allDistMargin(t, e, n, i) {
    t.children.sort(i);
    const s = this.toBBox, r = Et(t, 0, e, s), o = Et(t, n - e, n, s);
    let l = Ot(r) + Ot(o);
    for (let h = e; h < n - e; h++) {
      const u = t.children[h];
      vt(r, t.leaf ? s(u) : u), l += Ot(r);
    }
    for (let h = n - e - 1; h >= e; h--) {
      const u = t.children[h];
      vt(o, t.leaf ? s(u) : u), l += Ot(o);
    }
    return l;
  }
  _adjustParentBBoxes(t, e, n) {
    for (let i = n; i >= 0; i--)
      vt(e[i], t);
  }
  _condense(t) {
    for (let e = t.length - 1, n; e >= 0; e--)
      t[e].children.length === 0 ? e > 0 ? (n = t[e - 1].children, n.splice(n.indexOf(t[e]), 1)) : this.clear() : ct(t[e], this.toBBox);
  }
}
function Mn(a, t, e) {
  if (!e) return t.indexOf(a);
  for (let n = 0; n < t.length; n++)
    if (e(a, t[n])) return n;
  return -1;
}
function ct(a, t) {
  Et(a, 0, a.children.length, t, a);
}
function Et(a, t, e, n, i) {
  i || (i = dt(null)), i.minX = 1 / 0, i.minY = 1 / 0, i.maxX = -1 / 0, i.maxY = -1 / 0;
  for (let s = t; s < e; s++) {
    const r = a.children[s];
    vt(i, a.leaf ? n(r) : r);
  }
  return i;
}
function vt(a, t) {
  return a.minX = Math.min(a.minX, t.minX), a.minY = Math.min(a.minY, t.minY), a.maxX = Math.max(a.maxX, t.maxX), a.maxY = Math.max(a.maxY, t.maxY), a;
}
function wn(a, t) {
  return a.minX - t.minX;
}
function Nn(a, t) {
  return a.minY - t.minY;
}
function Vt(a) {
  return (a.maxX - a.minX) * (a.maxY - a.minY);
}
function Ot(a) {
  return a.maxX - a.minX + (a.maxY - a.minY);
}
function bn(a, t) {
  return (Math.max(t.maxX, a.maxX) - Math.min(t.minX, a.minX)) * (Math.max(t.maxY, a.maxY) - Math.min(t.minY, a.minY));
}
function En(a, t) {
  const e = Math.max(a.minX, t.minX), n = Math.max(a.minY, t.minY), i = Math.min(a.maxX, t.maxX), s = Math.min(a.maxY, t.maxY);
  return Math.max(0, i - e) * Math.max(0, s - n);
}
function Kt(a, t) {
  return a.minX <= t.minX && a.minY <= t.minY && t.maxX <= a.maxX && t.maxY <= a.maxY;
}
function kt(a, t) {
  return t.minX <= a.maxX && t.minY <= a.maxY && t.maxX >= a.minX && t.maxY >= a.minY;
}
function dt(a) {
  return {
    children: a,
    height: 1,
    leaf: !0,
    minX: 1 / 0,
    minY: 1 / 0,
    maxX: -1 / 0,
    maxY: -1 / 0
  };
}
function ye(a, t, e, n, i) {
  const s = [t, e];
  for (; s.length; ) {
    if (e = s.pop(), t = s.pop(), e - t <= n) continue;
    const r = t + Math.ceil((e - t) / n / 2) * n;
    Qe(a, r, t, e, i), s.push(t, r, r, e);
  }
}
const St = class St extends B {
  /**
   * Initializes a new instance of the FeatureListRoutable class.
   *
   * @param {Feature<LineString | MultiLineString>[]} features - An array of line string features to initialize the list.
   * @param {Partial<routeOptions>} [options=FeatureListRoutable.defaultOptions] - Optional routing options.
   */
  constructor(t, e = St.defaultOptions) {
    super([]), this._features = /* @__PURE__ */ new Map(), this._graph = new te(), this._rbushTree = new xn(9), this._options = {
      ...St.defaultOptions,
      ...e
    }, t.map((n) => this.add(n));
  }
  /**
   * Adds a line string or multi-line string feature to the list.
   *
   * @param {Feature<LineString | MultiLineString, GeoJsonProperties>} feature - The feature to add.
   * @returns {number} The index of the added feature in the list.
   */
  add(t) {
    let e = -1 / 0;
    return t.geometry.type === "MultiLineString" ? t.geometry.coordinates.forEach((n) => {
      const i = B.feature(
        { type: "LineString", coordinates: n },
        t.properties
      );
      e = this.addLine(i);
    }) : e = this.addLine(t), e;
  }
  /**
   * Adds a line string feature to the feature collection, updating the spatial index tree and graph connections.
   *
   * @param {Feature<LineString>} lineString - The line string feature to add.
   * @param {number[]} connections - An array of connection points along the line.
   * @param {number} useFeatureIndex - The index to use for the feature if provided.
   *
   * @returns {number} The index of the added feature in the collection.
   */
  addLine(t, e = [0, 1 / 0], n) {
    n === void 0 ? n = super.add(t) : this._features.set(n, t);
    const i = n, s = t.geometry.coordinates, r = /* @__PURE__ */ new Map();
    for (let l = 0; l < s.length; l++) {
      const h = this._getMatchingPoints({ featureIdx: i, nodeIdx: l });
      if (h && h.length && (e.push(l), r.set(l, h)), l > 0) {
        const [u, c] = s[l], { x: f, y: d } = V(u, c), [g, p] = s[l - 1], { x, y: m } = V(g, p);
        this._rbushTree.insert({
          minX: Math.min(x, f),
          minY: Math.min(m, d),
          maxX: Math.max(x, f),
          maxY: Math.max(m, d),
          featureIdx: i,
          startIdx: l - 1,
          endIdx: l
        });
      }
    }
    const o = /* @__PURE__ */ new Set();
    return e.forEach((l) => {
      const h = Math.max(Math.min(l, s.length - 1), 0);
      o.add(h);
    }), [...o].sort((l, h) => l - h).forEach((l, h, u) => {
      if (h > 0) {
        const d = { nodeIdx: u[h - 1], featureIdx: i }, g = { nodeIdx: l, featureIdx: i };
        this.addGraphConnection(d, g);
      }
      const c = r.get(l);
      c && c.length && c.forEach((f) => {
        this.addGraphConnection(f, { featureIdx: i, nodeIdx: l });
      });
    }), i;
  }
  splitLineAtPoint(t, e, n) {
    const i = this.getFeature(t);
    if (i) {
      const s = i.geometry.coordinates, r = s.slice(0, e + 1), o = s.slice(e);
      r.push(n), o.unshift(n);
      const l = B.feature({ type: "LineString", coordinates: r }, i.properties), h = B.feature({ type: "LineString", coordinates: o }, i.properties);
      this.removeLine(t);
      const u = this.addLine(l), c = this.addLine(h);
      return [u, c];
    } else
      return !1;
  }
  /**
   * Calculates the length of a line represented by an array of coordinates.
   *
   * @param {LineString['coordinates']} coords - The coordinates of the line.
   *
   * @returns {number} - The length of the line in meters.
   */
  lineLength(t, e = 0, n = 1 / 0) {
    let i = 0;
    for (let s = e + 1; s <= Math.min(t.length, n); s++) {
      const r = t[s - 1], o = t[s] || r;
      i += bt(r, o) * 1e3;
    }
    return i;
  }
  /**
   * Finds and adds graph connections for nearby points within a specified distance.
   *
   * @param {nodeInfoType} testPoint - The point to test and find nearby connections.
   * @param {number} [distanceInMeters=1] - The maximum distance in meters to consider for nearby points.
   * @param {RBush<rbushData>} [tree=this._rbushTree] - The spatial index tree to search for nearby points.
   */
  _getMatchingPoints(t, e = 1, n = this._rbushTree) {
    if (t.node || (t.node = this.getNode(t)), t.node) {
      const i = V(t.node[0], t.node[1]), s = [i.x - e / 2, i.y - e / 2], r = [i.x + e / 2, i.y + e / 2], o = n.search({ minX: s[0], minY: s[1], maxX: r[0], maxY: r[1] }), l = [];
      return o.filter((h) => h.featureIdx !== t.featureIdx).forEach((h) => {
        if (!t.node) return;
        const u = this._features.get(h.featureIdx);
        if (!u) return;
        const c = u.geometry.coordinates[h.startIdx], f = u.geometry.coordinates[h.endIdx];
        this._comparePositions(t.node, f) && l.push({ featureIdx: h.featureIdx, nodeIdx: h.endIdx }), this._comparePositions(t.node, c) && l.push({ featureIdx: h.featureIdx, nodeIdx: h.startIdx });
      }), l;
    }
  }
  /**
   * Compares two positions for equality.
   *
   * @param {Position} coordA - The first position to compare.
   * @param {Position} coordB - The second position to compare.
   * @returns {boolean} `true` if the positions are equal, `false` otherwise.
   */
  _comparePositions(t, e) {
    return t[0] === e[0] && t[1] === e[1];
  }
  getFeatureRoutingInfo(t) {
    const e = typeof t == "number" ? this._features.get(t) : t, { defaultSpeed: n, speedField: i, onewayField: s } = this._options;
    let r = n, o = !1;
    if (e) {
      r = Number(i !== void 0 && e.properties && e.properties[i] || n);
      const l = Array.isArray(this._options.onewayString) ? this._options.onewayString : [this._options.onewayString];
      o = !!(e.properties && s && e.properties[s] && l.includes(e.properties[s]));
    }
    return {
      speed: r,
      isOneWay: o
    };
  }
  speedToCost(t, e, n, i = 0, s = 1 / 0) {
    const r = (u, c) => {
      switch (u) {
        case "kph":
          return c * 1e-3;
        case "mph":
          return c * 6213727366498068e-19;
        case "other":
          return c;
      }
    }, o = this._features.get(n), l = this.lineLength((o == null ? void 0 : o.geometry.coordinates) || [], i, s);
    return r(e, t) * l;
  }
  /**
   * Adds a new node to the graph and updates adjacent edges.
   *
   * @param {nodeInfoType} nodeInfo - Information about the node to be added.
   */
  _addNode(t) {
    this._graph.addNode(t);
    const e = this._graph._featureLookup.get(t.featureIdx);
    if (e) {
      const n = t.nodeIdx, i = Object.keys(e).map((o) => this._graph.nodeNameToFeatureNode(o).nodeIdx).sort((o, l) => o - l);
      let s, r;
      if (i.forEach((o, l, h) => {
        o === n ? (s = h[l - 1], r = h[l + 1]) : o < n ? s = o : o > n && r === void 0 && (r = o);
      }), r !== void 0 && s !== void 0) {
        const o = { featureIdx: t.featureIdx, nodeIdx: r }, l = { featureIdx: t.featureIdx, nodeIdx: s };
        this._graph.getEdge(o, l) !== void 0 && (this._graph.removeEdge(o, l), this.addGraphConnection(o, t), this.addGraphConnection(t, l)), this._graph.getEdge(l, o) !== void 0 && (this._graph.removeEdge(l, o), this.addGraphConnection(l, t), this.addGraphConnection(t, o));
      }
    }
  }
  /**
   * Adds a connection between two nodes in the graph.
   *
   * @param {nodeInfoType} startNode - The starting node.
   * @param {nodeInfoType} endNode - The ending node.
   */
  addGraphConnection(t, e) {
    this._addNode(t), this._addNode(e);
    const { isOneWay: n, speed: i } = this.getFeatureRoutingInfo(t.featureIdx);
    let s = 0;
    t.featureIdx === e.featureIdx && (s = this.speedToCost(i, this._options.speedUnits, t.featureIdx, t.nodeIdx, e.nodeIdx)), this._graph.addEdge(t, e, s), n || this._graph.addEdge(e, t, s);
  }
  /**
    * Removes a feature from the list and related indexes.
    *
    * @param {number} featureIdx - The index of the feature to remove.
    */
  remove(t) {
    this.removeLine(t), super.remove(t);
  }
  /**
   * Removes a line feature from the collection and associated data structures.
   *
   * @param {number} featureIdx - The index of the line feature to be removed.
   */
  removeLine(t) {
    const e = this._features.get(t);
    if (e) {
      const n = e.geometry.coordinates;
      for (let i = 0; i < n.length; i++) {
        const [s, r] = n[i], { x: o, y: l } = V(s, r);
        if (i > 0) {
          const [h, u] = n[i - 1], { x: c, y: f } = V(h, u), d = {
            minX: Math.min(c, o),
            minY: Math.min(f, l),
            maxX: Math.max(c, o),
            maxY: Math.max(f, l)
          };
          this._rbushTree.search(d).filter((p) => p.featureIdx === t).forEach((p) => this._rbushTree.remove(p));
        }
      }
      this._graph.removeFeature(t);
    }
  }
  /**
   * Adds a new node to a feature at the specified index.
   *
   * @param {number} featureIdx - The index of the feature to add the node to.
   * @param {number} newNodeIdx - The index where the new node should be inserted.
   * @param {Position} node - The coordinates of the new node.
   * @param {Position} useNewFeatureIdx - Forces the updated feature to have a new featureIdx, used for tests.
   *
   * @returns {number | undefined} - The featureIdx of the new feature if successful, undefined otherwise.
   */
  addNodeToFeature(t, e, n, i = !1) {
    const s = [], r = this._features.get(t);
    if (r) {
      this.remove(t);
      for (let l = 0; l <= r.geometry.coordinates.length; l++)
        l < e ? s.push(r.geometry.coordinates[l]) : s.push(l === e ? n : r.geometry.coordinates[l - 1]);
      const o = {
        ...r,
        geometry: {
          ...r.geometry,
          coordinates: s
        }
      };
      return this.addLine(o, [0, e, 1 / 0], i ? void 0 : t);
    }
  }
  getNode(t) {
    var n;
    let e;
    if (typeof t == "string" ? e = this._graph.nodeNameToFeatureNode(t) : e = t, e)
      return (n = this._features.get(e.featureIdx)) == null ? void 0 : n.geometry.coordinates[e.nodeIdx];
  }
  /**
   * Calculates the route between two nodes and returns it as a GeoJSON LineString.
   *
   * @param {nodeInfoType} nodeA - The starting node.
   * @param {nodeInfoType} nodeB - The ending node.
   *
   * @returns {Feature<LineString>} - A GeoJSON LineString representing the route.
   */
  routeNodes(t, e) {
    const n = this._graph.featureNodeToNodeName(t.featureIdx, t.nodeIdx), i = this._graph.featureNodeToNodeName(e.featureIdx, e.nodeIdx), s = this.routeAStar(n, i);
    if (!s)
      throw new Error("Count not find path");
    const r = [];
    let o = 0, l = 0;
    const h = (c) => {
      if (!this._comparePositions(c, r[r.length - 1]))
        return r.push(c);
    };
    for (let c = 0; c < s.length; c++) {
      const f = s[c], d = c > 0 && s[c - 1];
      if (f) {
        const g = this.getNode(f);
        if (g)
          if (!d)
            r.push(g);
          else {
            const p = this._graph.nodeNameToFeatureNode(f), x = this._graph.nodeNameToFeatureNode(d), m = this.getNode(d);
            if (m) {
              if (p.featureIdx === x.featureIdx) {
                const M = p.nodeIdx > x.nodeIdx ? 1 : -1, w = x.nodeIdx + M, N = p.nodeIdx;
                for (let E = w; M > 0 ? E < N : E > N; E += M) {
                  const P = this.getNode({ nodeIdx: E, featureIdx: p.featureIdx });
                  P && h(P);
                }
              }
              o += bt(m, g) * 1e3, l += this._graph.getEdge(p, x) || 0, h(g);
            }
          }
      }
    }
    return {
      type: "Feature",
      properties: {
        distance: o,
        cost: l,
        meanCost: o === 0 ? 0 : l / o
      },
      geometry: {
        type: "LineString",
        coordinates: r
      }
    };
  }
  /**
   * Gets the closest intersection point to a given click point and provides from info about the feature it should be part of.
   *
   * @param {Position} clickPoint4326 - The click point in WGS84 coordinates (longitude, latitude).
   * @param {number} toleranceInMeters - The tolerance in web mercator meters for identifying the closest point (default is 0).
   *
   * @returns {intersectionPointInfo | undefined} - Information about the closest intersection point or undefined if not found.
   */
  getClosestPointInfo(t, e = 0) {
    const n = V(t[0], t[1]), i = {
      minX: n.x - e / 2,
      minY: n.y - e / 2,
      maxX: n.x + e / 2,
      maxY: n.y + e / 2
    };
    return this._rbushTree.search(i).map((o) => {
      const l = this.getFeature(o.featureIdx), h = {
        nearestPoint: void 0,
        nearestPointWGS84: void 0,
        distanceInMeters: 1 / 0,
        featureIdx: o.featureIdx,
        startNodeIdx: o.startIdx,
        endNodeIdx: o.endIdx
      }, u = l.geometry.coordinates[o.startIdx], c = l.geometry.coordinates[o.endIdx], f = V(u[0], u[1]), d = V(c[0], c[1]);
      if (l) {
        const g = ge(
          [n.x, n.y],
          [[f.x, f.y], [d.x, d.y]],
          "euclidean"
        ), p = Gt(g[0], g[1]);
        return {
          ...h,
          nearestPoint: g,
          nearestPointWGS84: [p.lng, p.lat],
          distanceInMeters: mt([n.x, n.y], g)
        };
      } else
        return h;
    }).sort((o, l) => o.distanceInMeters - l.distanceInMeters)[0];
  }
  /**
    * Adds a point on a line feature at the closest intersection point to a given click point.
    *
    * @param {Position} clickPoint4326 - The click point in WGS 84 coordinates.
    * @param {number} toleranceInMeters - Tolerance for finding the closest intersection point in meters (default is 0).
    * @returns {Position | undefined} - The position of the added point or undefined if no intersection point is found.
    */
  addPointOnLine(t, e = 0) {
    const n = this.getClosestPointInfo(t, e);
    return !n || !n.nearestPointWGS84 ? void 0 : this.addNodeToFeature(n.featureIdx, n.endNodeIdx, n.nearestPointWGS84) ? n.nearestPointWGS84 : void 0;
  }
  /**
  * Routes between two points on a map.
  *
  * @param {Position} start4326 - The starting point in WGS 84 coordinates.
  * @param {Position} end4326 - The ending point in WGS 84 coordinates.
  * @returns {Route} - The route between the two points.
  * @throws {Error} Throws an error if start or end points are not found or if there's an error with the nodes.
  */
  routePoints(t, e, n = 0) {
    const i = this.getClosestPointInfo(t, n), s = this.getClosestPointInfo(e, n), r = (h, u) => {
      let c = -1;
      const f = this.getFeature(h.featureIdx), d = f.geometry.coordinates[h.startNodeIdx];
      this._comparePositions(u, d) && (c = h.startNodeIdx);
      const g = f.geometry.coordinates[h.endNodeIdx];
      return c < 0 && this._comparePositions(u, g) && (c = h.endNodeIdx), c === -1 ? void 0 : {
        featureIdx: h.featureIdx,
        nodeIdx: c
      };
    };
    if (!i || !s)
      throw new Error(`Cannot find ${i ? "end" : "start"} node`);
    const o = r(i, t), l = r(s, e);
    if (!o || !l)
      throw new Error(`Error with ${o ? "end" : "start"} node`);
    return this.routeNodes(o, l);
  }
  routePoint2Point(t, e, n = 0) {
    const i = this.getClosestPointInfo(t, n), s = this.getClosestPointInfo(e, n);
    if (!i || !s)
      throw new Error("Could not find start or end points");
    const r = this.splitLineAtPoint(i.featureIdx, i.startNodeIdx, t), o = this.splitLineAtPoint(s.featureIdx, s.startNodeIdx, e);
    if (!r || !o)
      throw new Error("Could not split lines");
    const l = { featureIdx: r[1], nodeIdx: 0 }, h = { featureIdx: o[1], nodeIdx: 0 };
    return this.routeNodes(l, h);
  }
  routeAStar(t, e) {
    const n = this.getNode(t), i = this.getNode(e);
    if (!n || !i) return null;
    const s = [{
      name: t,
      cost: 0,
      heuristic: bt(n, i)
    }], r = [], o = this._graph._graph;
    for (; s.length > 0; ) {
      s.sort((h, u) => h.cost + h.heuristic - (u.cost + u.heuristic));
      const l = s.shift();
      if (r.push(l), l.name === e) {
        let h = [], u = l;
        for (; u; )
          h.unshift(u.name), u = u.parent;
        return h;
      }
      typeof window !== void 0 && (window.graph = o);
      for (const h in o[l.name]) {
        if (r.some((p) => p.name === h)) continue;
        const u = l.cost + o[l.name][h], c = this.getNode(h), f = 1 / 0;
        c && bt(c, i);
        const d = {
          name: h,
          cost: u,
          heuristic: f,
          parent: l
        }, g = s.find((p) => p.name === h);
        g ? g && u < g.cost && (g.cost = u, g.parent = l) : s.push(d);
      }
    }
    return null;
  }
};
St.defaultOptions = {
  speedField: void 0,
  speedUnits: "mph",
  onewayField: void 0,
  onewayString: void 0,
  defaultSpeed: 25
};
let xe = St;
/**
 * splaytree v3.1.2
 * Fast Splay tree for Node and browser
 *
 * @author Alexander Milevski <info@w8r.name>
 * @license MIT
 * @preserve
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
function vn(a, t) {
  var e = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, r;
  return r = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (r[Symbol.iterator] = function() {
    return this;
  }), r;
  function o(h) {
    return function(u) {
      return l([h, u]);
    };
  }
  function l(h) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (n = 1, i && (s = h[0] & 2 ? i.return : h[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, h[1])).done) return s;
      switch (i = 0, s && (h = [h[0] & 2, s.value]), h[0]) {
        case 0:
        case 1:
          s = h;
          break;
        case 4:
          return e.label++, { value: h[1], done: !1 };
        case 5:
          e.label++, i = h[1], h = [0];
          continue;
        case 7:
          h = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (s = e.trys, !(s = s.length > 0 && s[s.length - 1]) && (h[0] === 6 || h[0] === 2)) {
            e = 0;
            continue;
          }
          if (h[0] === 3 && (!s || h[1] > s[0] && h[1] < s[3])) {
            e.label = h[1];
            break;
          }
          if (h[0] === 6 && e.label < s[1]) {
            e.label = s[1], s = h;
            break;
          }
          if (s && e.label < s[2]) {
            e.label = s[2], e.ops.push(h);
            break;
          }
          s[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      h = t.call(a, e);
    } catch (u) {
      h = [6, u], i = 0;
    } finally {
      n = s = 0;
    }
    if (h[0] & 5) throw h[1];
    return { value: h[0] ? h[1] : void 0, done: !0 };
  }
}
var ot = (
  /** @class */
  /* @__PURE__ */ function() {
    function a(t, e) {
      this.next = null, this.key = t, this.data = e, this.left = null, this.right = null;
    }
    return a;
  }()
);
function Sn(a, t) {
  return a > t ? 1 : a < t ? -1 : 0;
}
function et(a, t, e) {
  for (var n = new ot(null, null), i = n, s = n; ; ) {
    var r = e(a, t.key);
    if (r < 0) {
      if (t.left === null)
        break;
      if (e(a, t.left.key) < 0) {
        var o = t.left;
        if (t.left = o.right, o.right = t, t = o, t.left === null)
          break;
      }
      s.left = t, s = t, t = t.left;
    } else if (r > 0) {
      if (t.right === null)
        break;
      if (e(a, t.right.key) > 0) {
        var o = t.right;
        if (t.right = o.left, o.left = t, t = o, t.right === null)
          break;
      }
      i.right = t, i = t, t = t.right;
    } else
      break;
  }
  return i.right = t.left, s.left = t.right, t.left = n.right, t.right = n.left, t;
}
function Ht(a, t, e, n) {
  var i = new ot(a, t);
  if (e === null)
    return i.left = i.right = null, i;
  e = et(a, e, n);
  var s = n(a, e.key);
  return s < 0 ? (i.left = e.left, i.right = e, e.left = null) : s >= 0 && (i.right = e.right, i.left = e, e.right = null), i;
}
function Me(a, t, e) {
  var n = null, i = null;
  if (t) {
    t = et(a, t, e);
    var s = e(t.key, a);
    s === 0 ? (n = t.left, i = t.right) : s < 0 ? (i = t.right, t.right = null, n = t) : (n = t.left, t.left = null, i = t);
  }
  return { left: n, right: i };
}
function In(a, t, e) {
  return t === null ? a : (a === null || (t = et(a.key, t, e), t.left = a), t);
}
function ee(a, t, e, n, i) {
  if (a) {
    n("" + t + (e ? "└── " : "├── ") + i(a) + `
`);
    var s = t + (e ? "    " : "│   ");
    a.left && ee(a.left, s, !1, n, i), a.right && ee(a.right, s, !0, n, i);
  }
}
var pe = (
  /** @class */
  function() {
    function a(t) {
      t === void 0 && (t = Sn), this._root = null, this._size = 0, this._comparator = t;
    }
    return a.prototype.insert = function(t, e) {
      return this._size++, this._root = Ht(t, e, this._root, this._comparator);
    }, a.prototype.add = function(t, e) {
      var n = new ot(t, e);
      this._root === null && (n.left = n.right = null, this._size++, this._root = n);
      var i = this._comparator, s = et(t, this._root, i), r = i(t, s.key);
      return r === 0 ? this._root = s : (r < 0 ? (n.left = s.left, n.right = s, s.left = null) : r > 0 && (n.right = s.right, n.left = s, s.right = null), this._size++, this._root = n), this._root;
    }, a.prototype.remove = function(t) {
      this._root = this._remove(t, this._root, this._comparator);
    }, a.prototype._remove = function(t, e, n) {
      var i;
      if (e === null)
        return null;
      e = et(t, e, n);
      var s = n(t, e.key);
      return s === 0 ? (e.left === null ? i = e.right : (i = et(t, e.left, n), i.right = e.right), this._size--, i) : e;
    }, a.prototype.pop = function() {
      var t = this._root;
      if (t) {
        for (; t.left; )
          t = t.left;
        return this._root = et(t.key, this._root, this._comparator), this._root = this._remove(t.key, this._root, this._comparator), { key: t.key, data: t.data };
      }
      return null;
    }, a.prototype.findStatic = function(t) {
      for (var e = this._root, n = this._comparator; e; ) {
        var i = n(t, e.key);
        if (i === 0)
          return e;
        i < 0 ? e = e.left : e = e.right;
      }
      return null;
    }, a.prototype.find = function(t) {
      return this._root && (this._root = et(t, this._root, this._comparator), this._comparator(t, this._root.key) !== 0) ? null : this._root;
    }, a.prototype.contains = function(t) {
      for (var e = this._root, n = this._comparator; e; ) {
        var i = n(t, e.key);
        if (i === 0)
          return !0;
        i < 0 ? e = e.left : e = e.right;
      }
      return !1;
    }, a.prototype.forEach = function(t, e) {
      for (var n = this._root, i = [], s = !1; !s; )
        n !== null ? (i.push(n), n = n.left) : i.length !== 0 ? (n = i.pop(), t.call(e, n), n = n.right) : s = !0;
      return this;
    }, a.prototype.range = function(t, e, n, i) {
      for (var s = [], r = this._comparator, o = this._root, l; s.length !== 0 || o; )
        if (o)
          s.push(o), o = o.left;
        else {
          if (o = s.pop(), l = r(o.key, e), l > 0)
            break;
          if (r(o.key, t) >= 0 && n.call(i, o))
            return this;
          o = o.right;
        }
      return this;
    }, a.prototype.keys = function() {
      var t = [];
      return this.forEach(function(e) {
        var n = e.key;
        return t.push(n);
      }), t;
    }, a.prototype.values = function() {
      var t = [];
      return this.forEach(function(e) {
        var n = e.data;
        return t.push(n);
      }), t;
    }, a.prototype.min = function() {
      return this._root ? this.minNode(this._root).key : null;
    }, a.prototype.max = function() {
      return this._root ? this.maxNode(this._root).key : null;
    }, a.prototype.minNode = function(t) {
      if (t === void 0 && (t = this._root), t)
        for (; t.left; )
          t = t.left;
      return t;
    }, a.prototype.maxNode = function(t) {
      if (t === void 0 && (t = this._root), t)
        for (; t.right; )
          t = t.right;
      return t;
    }, a.prototype.at = function(t) {
      for (var e = this._root, n = !1, i = 0, s = []; !n; )
        if (e)
          s.push(e), e = e.left;
        else if (s.length > 0) {
          if (e = s.pop(), i === t)
            return e;
          i++, e = e.right;
        } else
          n = !0;
      return null;
    }, a.prototype.next = function(t) {
      var e = this._root, n = null;
      if (t.right) {
        for (n = t.right; n.left; )
          n = n.left;
        return n;
      }
      for (var i = this._comparator; e; ) {
        var s = i(t.key, e.key);
        if (s === 0)
          break;
        s < 0 ? (n = e, e = e.left) : e = e.right;
      }
      return n;
    }, a.prototype.prev = function(t) {
      var e = this._root, n = null;
      if (t.left !== null) {
        for (n = t.left; n.right; )
          n = n.right;
        return n;
      }
      for (var i = this._comparator; e; ) {
        var s = i(t.key, e.key);
        if (s === 0)
          break;
        s < 0 ? e = e.left : (n = e, e = e.right);
      }
      return n;
    }, a.prototype.clear = function() {
      return this._root = null, this._size = 0, this;
    }, a.prototype.toList = function() {
      return _n(this._root);
    }, a.prototype.load = function(t, e, n) {
      e === void 0 && (e = []), n === void 0 && (n = !1);
      var i = t.length, s = this._comparator;
      if (n && se(t, e, 0, i - 1, s), this._root === null)
        this._root = ne(t, e, 0, i), this._size = i;
      else {
        var r = Tn(this.toList(), Pn(t, e), s);
        i = this._size + i, this._root = ie({ head: r }, 0, i);
      }
      return this;
    }, a.prototype.isEmpty = function() {
      return this._root === null;
    }, Object.defineProperty(a.prototype, "size", {
      get: function() {
        return this._size;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(a.prototype, "root", {
      get: function() {
        return this._root;
      },
      enumerable: !0,
      configurable: !0
    }), a.prototype.toString = function(t) {
      t === void 0 && (t = function(n) {
        return String(n.key);
      });
      var e = [];
      return ee(this._root, "", !0, function(n) {
        return e.push(n);
      }, t), e.join("");
    }, a.prototype.update = function(t, e, n) {
      var i = this._comparator, s = Me(t, this._root, i), r = s.left, o = s.right;
      i(t, e) < 0 ? o = Ht(e, n, o, i) : r = Ht(e, n, r, i), this._root = In(r, o, i);
    }, a.prototype.split = function(t) {
      return Me(t, this._root, this._comparator);
    }, a.prototype[Symbol.iterator] = function() {
      var t, e, n;
      return vn(this, function(i) {
        switch (i.label) {
          case 0:
            t = this._root, e = [], n = !1, i.label = 1;
          case 1:
            return n ? [3, 6] : t === null ? [3, 2] : (e.push(t), t = t.left, [3, 5]);
          case 2:
            return e.length === 0 ? [3, 4] : (t = e.pop(), [4, t]);
          case 3:
            return i.sent(), t = t.right, [3, 5];
          case 4:
            n = !0, i.label = 5;
          case 5:
            return [3, 1];
          case 6:
            return [
              2
              /*return*/
            ];
        }
      });
    }, a;
  }()
);
function ne(a, t, e, n) {
  var i = n - e;
  if (i > 0) {
    var s = e + Math.floor(i / 2), r = a[s], o = t[s], l = new ot(r, o);
    return l.left = ne(a, t, e, s), l.right = ne(a, t, s + 1, n), l;
  }
  return null;
}
function Pn(a, t) {
  for (var e = new ot(null, null), n = e, i = 0; i < a.length; i++)
    n = n.next = new ot(a[i], t[i]);
  return n.next = null, e.next;
}
function _n(a) {
  for (var t = a, e = [], n = !1, i = new ot(null, null), s = i; !n; )
    t ? (e.push(t), t = t.left) : e.length > 0 ? (t = s = s.next = e.pop(), t = t.right) : n = !0;
  return s.next = null, i.next;
}
function ie(a, t, e) {
  var n = e - t;
  if (n > 0) {
    var i = t + Math.floor(n / 2), s = ie(a, t, i), r = a.head;
    return r.left = s, a.head = a.head.next, r.right = ie(a, i + 1, e), r;
  }
  return null;
}
function Tn(a, t, e) {
  for (var n = new ot(null, null), i = n, s = a, r = t; s !== null && r !== null; )
    e(s.key, r.key) < 0 ? (i.next = s, s = s.next) : (i.next = r, r = r.next), i = i.next;
  return s !== null ? i.next = s : r !== null && (i.next = r), n.next;
}
function se(a, t, e, n, i) {
  if (!(e >= n)) {
    for (var s = a[e + n >> 1], r = e - 1, o = n + 1; ; ) {
      do
        r++;
      while (i(a[r], s) < 0);
      do
        o--;
      while (i(a[o], s) > 0);
      if (r >= o)
        break;
      var l = a[r];
      a[r] = a[o], a[o] = l, l = t[r], t[r] = t[o], t[o] = l;
    }
    se(a, t, e, o, i), se(a, t, o + 1, n, i);
  }
}
const tt = 11102230246251565e-32, G = 134217729, Rn = (3 + 8 * tt) * tt;
function Zt(a, t, e, n, i) {
  let s, r, o, l, h = t[0], u = n[0], c = 0, f = 0;
  u > h == u > -h ? (s = h, h = t[++c]) : (s = u, u = n[++f]);
  let d = 0;
  if (c < a && f < e)
    for (u > h == u > -h ? (r = h + s, o = s - (r - h), h = t[++c]) : (r = u + s, o = s - (r - u), u = n[++f]), s = r, o !== 0 && (i[d++] = o); c < a && f < e; )
      u > h == u > -h ? (r = s + h, l = r - s, o = s - (r - l) + (h - l), h = t[++c]) : (r = s + u, l = r - s, o = s - (r - l) + (u - l), u = n[++f]), s = r, o !== 0 && (i[d++] = o);
  for (; c < a; )
    r = s + h, l = r - s, o = s - (r - l) + (h - l), h = t[++c], s = r, o !== 0 && (i[d++] = o);
  for (; f < e; )
    r = s + u, l = r - s, o = s - (r - l) + (u - l), u = n[++f], s = r, o !== 0 && (i[d++] = o);
  return (s !== 0 || d === 0) && (i[d++] = s), d;
}
function Ln(a, t) {
  let e = t[0];
  for (let n = 1; n < a; n++) e += t[n];
  return e;
}
function Lt(a) {
  return new Float64Array(a);
}
const Fn = (3 + 16 * tt) * tt, On = (2 + 12 * tt) * tt, kn = (9 + 64 * tt) * tt * tt, ut = Lt(4), we = Lt(8), Ne = Lt(12), be = Lt(16), X = Lt(4);
function Bn(a, t, e, n, i, s, r) {
  let o, l, h, u, c, f, d, g, p, x, m, M, w, N, E, P, T, v;
  const _ = a - i, L = e - i, R = t - s, S = n - s;
  N = _ * S, f = G * _, d = f - (f - _), g = _ - d, f = G * S, p = f - (f - S), x = S - p, E = g * x - (N - d * p - g * p - d * x), P = R * L, f = G * R, d = f - (f - R), g = R - d, f = G * L, p = f - (f - L), x = L - p, T = g * x - (P - d * p - g * p - d * x), m = E - T, c = E - m, ut[0] = E - (m + c) + (c - T), M = N + m, c = M - N, w = N - (M - c) + (m - c), m = w - P, c = w - m, ut[1] = w - (m + c) + (c - P), v = M + m, c = v - M, ut[2] = M - (v - c) + (m - c), ut[3] = v;
  let O = Ln(4, ut), A = On * r;
  if (O >= A || -O >= A || (c = a - _, o = a - (_ + c) + (c - i), c = e - L, h = e - (L + c) + (c - i), c = t - R, l = t - (R + c) + (c - s), c = n - S, u = n - (S + c) + (c - s), o === 0 && l === 0 && h === 0 && u === 0) || (A = kn * r + Rn * Math.abs(O), O += _ * u + S * o - (R * h + L * l), O >= A || -O >= A)) return O;
  N = o * S, f = G * o, d = f - (f - o), g = o - d, f = G * S, p = f - (f - S), x = S - p, E = g * x - (N - d * p - g * p - d * x), P = l * L, f = G * l, d = f - (f - l), g = l - d, f = G * L, p = f - (f - L), x = L - p, T = g * x - (P - d * p - g * p - d * x), m = E - T, c = E - m, X[0] = E - (m + c) + (c - T), M = N + m, c = M - N, w = N - (M - c) + (m - c), m = w - P, c = w - m, X[1] = w - (m + c) + (c - P), v = M + m, c = v - M, X[2] = M - (v - c) + (m - c), X[3] = v;
  const k = Zt(4, ut, 4, X, we);
  N = _ * u, f = G * _, d = f - (f - _), g = _ - d, f = G * u, p = f - (f - u), x = u - p, E = g * x - (N - d * p - g * p - d * x), P = R * h, f = G * R, d = f - (f - R), g = R - d, f = G * h, p = f - (f - h), x = h - p, T = g * x - (P - d * p - g * p - d * x), m = E - T, c = E - m, X[0] = E - (m + c) + (c - T), M = N + m, c = M - N, w = N - (M - c) + (m - c), m = w - P, c = w - m, X[1] = w - (m + c) + (c - P), v = M + m, c = v - M, X[2] = M - (v - c) + (m - c), X[3] = v;
  const Y = Zt(k, we, 4, X, Ne);
  N = o * u, f = G * o, d = f - (f - o), g = o - d, f = G * u, p = f - (f - u), x = u - p, E = g * x - (N - d * p - g * p - d * x), P = l * h, f = G * l, d = f - (f - l), g = l - d, f = G * h, p = f - (f - h), x = h - p, T = g * x - (P - d * p - g * p - d * x), m = E - T, c = E - m, X[0] = E - (m + c) + (c - T), M = N + m, c = M - N, w = N - (M - c) + (m - c), m = w - P, c = w - m, X[1] = w - (m + c) + (c - P), v = M + m, c = v - M, X[2] = M - (v - c) + (m - c), X[3] = v;
  const $ = Zt(Y, Ne, 4, X, be);
  return be[$ - 1];
}
function An(a, t, e, n, i, s) {
  const r = (t - s) * (e - i), o = (a - i) * (n - s), l = r - o, h = Math.abs(r + o);
  return Math.abs(l) >= Fn * h ? l : -Bn(a, t, e, n, i, s, h);
}
const Nt = (a, t) => a.ll.x <= t.x && t.x <= a.ur.x && a.ll.y <= t.y && t.y <= a.ur.y, oe = (a, t) => {
  if (t.ur.x < a.ll.x || a.ur.x < t.ll.x || t.ur.y < a.ll.y || a.ur.y < t.ll.y) return null;
  const e = a.ll.x < t.ll.x ? t.ll.x : a.ll.x, n = a.ur.x < t.ur.x ? a.ur.x : t.ur.x, i = a.ll.y < t.ll.y ? t.ll.y : a.ll.y, s = a.ur.y < t.ur.y ? a.ur.y : t.ur.y;
  return {
    ll: {
      x: e,
      y: i
    },
    ur: {
      x: n,
      y: s
    }
  };
};
let it = Number.EPSILON;
it === void 0 && (it = Math.pow(2, -52));
const $n = it * it, Ee = (a, t) => {
  if (-it < a && a < it && -it < t && t < it)
    return 0;
  const e = a - t;
  return e * e < $n * a * t ? 0 : a < t ? -1 : 1;
};
class Cn {
  constructor() {
    this.reset();
  }
  reset() {
    this.xRounder = new ve(), this.yRounder = new ve();
  }
  round(t, e) {
    return {
      x: this.xRounder.round(t),
      y: this.yRounder.round(e)
    };
  }
}
class ve {
  constructor() {
    this.tree = new pe(), this.round(0);
  }
  // Note: this can rounds input values backwards or forwards.
  //       You might ask, why not restrict this to just rounding
  //       forwards? Wouldn't that allow left endpoints to always
  //       remain left endpoints during splitting (never change to
  //       right). No - it wouldn't, because we snap intersections
  //       to endpoints (to establish independence from the segment
  //       angle for t-intersections).
  round(t) {
    const e = this.tree.add(t), n = this.tree.prev(e);
    if (n !== null && Ee(e.key, n.key) === 0)
      return this.tree.remove(t), n.key;
    const i = this.tree.next(e);
    return i !== null && Ee(e.key, i.key) === 0 ? (this.tree.remove(t), i.key) : t;
  }
}
const Tt = new Cn(), Bt = (a, t) => a.x * t.y - a.y * t.x, Ve = (a, t) => a.x * t.x + a.y * t.y, Se = (a, t, e) => {
  const n = An(a.x, a.y, t.x, t.y, e.x, e.y);
  return n > 0 ? -1 : n < 0 ? 1 : 0;
}, $t = (a) => Math.sqrt(Ve(a, a)), jn = (a, t, e) => {
  const n = {
    x: t.x - a.x,
    y: t.y - a.y
  }, i = {
    x: e.x - a.x,
    y: e.y - a.y
  };
  return Bt(i, n) / $t(i) / $t(n);
}, Gn = (a, t, e) => {
  const n = {
    x: t.x - a.x,
    y: t.y - a.y
  }, i = {
    x: e.x - a.x,
    y: e.y - a.y
  };
  return Ve(i, n) / $t(i) / $t(n);
}, Ie = (a, t, e) => t.y === 0 ? null : {
  x: a.x + t.x / t.y * (e - a.y),
  y: e
}, Pe = (a, t, e) => t.x === 0 ? null : {
  x: e,
  y: a.y + t.y / t.x * (e - a.x)
}, Xn = (a, t, e, n) => {
  if (t.x === 0) return Pe(e, n, a.x);
  if (n.x === 0) return Pe(a, t, e.x);
  if (t.y === 0) return Ie(e, n, a.y);
  if (n.y === 0) return Ie(a, t, e.y);
  const i = Bt(t, n);
  if (i == 0) return null;
  const s = {
    x: e.x - a.x,
    y: e.y - a.y
  }, r = Bt(s, t) / i, o = Bt(s, n) / i, l = a.x + o * t.x, h = e.x + r * n.x, u = a.y + o * t.y, c = e.y + r * n.y, f = (l + h) / 2, d = (u + c) / 2;
  return {
    x: f,
    y: d
  };
};
class U {
  // for ordering sweep events in the sweep event queue
  static compare(t, e) {
    const n = U.comparePoints(t.point, e.point);
    return n !== 0 ? n : (t.point !== e.point && t.link(e), t.isLeft !== e.isLeft ? t.isLeft ? 1 : -1 : st.compare(t.segment, e.segment));
  }
  // for ordering points in sweep line order
  static comparePoints(t, e) {
    return t.x < e.x ? -1 : t.x > e.x ? 1 : t.y < e.y ? -1 : t.y > e.y ? 1 : 0;
  }
  // Warning: 'point' input will be modified and re-used (for performance)
  constructor(t, e) {
    t.events === void 0 ? t.events = [this] : t.events.push(this), this.point = t, this.isLeft = e;
  }
  link(t) {
    if (t.point === this.point)
      throw new Error("Tried to link already linked events");
    const e = t.point.events;
    for (let n = 0, i = e.length; n < i; n++) {
      const s = e[n];
      this.point.events.push(s), s.point = this.point;
    }
    this.checkForConsuming();
  }
  /* Do a pass over our linked events and check to see if any pair
   * of segments match, and should be consumed. */
  checkForConsuming() {
    const t = this.point.events.length;
    for (let e = 0; e < t; e++) {
      const n = this.point.events[e];
      if (n.segment.consumedBy === void 0)
        for (let i = e + 1; i < t; i++) {
          const s = this.point.events[i];
          s.consumedBy === void 0 && n.otherSE.point.events === s.otherSE.point.events && n.segment.consume(s.segment);
        }
    }
  }
  getAvailableLinkedEvents() {
    const t = [];
    for (let e = 0, n = this.point.events.length; e < n; e++) {
      const i = this.point.events[e];
      i !== this && !i.segment.ringOut && i.segment.isInResult() && t.push(i);
    }
    return t;
  }
  /**
   * Returns a comparator function for sorting linked events that will
   * favor the event that will give us the smallest left-side angle.
   * All ring construction starts as low as possible heading to the right,
   * so by always turning left as sharp as possible we'll get polygons
   * without uncessary loops & holes.
   *
   * The comparator function has a compute cache such that it avoids
   * re-computing already-computed values.
   */
  getLeftmostComparator(t) {
    const e = /* @__PURE__ */ new Map(), n = (i) => {
      const s = i.otherSE;
      e.set(i, {
        sine: jn(this.point, t.point, s.point),
        cosine: Gn(this.point, t.point, s.point)
      });
    };
    return (i, s) => {
      e.has(i) || n(i), e.has(s) || n(s);
      const {
        sine: r,
        cosine: o
      } = e.get(i), {
        sine: l,
        cosine: h
      } = e.get(s);
      return r >= 0 && l >= 0 ? o < h ? 1 : o > h ? -1 : 0 : r < 0 && l < 0 ? o < h ? -1 : o > h ? 1 : 0 : l < r ? -1 : l > r ? 1 : 0;
    };
  }
}
let zn = 0;
class st {
  /* This compare() function is for ordering segments in the sweep
   * line tree, and does so according to the following criteria:
   *
   * Consider the vertical line that lies an infinestimal step to the
   * right of the right-more of the two left endpoints of the input
   * segments. Imagine slowly moving a point up from negative infinity
   * in the increasing y direction. Which of the two segments will that
   * point intersect first? That segment comes 'before' the other one.
   *
   * If neither segment would be intersected by such a line, (if one
   * or more of the segments are vertical) then the line to be considered
   * is directly on the right-more of the two left inputs.
   */
  static compare(t, e) {
    const n = t.leftSE.point.x, i = e.leftSE.point.x, s = t.rightSE.point.x, r = e.rightSE.point.x;
    if (r < n) return 1;
    if (s < i) return -1;
    const o = t.leftSE.point.y, l = e.leftSE.point.y, h = t.rightSE.point.y, u = e.rightSE.point.y;
    if (n < i) {
      if (l < o && l < h) return 1;
      if (l > o && l > h) return -1;
      const c = t.comparePoint(e.leftSE.point);
      if (c < 0) return 1;
      if (c > 0) return -1;
      const f = e.comparePoint(t.rightSE.point);
      return f !== 0 ? f : -1;
    }
    if (n > i) {
      if (o < l && o < u) return -1;
      if (o > l && o > u) return 1;
      const c = e.comparePoint(t.leftSE.point);
      if (c !== 0) return c;
      const f = t.comparePoint(e.rightSE.point);
      return f < 0 ? 1 : f > 0 ? -1 : 1;
    }
    if (o < l) return -1;
    if (o > l) return 1;
    if (s < r) {
      const c = e.comparePoint(t.rightSE.point);
      if (c !== 0) return c;
    }
    if (s > r) {
      const c = t.comparePoint(e.rightSE.point);
      if (c < 0) return 1;
      if (c > 0) return -1;
    }
    if (s !== r) {
      const c = h - o, f = s - n, d = u - l, g = r - i;
      if (c > f && d < g) return 1;
      if (c < f && d > g) return -1;
    }
    return s > r ? 1 : s < r || h < u ? -1 : h > u ? 1 : t.id < e.id ? -1 : t.id > e.id ? 1 : 0;
  }
  /* Warning: a reference to ringWindings input will be stored,
   *  and possibly will be later modified */
  constructor(t, e, n, i) {
    this.id = ++zn, this.leftSE = t, t.segment = this, t.otherSE = e, this.rightSE = e, e.segment = this, e.otherSE = t, this.rings = n, this.windings = i;
  }
  static fromRing(t, e, n) {
    let i, s, r;
    const o = U.comparePoints(t, e);
    if (o < 0)
      i = t, s = e, r = 1;
    else if (o > 0)
      i = e, s = t, r = -1;
    else throw new Error(`Tried to create degenerate segment at [${t.x}, ${t.y}]`);
    const l = new U(i, !0), h = new U(s, !1);
    return new st(l, h, [n], [r]);
  }
  /* When a segment is split, the rightSE is replaced with a new sweep event */
  replaceRightSE(t) {
    this.rightSE = t, this.rightSE.segment = this, this.rightSE.otherSE = this.leftSE, this.leftSE.otherSE = this.rightSE;
  }
  bbox() {
    const t = this.leftSE.point.y, e = this.rightSE.point.y;
    return {
      ll: {
        x: this.leftSE.point.x,
        y: t < e ? t : e
      },
      ur: {
        x: this.rightSE.point.x,
        y: t > e ? t : e
      }
    };
  }
  /* A vector from the left point to the right */
  vector() {
    return {
      x: this.rightSE.point.x - this.leftSE.point.x,
      y: this.rightSE.point.y - this.leftSE.point.y
    };
  }
  isAnEndpoint(t) {
    return t.x === this.leftSE.point.x && t.y === this.leftSE.point.y || t.x === this.rightSE.point.x && t.y === this.rightSE.point.y;
  }
  /* Compare this segment with a point.
   *
   * A point P is considered to be colinear to a segment if there
   * exists a distance D such that if we travel along the segment
   * from one * endpoint towards the other a distance D, we find
   * ourselves at point P.
   *
   * Return value indicates:
   *
   *   1: point lies above the segment (to the left of vertical)
   *   0: point is colinear to segment
   *  -1: point lies below the segment (to the right of vertical)
   */
  comparePoint(t) {
    if (this.isAnEndpoint(t)) return 0;
    const e = this.leftSE.point, n = this.rightSE.point, i = this.vector();
    if (e.x === n.x)
      return t.x === e.x ? 0 : t.x < e.x ? 1 : -1;
    const s = (t.y - e.y) / i.y, r = e.x + s * i.x;
    if (t.x === r) return 0;
    const o = (t.x - e.x) / i.x, l = e.y + o * i.y;
    return t.y === l ? 0 : t.y < l ? -1 : 1;
  }
  /**
   * Given another segment, returns the first non-trivial intersection
   * between the two segments (in terms of sweep line ordering), if it exists.
   *
   * A 'non-trivial' intersection is one that will cause one or both of the
   * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
   *
   *   * endpoint of segA with endpoint of segB --> trivial
   *   * endpoint of segA with point along segB --> non-trivial
   *   * endpoint of segB with point along segA --> non-trivial
   *   * point along segA with point along segB --> non-trivial
   *
   * If no non-trivial intersection exists, return null
   * Else, return null.
   */
  getIntersection(t) {
    const e = this.bbox(), n = t.bbox(), i = oe(e, n);
    if (i === null) return null;
    const s = this.leftSE.point, r = this.rightSE.point, o = t.leftSE.point, l = t.rightSE.point, h = Nt(e, o) && this.comparePoint(o) === 0, u = Nt(n, s) && t.comparePoint(s) === 0, c = Nt(e, l) && this.comparePoint(l) === 0, f = Nt(n, r) && t.comparePoint(r) === 0;
    if (u && h)
      return f && !c ? r : !f && c ? l : null;
    if (u)
      return c && s.x === l.x && s.y === l.y ? null : s;
    if (h)
      return f && r.x === o.x && r.y === o.y ? null : o;
    if (f && c) return null;
    if (f) return r;
    if (c) return l;
    const d = Xn(s, this.vector(), o, t.vector());
    return d === null || !Nt(i, d) ? null : Tt.round(d.x, d.y);
  }
  /**
   * Split the given segment into multiple segments on the given points.
   *  * Each existing segment will retain its leftSE and a new rightSE will be
   *    generated for it.
   *  * A new segment will be generated which will adopt the original segment's
   *    rightSE, and a new leftSE will be generated for it.
   *  * If there are more than two points given to split on, new segments
   *    in the middle will be generated with new leftSE and rightSE's.
   *  * An array of the newly generated SweepEvents will be returned.
   *
   * Warning: input array of points is modified
   */
  split(t) {
    const e = [], n = t.events !== void 0, i = new U(t, !0), s = new U(t, !1), r = this.rightSE;
    this.replaceRightSE(s), e.push(s), e.push(i);
    const o = new st(i, r, this.rings.slice(), this.windings.slice());
    return U.comparePoints(o.leftSE.point, o.rightSE.point) > 0 && o.swapEvents(), U.comparePoints(this.leftSE.point, this.rightSE.point) > 0 && this.swapEvents(), n && (i.checkForConsuming(), s.checkForConsuming()), e;
  }
  /* Swap which event is left and right */
  swapEvents() {
    const t = this.rightSE;
    this.rightSE = this.leftSE, this.leftSE = t, this.leftSE.isLeft = !0, this.rightSE.isLeft = !1;
    for (let e = 0, n = this.windings.length; e < n; e++)
      this.windings[e] *= -1;
  }
  /* Consume another segment. We take their rings under our wing
   * and mark them as consumed. Use for perfectly overlapping segments */
  consume(t) {
    let e = this, n = t;
    for (; e.consumedBy; ) e = e.consumedBy;
    for (; n.consumedBy; ) n = n.consumedBy;
    const i = st.compare(e, n);
    if (i !== 0) {
      if (i > 0) {
        const s = e;
        e = n, n = s;
      }
      if (e.prev === n) {
        const s = e;
        e = n, n = s;
      }
      for (let s = 0, r = n.rings.length; s < r; s++) {
        const o = n.rings[s], l = n.windings[s], h = e.rings.indexOf(o);
        h === -1 ? (e.rings.push(o), e.windings.push(l)) : e.windings[h] += l;
      }
      n.rings = null, n.windings = null, n.consumedBy = e, n.leftSE.consumedBy = e.leftSE, n.rightSE.consumedBy = e.rightSE;
    }
  }
  /* The first segment previous segment chain that is in the result */
  prevInResult() {
    return this._prevInResult !== void 0 ? this._prevInResult : (this.prev ? this.prev.isInResult() ? this._prevInResult = this.prev : this._prevInResult = this.prev.prevInResult() : this._prevInResult = null, this._prevInResult);
  }
  beforeState() {
    if (this._beforeState !== void 0) return this._beforeState;
    if (!this.prev) this._beforeState = {
      rings: [],
      windings: [],
      multiPolys: []
    };
    else {
      const t = this.prev.consumedBy || this.prev;
      this._beforeState = t.afterState();
    }
    return this._beforeState;
  }
  afterState() {
    if (this._afterState !== void 0) return this._afterState;
    const t = this.beforeState();
    this._afterState = {
      rings: t.rings.slice(0),
      windings: t.windings.slice(0),
      multiPolys: []
    };
    const e = this._afterState.rings, n = this._afterState.windings, i = this._afterState.multiPolys;
    for (let o = 0, l = this.rings.length; o < l; o++) {
      const h = this.rings[o], u = this.windings[o], c = e.indexOf(h);
      c === -1 ? (e.push(h), n.push(u)) : n[c] += u;
    }
    const s = [], r = [];
    for (let o = 0, l = e.length; o < l; o++) {
      if (n[o] === 0) continue;
      const h = e[o], u = h.poly;
      if (r.indexOf(u) === -1)
        if (h.isExterior) s.push(u);
        else {
          r.indexOf(u) === -1 && r.push(u);
          const c = s.indexOf(h.poly);
          c !== -1 && s.splice(c, 1);
        }
    }
    for (let o = 0, l = s.length; o < l; o++) {
      const h = s[o].multiPoly;
      i.indexOf(h) === -1 && i.push(h);
    }
    return this._afterState;
  }
  /* Is this segment part of the final result? */
  isInResult() {
    if (this.consumedBy) return !1;
    if (this._isInResult !== void 0) return this._isInResult;
    const t = this.beforeState().multiPolys, e = this.afterState().multiPolys;
    switch (J.type) {
      case "union": {
        const n = t.length === 0, i = e.length === 0;
        this._isInResult = n !== i;
        break;
      }
      case "intersection": {
        let n, i;
        t.length < e.length ? (n = t.length, i = e.length) : (n = e.length, i = t.length), this._isInResult = i === J.numMultiPolys && n < i;
        break;
      }
      case "xor": {
        const n = Math.abs(t.length - e.length);
        this._isInResult = n % 2 === 1;
        break;
      }
      case "difference": {
        const n = (i) => i.length === 1 && i[0].isSubject;
        this._isInResult = n(t) !== n(e);
        break;
      }
      default:
        throw new Error(`Unrecognized operation type found ${J.type}`);
    }
    return this._isInResult;
  }
}
class _e {
  constructor(t, e, n) {
    if (!Array.isArray(t) || t.length === 0)
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    if (this.poly = e, this.isExterior = n, this.segments = [], typeof t[0][0] != "number" || typeof t[0][1] != "number")
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    const i = Tt.round(t[0][0], t[0][1]);
    this.bbox = {
      ll: {
        x: i.x,
        y: i.y
      },
      ur: {
        x: i.x,
        y: i.y
      }
    };
    let s = i;
    for (let r = 1, o = t.length; r < o; r++) {
      if (typeof t[r][0] != "number" || typeof t[r][1] != "number")
        throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
      let l = Tt.round(t[r][0], t[r][1]);
      l.x === s.x && l.y === s.y || (this.segments.push(st.fromRing(s, l, this)), l.x < this.bbox.ll.x && (this.bbox.ll.x = l.x), l.y < this.bbox.ll.y && (this.bbox.ll.y = l.y), l.x > this.bbox.ur.x && (this.bbox.ur.x = l.x), l.y > this.bbox.ur.y && (this.bbox.ur.y = l.y), s = l);
    }
    (i.x !== s.x || i.y !== s.y) && this.segments.push(st.fromRing(s, i, this));
  }
  getSweepEvents() {
    const t = [];
    for (let e = 0, n = this.segments.length; e < n; e++) {
      const i = this.segments[e];
      t.push(i.leftSE), t.push(i.rightSE);
    }
    return t;
  }
}
class Yn {
  constructor(t, e) {
    if (!Array.isArray(t))
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    this.exteriorRing = new _e(t[0], this, !0), this.bbox = {
      ll: {
        x: this.exteriorRing.bbox.ll.x,
        y: this.exteriorRing.bbox.ll.y
      },
      ur: {
        x: this.exteriorRing.bbox.ur.x,
        y: this.exteriorRing.bbox.ur.y
      }
    }, this.interiorRings = [];
    for (let n = 1, i = t.length; n < i; n++) {
      const s = new _e(t[n], this, !1);
      s.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = s.bbox.ll.x), s.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = s.bbox.ll.y), s.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = s.bbox.ur.x), s.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = s.bbox.ur.y), this.interiorRings.push(s);
    }
    this.multiPoly = e;
  }
  getSweepEvents() {
    const t = this.exteriorRing.getSweepEvents();
    for (let e = 0, n = this.interiorRings.length; e < n; e++) {
      const i = this.interiorRings[e].getSweepEvents();
      for (let s = 0, r = i.length; s < r; s++)
        t.push(i[s]);
    }
    return t;
  }
}
class Te {
  constructor(t, e) {
    if (!Array.isArray(t))
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    try {
      typeof t[0][0][0] == "number" && (t = [t]);
    } catch {
    }
    this.polys = [], this.bbox = {
      ll: {
        x: Number.POSITIVE_INFINITY,
        y: Number.POSITIVE_INFINITY
      },
      ur: {
        x: Number.NEGATIVE_INFINITY,
        y: Number.NEGATIVE_INFINITY
      }
    };
    for (let n = 0, i = t.length; n < i; n++) {
      const s = new Yn(t[n], this);
      s.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = s.bbox.ll.x), s.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = s.bbox.ll.y), s.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = s.bbox.ur.x), s.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = s.bbox.ur.y), this.polys.push(s);
    }
    this.isSubject = e;
  }
  getSweepEvents() {
    const t = [];
    for (let e = 0, n = this.polys.length; e < n; e++) {
      const i = this.polys[e].getSweepEvents();
      for (let s = 0, r = i.length; s < r; s++)
        t.push(i[s]);
    }
    return t;
  }
}
class Ct {
  /* Given the segments from the sweep line pass, compute & return a series
   * of closed rings from all the segments marked to be part of the result */
  static factory(t) {
    const e = [];
    for (let n = 0, i = t.length; n < i; n++) {
      const s = t[n];
      if (!s.isInResult() || s.ringOut) continue;
      let r = null, o = s.leftSE, l = s.rightSE;
      const h = [o], u = o.point, c = [];
      for (; r = o, o = l, h.push(o), o.point !== u; )
        for (; ; ) {
          const f = o.getAvailableLinkedEvents();
          if (f.length === 0) {
            const p = h[0].point, x = h[h.length - 1].point;
            throw new Error(`Unable to complete output ring starting at [${p.x}, ${p.y}]. Last matching segment found ends at [${x.x}, ${x.y}].`);
          }
          if (f.length === 1) {
            l = f[0].otherSE;
            break;
          }
          let d = null;
          for (let p = 0, x = c.length; p < x; p++)
            if (c[p].point === o.point) {
              d = p;
              break;
            }
          if (d !== null) {
            const p = c.splice(d)[0], x = h.splice(p.index);
            x.unshift(x[0].otherSE), e.push(new Ct(x.reverse()));
            continue;
          }
          c.push({
            index: h.length,
            point: o.point
          });
          const g = o.getLeftmostComparator(r);
          l = f.sort(g)[0].otherSE;
          break;
        }
      e.push(new Ct(h));
    }
    return e;
  }
  constructor(t) {
    this.events = t;
    for (let e = 0, n = t.length; e < n; e++)
      t[e].segment.ringOut = this;
    this.poly = null;
  }
  getGeom() {
    let t = this.events[0].point;
    const e = [t];
    for (let h = 1, u = this.events.length - 1; h < u; h++) {
      const c = this.events[h].point, f = this.events[h + 1].point;
      Se(c, t, f) !== 0 && (e.push(c), t = c);
    }
    if (e.length === 1) return null;
    const n = e[0], i = e[1];
    Se(n, t, i) === 0 && e.shift(), e.push(e[0]);
    const s = this.isExteriorRing() ? 1 : -1, r = this.isExteriorRing() ? 0 : e.length - 1, o = this.isExteriorRing() ? e.length : -1, l = [];
    for (let h = r; h != o; h += s) l.push([e[h].x, e[h].y]);
    return l;
  }
  isExteriorRing() {
    if (this._isExteriorRing === void 0) {
      const t = this.enclosingRing();
      this._isExteriorRing = t ? !t.isExteriorRing() : !0;
    }
    return this._isExteriorRing;
  }
  enclosingRing() {
    return this._enclosingRing === void 0 && (this._enclosingRing = this._calcEnclosingRing()), this._enclosingRing;
  }
  /* Returns the ring that encloses this one, if any */
  _calcEnclosingRing() {
    let t = this.events[0];
    for (let i = 1, s = this.events.length; i < s; i++) {
      const r = this.events[i];
      U.compare(t, r) > 0 && (t = r);
    }
    let e = t.segment.prevInResult(), n = e ? e.prevInResult() : null;
    for (; ; ) {
      if (!e) return null;
      if (!n) return e.ringOut;
      if (n.ringOut !== e.ringOut)
        return n.ringOut.enclosingRing() !== e.ringOut ? e.ringOut : e.ringOut.enclosingRing();
      e = n.prevInResult(), n = e ? e.prevInResult() : null;
    }
  }
}
class Re {
  constructor(t) {
    this.exteriorRing = t, t.poly = this, this.interiorRings = [];
  }
  addInterior(t) {
    this.interiorRings.push(t), t.poly = this;
  }
  getGeom() {
    const t = [this.exteriorRing.getGeom()];
    if (t[0] === null) return null;
    for (let e = 0, n = this.interiorRings.length; e < n; e++) {
      const i = this.interiorRings[e].getGeom();
      i !== null && t.push(i);
    }
    return t;
  }
}
class Wn {
  constructor(t) {
    this.rings = t, this.polys = this._composePolys(t);
  }
  getGeom() {
    const t = [];
    for (let e = 0, n = this.polys.length; e < n; e++) {
      const i = this.polys[e].getGeom();
      i !== null && t.push(i);
    }
    return t;
  }
  _composePolys(t) {
    const e = [];
    for (let n = 0, i = t.length; n < i; n++) {
      const s = t[n];
      if (!s.poly)
        if (s.isExteriorRing()) e.push(new Re(s));
        else {
          const r = s.enclosingRing();
          r.poly || e.push(new Re(r)), r.poly.addInterior(s);
        }
    }
    return e;
  }
}
class qn {
  constructor(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : st.compare;
    this.queue = t, this.tree = new pe(e), this.segments = [];
  }
  process(t) {
    const e = t.segment, n = [];
    if (t.consumedBy)
      return t.isLeft ? this.queue.remove(t.otherSE) : this.tree.remove(e), n;
    const i = t.isLeft ? this.tree.add(e) : this.tree.find(e);
    if (!i) throw new Error(`Unable to find segment #${e.id} [${e.leftSE.point.x}, ${e.leftSE.point.y}] -> [${e.rightSE.point.x}, ${e.rightSE.point.y}] in SweepLine tree.`);
    let s = i, r = i, o, l;
    for (; o === void 0; )
      s = this.tree.prev(s), s === null ? o = null : s.key.consumedBy === void 0 && (o = s.key);
    for (; l === void 0; )
      r = this.tree.next(r), r === null ? l = null : r.key.consumedBy === void 0 && (l = r.key);
    if (t.isLeft) {
      let h = null;
      if (o) {
        const c = o.getIntersection(e);
        if (c !== null && (e.isAnEndpoint(c) || (h = c), !o.isAnEndpoint(c))) {
          const f = this._splitSafely(o, c);
          for (let d = 0, g = f.length; d < g; d++)
            n.push(f[d]);
        }
      }
      let u = null;
      if (l) {
        const c = l.getIntersection(e);
        if (c !== null && (e.isAnEndpoint(c) || (u = c), !l.isAnEndpoint(c))) {
          const f = this._splitSafely(l, c);
          for (let d = 0, g = f.length; d < g; d++)
            n.push(f[d]);
        }
      }
      if (h !== null || u !== null) {
        let c = null;
        h === null ? c = u : u === null ? c = h : c = U.comparePoints(h, u) <= 0 ? h : u, this.queue.remove(e.rightSE), n.push(e.rightSE);
        const f = e.split(c);
        for (let d = 0, g = f.length; d < g; d++)
          n.push(f[d]);
      }
      n.length > 0 ? (this.tree.remove(e), n.push(t)) : (this.segments.push(e), e.prev = o);
    } else {
      if (o && l) {
        const h = o.getIntersection(l);
        if (h !== null) {
          if (!o.isAnEndpoint(h)) {
            const u = this._splitSafely(o, h);
            for (let c = 0, f = u.length; c < f; c++)
              n.push(u[c]);
          }
          if (!l.isAnEndpoint(h)) {
            const u = this._splitSafely(l, h);
            for (let c = 0, f = u.length; c < f; c++)
              n.push(u[c]);
          }
        }
      }
      this.tree.remove(e);
    }
    return n;
  }
  /* Safely split a segment that is currently in the datastructures
   * IE - a segment other than the one that is currently being processed. */
  _splitSafely(t, e) {
    this.tree.remove(t);
    const n = t.rightSE;
    this.queue.remove(n);
    const i = t.split(e);
    return i.push(n), t.consumedBy === void 0 && this.tree.add(t), i;
  }
}
const Le = typeof process < "u" && process.env.POLYGON_CLIPPING_MAX_QUEUE_SIZE || 1e6, Un = typeof process < "u" && process.env.POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS || 1e6;
class Dn {
  run(t, e, n) {
    J.type = t, Tt.reset();
    const i = [new Te(e, !0)];
    for (let c = 0, f = n.length; c < f; c++)
      i.push(new Te(n[c], !1));
    if (J.numMultiPolys = i.length, J.type === "difference") {
      const c = i[0];
      let f = 1;
      for (; f < i.length; )
        oe(i[f].bbox, c.bbox) !== null ? f++ : i.splice(f, 1);
    }
    if (J.type === "intersection")
      for (let c = 0, f = i.length; c < f; c++) {
        const d = i[c];
        for (let g = c + 1, p = i.length; g < p; g++)
          if (oe(d.bbox, i[g].bbox) === null) return [];
      }
    const s = new pe(U.compare);
    for (let c = 0, f = i.length; c < f; c++) {
      const d = i[c].getSweepEvents();
      for (let g = 0, p = d.length; g < p; g++)
        if (s.insert(d[g]), s.size > Le)
          throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big).");
    }
    const r = new qn(s);
    let o = s.size, l = s.pop();
    for (; l; ) {
      const c = l.key;
      if (s.size === o) {
        const d = c.segment;
        throw new Error(`Unable to pop() ${c.isLeft ? "left" : "right"} SweepEvent [${c.point.x}, ${c.point.y}] from segment #${d.id} [${d.leftSE.point.x}, ${d.leftSE.point.y}] -> [${d.rightSE.point.x}, ${d.rightSE.point.y}] from queue.`);
      }
      if (s.size > Le)
        throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big).");
      if (r.segments.length > Un)
        throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments).");
      const f = r.process(c);
      for (let d = 0, g = f.length; d < g; d++) {
        const p = f[d];
        p.consumedBy === void 0 && s.insert(p);
      }
      o = s.size, l = s.pop();
    }
    Tt.reset();
    const h = Ct.factory(r.segments);
    return new Wn(h).getGeom();
  }
}
const J = new Dn(), Jn = function(a) {
  for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    e[n - 1] = arguments[n];
  return J.run("union", a, e);
}, Qn = function(a) {
  for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    e[n - 1] = arguments[n];
  return J.run("intersection", a, e);
}, Vn = function(a) {
  for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    e[n - 1] = arguments[n];
  return J.run("xor", a, e);
}, Kn = function(a) {
  for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    e[n - 1] = arguments[n];
  return J.run("difference", a, e);
};
var Hn = {
  union: Jn,
  intersection: Qn,
  xor: Vn,
  difference: Kn
};
function zt(a, t, e = 8, n, i) {
  const s = de(n || a, i || a), r = 2 / e * Math.PI;
  return new Array(e + 1).fill(0).map((l, h) => {
    const u = (s + r * (h + 1)) % (2 * Math.PI);
    return Ue(a, u, t);
  });
}
const re = (a, t, e = 8) => {
  const n = a.map((s, r) => zt(s, t, e, s, a[r + 1])), i = a.slice(0, -1).map((s, r) => Ke(s, a[r + 1] || s, t));
  return He(...i, ...n)[0][0];
};
function ae(a, t, e = 8) {
  const n = Fe(a), s = le(n).map((r, o, l) => {
    const h = l[o - 1 < 0 ? l.length - 1 : o - 1], u = l[(o + 1) % l.length];
    return zt(r, t, e, h, u);
  });
  return le(Fe(s));
}
function Fe(a) {
  const t = [];
  for (const e of a)
    if (Array.isArray(e[0]))
      if (Array.isArray(e[0][0]))
        for (const n of e)
          t.push(...n);
      else
        t.push(...e);
    else
      t.push(e);
  return t;
}
function le(a) {
  const t = a.slice();
  return t.sort(tn), Ze(t);
}
function Ke(a, t, e) {
  const n = de(a, t), i = (n + Math.PI / 2) % (2 * Math.PI), s = (n - Math.PI / 2) % (2 * Math.PI), r = [
    [
      // Top Left
      a[0] + e * Math.cos(i),
      a[1] + e * Math.sin(i)
    ],
    [
      // Top Right
      t[0] + e * Math.cos(i),
      t[1] + e * Math.sin(i)
    ],
    [
      // Bottom Right
      t[0] + e * Math.cos(s),
      t[1] + e * Math.sin(s)
    ],
    [
      // Bottom Left
      a[0] + e * Math.cos(s),
      a[1] + e * Math.sin(s)
    ]
  ];
  return [...r, r[0]];
}
function He(...a) {
  const e = a.map(
    (s) => [[s.map((r) => [
      Math.round(r[0] * 1e6),
      Math.round(r[1] * 1e6)
    ])]]
  ), n = e.shift();
  return n ? Hn.union(n, ...e).map((s) => s.map((r) => r.map((o) => [o[0] / 1e6, o[1] / 1e6]))) : [[[]]];
}
function Ze(a) {
  if (a.length <= 1)
    return a.slice();
  let t = [];
  for (const [n, i] of a) {
    for (; t.length >= 2; ) {
      const [s, r] = t[t.length - 1], [o, l] = t[t.length - 2];
      if ((s - o) * (i - l) >= (r - l) * (n - o))
        t.pop();
      else
        break;
    }
    t.push([n, i]);
  }
  t.pop();
  let e = [];
  for (let n = a.length - 1; n >= 0; n--) {
    const [i, s] = a[n];
    for (; e.length >= 2; ) {
      const [r, o] = e[e.length - 1], [l, h] = e[e.length - 2];
      if ((r - l) * (s - h) >= (o - h) * (i - l))
        e.pop();
      else
        break;
    }
    e.push([i, s]);
  }
  return e.pop(), t.length === 1 && e.length === 1 && t[0][0] === e[0][0] && t[0][1] === e[0][1] ? t : [...t, ...e];
}
function tn([a, t], [e, n]) {
  return a < e ? -1 : a > e ? 1 : t < n ? -1 : t > n ? 1 : 0;
}
const oi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bufferLine: re,
  bufferPoint: zt,
  bufferPolygonHull: ae,
  convexHull: le,
  lineToPoly: Ke,
  makeHullPresorted: Ze,
  mergePolygons: He,
  pointComparator: tn
}, Symbol.toStringTag, { value: "Module" }));
class ri extends B {
  buffer(t, e = 8) {
    const i = [...this._features.values()].map((s) => {
      if (["Point", "MultiPoint", "LineString", "MultiLineString", "Polygon", "MultiPolygon"].includes(s.geometry.type))
        throw new Error("Unknown geometry type: " + s.geometry.type);
      const r = B.projectWGS84toWebMercator(s.geometry.coordinates, s.geometry.type);
      let o;
      switch (s.geometry.type) {
        case "Point":
          o = zt(r, t, e);
          break;
        case "MultiPoint":
        case "LineString":
          o = re(r, t, e);
          break;
        case "MultiLineString":
          o = r.map((h) => re(h, t, e));
          break;
        case "Polygon":
          o = ae(r, t, e);
          break;
        case "MultiPolygon":
          o = ae(
            r.map((h) => h.filter((u) => Xt(u))),
            t,
            e
          );
          break;
        default:
          throw new Error("Unknown geometry type: " + s.geometry.type);
      }
      return B.projectWebMercatorToWGS84(o, s.geometry.type);
    }).map((s) => B.feature(B.polygonize(s), {}));
    return B.collection(i);
  }
}
function ai(a) {
  let t = 0;
  for (let e = 0; e < a.length; e++) {
    const n = a.charCodeAt(e);
    t = (t << 5) - t + n, t |= 0;
  }
  return Uint32Array.from([t])[0].toString(36);
}
function li(a) {
  const t = Array.from({ length: a }, (e, n) => n);
  for (let e = t.length - 1; e > 0; e--) {
    const n = Math.floor(Math.random() * (e + 1));
    [t[e], t[n]] = [t[n], t[e]];
  }
  return t;
}
function en(a, t, e) {
  const [n, i] = t[0] < e[0] ? [t[0], e[0]] : [e[0], t[0]], [s, r] = t[1] < e[1] ? [t[1], e[1]] : [e[1], t[1]];
  return a[0] >= n && a[0] <= i && a[1] >= s && a[1] <= r;
}
function nn(a, t, e = 0) {
  const n = (r, o, l) => {
    let h = o.map(
      (c, f) => sn(
        new C(...o[f === 0 ? f : f - 1], "4326").xyArray,
        new C(...c, "4326").xyArray,
        new C(...r, "4326").xyArray,
        l.concat([f - 1, f])
      )
    );
    if (h.filter((c) => c.intersectsSegment).length === 0) {
      const c = o.map((f, d) => ({
        intersectsSegment: !0,
        distanceFromLine: 0,
        distanceFromPoint: mt(new C(...r, "4326").lngLatPosition, new C(...f, "4326").lngLatPosition),
        intersectionPoint: new C(...f, "4326").lngLatPosition,
        intersectionPointWGS84: f,
        pointLocation: l.concat([d, d])
      })).reduce((f, d) => (f.distanceFromPoint || f.distanceFromLine) < (d.distanceFromPoint || d.distanceFromLine) ? f : d, {});
      h.push(c);
    }
    return h.filter((c) => c.intersectsSegment).reduce((c, f) => (c.distanceFromPoint || c.distanceFromLine) < (f.distanceFromPoint || f.distanceFromLine) ? c : f, {});
  }, i = (r) => r.filter((o) => o).reduce((o, l) => (o.distanceFromPoint || o.distanceFromLine) < (l.distanceFromPoint || l.distanceFromLine) ? o : l, {}), s = {
    Point: (r, o) => s.MultiPoint(r, [o]),
    MultiPoint: (r, o) => i(o.map((l) => ({
      distanceFromLine: mt(new C(...l, "4326").lngLatPosition, new C(...r, "4326").lngLatPosition),
      intersectionPoint: l
    }))),
    LineString: (r, o) => s.MultiPolygon(r, [[o]]),
    MultiLineString: (r, o) => s.Polygon(r, o),
    Polygon: (r, o) => s.MultiPolygon(r, [o]),
    MultiPolygon: (r, o) => i(o.map(
      (l, h) => i(l.map((u, c) => n(r, u, [e, h, c])))
    ))
  };
  if (!s.hasOwnProperty(t.type)) throw new Error('Geometry type "' + t.type + '" not supported');
  return s[t.type](a, t.coordinates);
}
function Zn(a, t, e = 0) {
  let n;
  if (e) {
    let r = new C(...a, "4326").lngLatPosition;
    r[0] = Math.floor(r[0] / e) * e, r[1] = Math.floor(r[1] / e) * e, n = new C(...r, "3857").lngLatPosition;
  } else
    n = a;
  return t.map((r, o) => nn(n, r.geometry, o)).reduce((r, o) => (r.distanceFromPoint || r.distanceFromLine) < (o.distanceFromPoint || o.distanceFromLine) ? r : o, {});
}
function sn(a, t, e, n) {
  const i = (t[1] - a[1]) / (t[0] - a[0]), s = a[1] - i * a[0], r = -(1 / i), o = e[1] - r * e[0], l = (s - o) / (r - i), h = r * l + o, u = [l, h], c = mt(e, u);
  return {
    intersectsSegment: en(e, a, t),
    distanceFromLine: c,
    distanceFromPoint: 0,
    intersectionPoint: u,
    intersectionPointWGS84: new C(...u, "3857").lngLatPosition,
    pointLocation: n
  };
}
const hi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  pointBetween: sn,
  pointInBbox: en,
  pointInFeatures: Zn,
  pointOnPath: nn
}, Symbol.toStringTag, { value: "Module" }));
export {
  K as BoundingBox,
  B as FeatureList,
  ri as FeatureListBuffer,
  xe as FeatureListRouteable,
  te as NodeGraph,
  ft as TileCoord,
  V as WGS84ToWebMercator,
  Gt as WebMercatorToWGS84,
  C as XYCoord,
  oi as buffer,
  zt as bufferPoint,
  H as earthCircumference,
  mt as euclidean,
  si as geometry,
  ai as hash,
  hn as haversine,
  Xt as isCounterClockwise,
  ei as metersToPixels,
  ti as pixelsToMeters,
  hi as pointCalculations,
  ke as pointInPolygon,
  Oe as pointInRing,
  ni as rewindRings,
  mn as segmentizeLine,
  li as shuffle,
  ii as tileMath,
  bt as vincenty,
  ln as wrapLine,
  an as wrapToPeer
};
